import { Role, CLIENT_NAME } from "@/helper/Role";
import { authenticationService } from "@/services/AuthenticationService";
console.log({ CLIENT_NAME });

const cloudNavItems = [
  {
    name: "Home",
    url: "/home",
    icon: "icon-home",
    show: true,
    isCollapsed: false,
    children: [
      {
        name: "Home",
        url: "/home/homepage",
        icon: "icon-arrow-right",

        description: "home_page_msg",
        show: true,
        // action: "read",
        // resource: "",
      },
      // {
      //   name: 'Setup',
      //   url: '/setup/welcome',
      //   icon: 'icon-arrow-right'
      // },
    ],
  },

  /**
   * USER MANAGEMENT START
   */

  {
    id: 1,
    name: "user_management",
    url: "/user-management",
    icon: "icon-master",
    permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
    isCollapsed: false,
    children: [
      {
        name: "user",
        url: "/user-management/users",
        icon: "icon-arrow-right",
        description: "user_dash_msg",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 1,
        action: "read",
        resource: "Users",
      },
      {
        name: "Aggregator User",
        url: "/user-management/aggregator-users",
        icon: "icon-arrow-right",
        description: "aggregatoruser_dash_msg",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 2,
        action: "read",
        resource: "Aggregator User",
      },
      {
        name: "Roles",
        url: "/user-management/roles-list",
        icon: "icon-arrow-right",
        description: "role_dash_msg",
        permissions: [Role.SuperAdmin],
        module_id: 3,
        action: "read",
        resource: "Roles",
      },
      {
        name: "designation",
        url: "/user-management/designations",
        icon: "icon-arrow-right",
        description: "designation_dash_msg",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 4,
        action: "read",
        resource: "Designations",
      },
      {
        name: "department",
        url: "/user-management/list-department",
        icon: "icon-arrow-right",
        description: "department_msg",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 5,
        action: "read",
        resource: "Department",
      },
      {
        name: "gender",
        url: "/user-management/genders",
        icon: "icon-arrow-right",
        description: "gender_dash_msg",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 6,
        action: "read",
        resource: "Gender",
      },
      {
        name: "martialstatus",
        url: "/user-management/marital-status",
        icon: "icon-arrow-right",
        description: "marital_dash_msg",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 7,
        action: "read",
        resource: "Marital Status",
      },
      {
        name: "userAuditLog",
        url: "/user-management/user-audit-log",
        icon: "icon-arrow-right",
        description: "userAuditLog_dash_msg",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 9,
        action: "read",
        resource: "User Audit Log",
      },
      {
        name: "App Report Users",
        url: "/user-management/app-report-users",
        icon: "icon-arrow-right",
        description: "App Report Users",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 298,
        action: "read",
        resource: "App Report Users",
      },
      {
        id: 1,
        name: "shifts",
        url: "",
        icon: "icon-arrow-right",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        isCollapsed: false,
        // action: "read",
        // resource: "Shifts",
        children: [
          {
            name: "shifts",
            url: "/cinema-manager/shifts",
            icon: "icon-arrow-right",
            description: "shift_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 11,
            action: "read",
            resource: "Shifts",
          },
          {
            name: "User Shifts",
            url: "/cinema-manager/user-shifts",
            icon: "icon-arrow-right",
            description: "user_shift_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 13,
            action: "read",
            resource: "User Shift",
          },
          {
            name: "Shift Close",
            url: "/cinema-manager/shifts-close",
            icon: "icon-arrow-right",
            description: "shiftclose_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 24,
            action: "read",
            resource: "Shifts",
          },
        ],
      },
    ],
  },

  /**
   * USER MANAGEMENT END
   */

  /**
   * Exhibitor MANAGEMENT START
   */

  {
    id: 2,
    name: "exhibitor_management",
    url: "/exhibitor-management",
    icon: "icon-cinema-management",
    permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
    isCollapsed: false,
    children: [
      // {
      //   name: "aggregator_user",
      //   url: "/user-management/aggregator-users",
      //   icon: "icon-arrow-right",
      //   description: "aggregatoruser_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
      //   module_id: 2,
      // },
      // {
      //   name: "Aggregators",
      //   url: "/cinema-manager/aggregators",
      //   icon: "icon-arrow-right",
      //   description: "checklists_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 143,
      //   action: "read",
      //   resource: "Checklists",
      // },
      {
        name: "View Rate Card Group",
        url: "/cinema-manager/view-rate-card-group",
        icon: "icon-arrow-right",
        description: "checklists_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 166,
        action: "read",
        resource: "Checklists",
      },
      {
        name: "Access Rights For Schedule",
        url: "/cinema-manager/access-rights-for-schedule",
        icon: "icon-arrow-right",
        description: "schedule_access_msg",
        keywords: ["access", "rights"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 12,
        action: "read",
        resource: "Access Rights For Schedule",
      },
      {
        name: "salesChannelForFoodAndBeverages",
        url: "/cinema-manager/access-rights-for-fnb",
        icon: "icon-arrow-right",
        keywords: ["access", "rights"],
        description: "fnb_access_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 186,
        action: "read",
        resource: "Access Rights For FnB",
      },
      {
        name: "scheduleList",
        url: "/cinema-manager/schedule-comments",
        icon: "icon-arrow-right",
        description: "schedule_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 141,
        action: "read",
        resource: "Schedule",
      },
      {
        name: "movie",
        url: "/cinema-manager/movies",
        icon: "icon-arrow-right",
        description: "movie_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 14,
        action: "read",
        resource: "Movies",
      },
      {
        name: "Movie Rate Card",
        url: "/cinema-manager/movie-rate-card",
        icon: "icon-arrow-right",
        description: "manageMovieRateCardHere",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 197,
        action: "read",
        resource: "Movie Rate Card",
      },
      {
        name: "Cinema Settings",
        url: "/cinema-manager/cinema-settings",
        icon: "icon-arrow-right",
        description: "cinemasettings_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 15,
        action: "read",
        resource: "Cinema Settings",
      },
      {
        name: "cinemas",
        url: "/cinema-manager/cinemas",
        icon: "icon-arrow-right",
        description: "cinema_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 16,
        action: "read",
        resource: "Cinemas",
      },
      {
        name: "Cinema FnB App Qrcodes",
        url: "/cinema-manager/cinema-fnb-app-qrcode",
        icon: "icon-arrow-right",
        description: "cinema_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 259,
        action: "read",
        resource: "Cinema FnB App Qrcodes",
      },
      {
        name: "screen",
        url: "/cinema-manager/screens",
        icon: "icon-arrow-right",
        description: "screen_dash_msg",
        keywords: ["auditorium", "hall"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 17,
        action: "read",
        resource: "Screens",
      },
      {
        name: "screentype",
        url: "/cinema-manager/screen-type",
        icon: "icon-arrow-right",
        keywords: ["auditorium", "hall"],
        description: "screentype_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 171,
        action: "read",
        resource: "Screen Type",
      },
      {
        name: "screensizeformat",
        url: "/cinema-manager/screen-size-format",
        icon: "icon-arrow-right",
        keywords: ["auditorium", "hall"],
        description: "screensize_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 172,
        action: "read",
        resource: "Screen Size Format",
      },
      {
        name: "seatLayout",
        url: "/cinema-manager/seat-layout",
        icon: "icon-arrow-right",
        description: "seatlayout_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 18,
        action: "read",
        resource: "Seat Layout",
      },
      {
        name: "Manage Broken Seats",
        url: "/cinema-manager/manage-broken-seat",
        icon: "icon-arrow-right",
        description: "seatlayout_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 329,
        action: "read",
        resource: "Manage Broken Seats",
      },
      {
        id: 2,
        name: "ticketPricing",
        url: "",
        icon: "icon-arrow-right",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        isCollapsed: false,
        children: [
          {
            name: "Tax Settings",
            url: "/cinema-manager/tax-settings",
            icon: "icon-arrow-right",
            description: "chargesettings_dash_msg",
            keywords: ["GST", "gst", "VAT", "vat", "price", "Tax", "tax"],
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 19,
            action: "read",
            resource: "Charge Settings",
          },
          {
            name: "privateRateCardGroup",
            url: "/cinema-manager/list-private-rate-card",
            icon: "icon-arrow-right",
            description: "ratecardgroup_dash_msg",
            keywords: ["Private", "rate", "Card", "Group"],
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 188,
            action: "read",
            resource: "Private Rate Card",
          },
          {
            name: "Movie Addon Charges",
            url: "/cinema-manager/addon_charges",
            icon: "icon-arrow-right",
            description: "Addon_charges_dash_msg",
            keywords: ["Addon", "charges", "taxes", "custom"],
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 233,
            action: "read",
            resource: "Movie Addon Charges",
          },
          {
            name: "Tax Types",
            url: "/master/tax-types",
            icon: "icon-arrow-right",
            description: "chargetypes_dash_msg",
            keywords: ["GST", "gst", "VAT", "vat", "Tax", "tax"],
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 45,
            action: "read",
            resource: "Charge Types",
          },
        ],
      },
      {
        name: "manualBillingCategories",
        url: "/cinema-manager/billing-categories",
        icon: "icon-arrow-right",
        description: "mbCAtegories_dash_msg",
        keywords: ["categories", "manual bill", "billings", "bill"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 270,
        only_visible_on: [
          {
            key_name: CLIENT_NAME.QFX,
          },
          {
            key_name: CLIENT_NAME.EPIX,
          },
          {
            key_name: CLIENT_NAME.EMPIRE,
          },
        ],
        action: "read",
        resource: "Manual Bill Categories",
      },
      {
        name: "manualBillingItems",
        url: "/cinema-manager/billing-items",
        icon: "icon-arrow-right",
        description: "mbItems_dash_msg",
        keywords: ["items", "manual bill", "billings", "bill", "manual items"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 269,
        only_visible_on: [
          {
            key_name: CLIENT_NAME.QFX,
          },
          {
            key_name: CLIENT_NAME.EPIX,
          },
          {
            key_name: CLIENT_NAME.EMPIRE,
          },
        ],
        action: "read",
        resource: "Manual Bill Items",
      },
      {
        name: "schedule",
        url: "/cinema-manager/view-schedule",
        icon: "icon-arrow-right",
        description: "view_schedule_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 21,
        action: "read",
        resource: "Schedule",
      },
      {
        name: "schedulebeta",
        url: "/cinema-manager/view-schedule-beta",
        icon: "icon-arrow-right",
        description: "view_schedule_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 21,
        action: "read",
        resource: "Schedule",
      },
      {
        name: "Schedule Overview",
        url: "/cinema-manager/view-schedule-overview",
        icon: "icon-arrow-right",
        description: "view_schedule_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 21,
        action: "read",
        resource: "Schedule",
      },
      {
        name: "Scheduled Movies Order",
        url: "/cinema-manager/scheduled-movies-order",
        icon: "icon-arrow-right",
        description: "Scheduled Movies Order",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 21,
        action: "read",
        resource: "Schedule",
      },
      {
        name: "Reserved Seats",
        url: "/cinema-manager/reserve-seats",
        icon: "icon-arrow-right",
        description: "reserveseats_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 22,
        action: "read",
        resource: "Reserve Seats",
      },
      {
        name: "Back Office Booking",
        url: "/cinema-manager/past-booking",
        icon: "icon-arrow-right",
        description: "reserveseats_dash_msg",
        keywords: [
          "back",
          "back office",
          "bookings",
          "past",
          "Past Bookings",
          "Back Office Booking",
          "Book",
        ],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 196,
        action: "read",
        resource: "Back Office Booking",
      },

      {
        name: "floatAmount",
        url: "/cinema-manager/float-amount",
        icon: "icon-arrow-right",
        description: "floatamount_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 23,
        action: "read",
        resource: "Float Amount",
      },
      {
        name: "makeARefund",
        url: "/cinema-manager/make-a-refund",
        icon: "icon-arrow-right",
        description: "makearefund_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.OnlineSupport],
        module_id: 25,
        action: "read",
        resource: "Make A Refund",
      },

      // {
      //   name: "Payment Gateway Refund",
      //   url: "/cinema-manager/payment-gateway-refund",
      //   icon: "icon-arrow-right",
      //   description: "Payment Gateway Refund",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.OnlineSupport],
      //   keywords: ["refund", "payment", "gateway"],
      //   module_id: 25,
      //   action: "read",
      //   resource: "Make A Refund",
      //   only_available_on: [
      //     ...Object.keys(CLIENT_NAME)
      //       .map((x) => CLIENT_NAME[x])
      //       .filter((x) => x !== CLIENT_NAME.EMPIRE)
      //       .filter((x) => x !== CLIENT_NAME.QFX)
      //       .filter((x) => x !== CLIENT_NAME.STAR)
      //       .filter((x) => x !== CLIENT_NAME.CINEPOLIS_OMAN)
      //       .filter((x) => x !== CLIENT_NAME.CINEPOLIS_KSA)
      //       .filter((x) => x !== CLIENT_NAME.EPIX)
      //       .map((x) => {
      //         return {
      //           key_name: x,
      //           url: "/reports/show-reservations",
      //         };
      //       }),

      //     {
      //       key_name: CLIENT_NAME.EMPIRE,
      //       url: "/cinema-manager/payment-gateway-refund",
      //     },
      //     {
      //       key_name: CLIENT_NAME.QFX,
      //       url: "/cinema-manager/payment-gateway-refund",
      //     },
      //     {
      //       key_name: CLIENT_NAME.STAR,
      //       url: "/cinema-manager/star-payment-gateway-refund",
      //     },
      //     {
      //       key_name: CLIENT_NAME.CINEPOLIS_OMAN,
      //       url: "/cinema-manager/cinepolis-payment-gateway-refund",
      //     },
      //     {
      //       key_name: CLIENT_NAME.CINEPOLIS_KSA,
      //       url: "/cinema-manager/cinepolis-payment-gateway-refund",
      //     },
      //     {
      //       key_name: CLIENT_NAME.EPIX,
      //       url: "/cinema-manager/epix-payment-gateway-refund",
      //     },
      //     {
      //       key_name: CLIENT_NAME.WOW,
      //       url: "/cinema-manager/star-payment-gateway-refund",
      //     },
      //   ],
      // },
      {
        name: "showrefund",
        url: "/cinema-manager/show-refund",
        icon: "icon-arrow-right",
        description: "showrefund_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.OnlineSupport],
        module_id: 26,
        action: "read",
        resource: "Show Refund",
      },
      // {
      //   name: "hardwareSettings",
      //   url: "/cinema-manager/hardware-settings",
      //   icon: "icon-arrow-right",
      //   description: "hardwaresettings_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 31,
      //   action: "read",
      //   resource: "Hardware Settings",
      // },
      {
        name: "Ticket Type",
        url: "/master/ticket-type",
        icon: "icon-arrow-right",
        description: "ticket_type_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 165,
        action: "read",
        resource: "Ticket Type",
      },

      {
        name: "Audit Logs",
        url: "/cinema-manager/fnb-audit-logs",
        icon: "icon-arrow-right",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        isCollapsed: false,
        children: [
          // {
          //   name: "Fnb Audit Logs",
          //   url: "/cinema-manager/fnb-audit-logs",
          //   icon: "icon-arrow-right",
          //   description: "fnbauditlogs_dash_msg",
          //   permissions: [
          //     Role.SuperAdmin,
          //     Role.HoManager,
          //     Role.CinemaManager,
          //   ],
          //   module_id: 147,
          //   action: "read",
          //   resource: "F&B Audit Log",
          // },
          // {
          //   name: "scheduleauditlogs",
          //   url: "/cinema-manager/schedule-audit-logs",
          //   icon: "icon-arrow-right",
          //   description: "scheduleauditlogs_dash_msg",
          //   permissions: [
          //     Role.SuperAdmin,
          //     Role.HoManager,
          //     Role.CinemaManager,
          //   ],
          //   module_id: 148,
          //   action: "read",
          //   resource: "Schedule Audit Log",
          // },
          // {
          //   name: "systemLogs",
          //   url: "/cinema-manager/system-logs",
          //   icon: "icon-arrow-right",
          //   description: "systemLogs_dash_msg",
          //   permissions: [
          //     Role.SuperAdmin,
          //     Role.HoManager,
          //     Role.CinemaManager,
          //   ],
          //   module_id: 173,
          //   action: "read",
          //   resource: "System Logs",
          // },
        ],
      },

      // {
      //   name: "fnbDynamicPricing",
      //   url: "/cinema-manager/fnb-dynamic-pricing",
      //   icon: "icon-arrow-right",
      //   keywords: ["price", "food", "beverages", "dynamic", "pricing"],
      //   description: "fnbDynamicPricing_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 158,
      //   action: "read",
      //   resource: "F&B Dynamic Pricing",
      // },
    ],
  },

  /**
   * DISTRIBUTORS START
   */
  {
    id: 3,
    name: "distributor",
    url: "/distributor",
    icon: "icon-distributor",
    permissions: [
      Role.SuperAdmin,
      Role.CinemaManager,
      Role.HoManager,
      Role.Distributor,
    ],
    isCollapsed: false,
    children: [
      {
        name: "distributor",
        url: "/distributor/distributors",
        icon: "icon-arrow-right",
        description: "distributor_dash_msg",
        permissions: [
          Role.SuperAdmin,
          Role.HoManager,
          Role.CinemaManager,
          Role.Distributor,
        ],
        module_id: 40,
        action: "read",
        resource: "Distributors",
      },
      {
        name: "shareType",
        url: "/distributor/distributor-share-type",
        icon: "icon-arrow-right",
        description: "sharetype_dash_msg",
        permissions: [
          Role.SuperAdmin,
          Role.HoManager,
          Role.CinemaManager,
          Role.Distributor,
        ],
        module_id: 37,
        action: "read",
        resource: "Share Type",
      },
      {
        name: "contract",
        url: "/distributor/contract",
        icon: "icon-arrow-right",
        description: "contract_dash_msg",
        permissions: [
          Role.SuperAdmin,
          Role.HoManager,
          Role.CinemaManager,
          Role.Distributor,
        ],
        module_id: 39,
        action: "read",
        resource: "Contract",
      },
      {
        name: "weekwiseContract",
        url: "/distributor/weekwise-contract",
        icon: "icon-arrow-right",
        description: "weekwiseContract_dash_msg",
        permissions: [
          Role.SuperAdmin,
          Role.HoManager,
          Role.CinemaManager,
          Role.Distributor,
        ],
        module_id: 146,
        action: "read",
        resource: "Weekwise Contract",
      },
      {
        name: "distributorContract",
        url: "/distributor/distributor-contract",
        icon: "icon-arrow-right",
        description: "distributorContract_dash_msg",
        permissions: [
          Role.SuperAdmin,
          Role.HoManager,
          Role.CinemaManager,
          Role.Distributor,
        ],
        module_id: 145,
        action: "read",
        resource: "Distributor Contract",
      },
      // {
      //   name: "Distributor Deduction",
      //   url: "/distributor/distributor-deduction",
      //   icon: "icon-arrow-right",
      //   description: "distributorContract_dash_msg",
      //   permissions: [
      //     Role.SuperAdmin,
      //     Role.HoManager,
      //     Role.CinemaManager,
      //     Role.Distributor,
      //   ],
      //   module_id: 38,
      //   action: "read",
      //   resource: "Distributor Deduction",
      // },
    ],
  },
  {
    id: 4,
    name: "master",
    url: "/master",
    icon: "icon-suitcase",
    permissions: [Role.SuperAdmin, Role.HoManager],
    isCollapsed: false,
    children: [
      // {
      //   name: "imageGallery",
      //   url: "/master/image-gallery",
      //   icon: "icon-arrow-right",
      //   description: "imagegallery_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 175,
      //   action: "read",
      //   resource: "Image Gallery",
      // },
      {
        name: "Tax Types",
        url: "/master/tax-types",
        icon: "icon-arrow-right",
        description: "chargetypes_dash_msg",
        keywords: ["GST", "gst", "VAT", "vat", "Tax", "tax"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 45,
        action: "read",
        resource: "Charge Types",
      },
      {
        name: "banners",
        url: "/master/banners",
        icon: "icon-arrow-right",
        description: "banners_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 127,
        action: "read",
        resource: "Banners",
      },
      {
        name: "Global Options Settings",
        url: "/master/global-options-settings",
        icon: "icon-arrow-right",
        description: "global_options_dash_msg",
        keywords: [
          "global",
          "global settings",
          "Global Options",
          "Global Options Settings",
          "settings",
        ],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 203,
        action: "read",
        resource: "Global Options Settings",
      },
      {
        name: "cinematypes",
        url: "/master/cinema-types",
        icon: "icon-arrow-right",
        description: "cinematypes_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 155,
        action: "read",
        resource: "Cinema Type",
      },
      {
        name: "tiertypes",
        url: "/master/tier-types",
        icon: "icon-arrow-right",
        description: "tiertypes_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager],
        module_id: 156,
        action: "read",
        resource: "Tier Type",
      },
      {
        name: "country",
        url: "/master/countries",
        icon: "icon-arrow-right",
        description: "country_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager],
        module_id: 41,
        action: "read",
        resource: "Country",
      },
      {
        name: "state",
        url: "/master/states",
        icon: "icon-arrow-right",
        description: "state_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager],
        module_id: 42,
        action: "read",
        resource: "States",
      },
      {
        name: "city",
        url: "/master/cities",
        icon: "icon-arrow-right",
        description: "city_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager],
        module_id: 43,
        action: "read",
        resource: "Cities",
      },
      {
        name: "region",
        url: "/master/regions",
        icon: "icon-arrow-right",
        description: "region_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager],
        module_id: 174,
        action: "read",
        resource: "Region",
      },
      {
        name: "territory",
        url: "/master/territory",
        icon: "icon-arrow-right",
        description: "territory_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager],
        module_id: 307,
        action: "read",
        resource: "Territory",
      },
      {
        name: "denomination",
        url: "/master/denominations",
        icon: "icon-arrow-right",
        description: "denomination_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 44,
        action: "read",
        resource: "Denominations",
      },
      {
        name: "productioncompany",
        url: "/distributor/productions",
        icon: "icon-arrow-right",
        description: "production_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 46,
        action: "read",
        resource: "Production Companies",
      },
      {
        name: "censorrating",
        url: "/master/ratings",
        icon: "icon-arrow-right",
        description: "rating_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 47,
        action: "read",
        resource: "Censor Ratings",
      },
      {
        name: "crew",
        url: "/master/crews",
        icon: "icon-arrow-right",
        description: "crew_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 48,
        action: "read",
        resource: "Crews",
      },
      {
        name: "Cast & Crew Details",
        url: "/master/cast-crew",
        icon: "icon-arrow-right",
        description: "crew_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 48,
        action: "read",
        resource: "Crews",
      },
      {
        name: "currency",
        url: "/master/currencies",
        icon: "icon-arrow-right",
        description: "currency_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 49,
        action: "read",
        resource: "Currencies",
      },
      // {
      //   name: "currency_conversion",
      //   url: "/master/currencies-conversion",
      //   icon: "icon-arrow-right",
      //   description: "currency_conversation_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 176,
      //   action: "read",
      //   resource: "Currency Conversion",
      // },

      {
        name: "comments",
        url: "/master/schedule-comments-master",
        icon: "icon-arrow-right",
        description: "comments_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 141,
        action: "read",
        resource: "Comments",
      },
      {
        name: "bookingsource",
        url: "/master/booking-sources",
        icon: "icon-arrow-right",
        description: "bookingsource_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 50,
        action: "read",
        resource: "Booking Source",
      },
      {
        name: "genre",
        url: "/master/genres",
        icon: "icon-arrow-right",
        description: "genre_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 53,
        action: "read",
        resource: "Genre",
      },
      {
        name: "labels",
        url: "/master/movie-labels",
        icon: "icon-arrow-right",
        description: "label_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 194,
        action: "read",
        resource: "FNB Label",
      },
      {
        name: "screen_seat_type_group",
        url: "/master/screen-seat-type-group",
        icon: "icon-arrow-right",
        description: "sstg_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 194,
        action: "read",
        resource: "Screen Seat Type Group",
      },
      {
        name: "Hardware Locations",
        url: "/master/hardware-locations",
        icon: "icon-arrow-right",
        description: "hardwareLocations_dash",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 236,
        action: "read",
        resource: "Hardware Locations",
      },
      {
        name: "hardware",
        url: "/master/hardwares",
        icon: "icon-arrow-right",
        description: "hardware_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 54,
        action: "read",
        resource: "Hardwares",
      },
      {
        name: "language",
        url: "/master/languages",
        icon: "icon-arrow-right",
        description: "language_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 55,
        action: "read",
        resource: "Language",
      },
      {
        name: "imagesetting",
        url: "/master/image-settings",
        icon: "icon-arrow-right",
        description: "imagesetting_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 56,
        action: "read",
        resource: "Image Setting",
      },
      {
        name: "movieformat",
        url: "/master/movie-formats",
        icon: "icon-arrow-right",
        description: "format_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 57,
        action: "read",
        resource: "Movie Format",
      },
      {
        name: "moviecategory",
        url: "/master/movie-categories",
        icon: "icon-arrow-right",
        description: "movie_category_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        keywords: ["mini", "festival", "minifestival"],
        module_id: 58,
        action: "read",
        resource: "Movie Category",
      },
      {
        name: "organization",
        url: "/master/organizations",
        icon: "icon-arrow-right",
        description: "org_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 60,
        action: "read",
        resource: "Organizations",
      },
      {
        name: "paymentmode",
        url: "/master/payment-modes",
        icon: "icon-arrow-right",
        description: "payment_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 61,
        action: "read",
        resource: "Payment Mode",
      },
      {
        name: "refundreason",
        url: "/master/refund-reasons",
        icon: "icon-arrow-right",
        description: "refund_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 62,
        action: "read",
        resource: "Refund Reason",
      },
      {
        name: "soundformats",
        url: "/master/sound-formats",
        icon: "icon-arrow-right",
        description: "sound_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 152,
        action: "read",
        resource: "Sound Format",
      },
      {
        name: "clients",
        url: "/master/clients",
        icon: "icon-arrow-right",
        description: "clients_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 160,
        action: "read",
        resource: "Clients",
      },
      {
        name: "unitconverter",
        url: "/master/unit-converter",
        icon: "icon-arrow-right",
        description: "unitconverter_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 128,
        action: "read",
        resource: "Unit Converter",
      },
      {
        name: "unitofmeasurement",
        url: "/master/unit-of-measurment",
        icon: "icon-arrow-right",
        description: "unitofmeasurement_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 67,
        action: "read",
        resource: "Unit of Measurements",
      },
      {
        name: "weekday",
        url: "/master/weekdays",
        icon: "icon-arrow-right",
        description: "weekday_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 68,
        action: "read",
        resource: "Weekdays",
      },
      {
        name: "bookingusercategory",
        url: "/master/booking-user-category",
        icon: "icon-arrow-right",
        description: "bookingusercategory_dash_msg",
        permissions: [],
        module_id: 69,
        action: "read",
        resource: "Booking User Category",
      },
      // {
      //   name: "autoemailreportv2",
      //   url: "/master/auto-emailer-v2",
      //   icon: "icon-arrow-right",
      //   description: "autoemailreport_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 75,
      //   action: "read",
      //   resource: "Auto Email Report",
      // },
      // {
      //   name: "autoemailreport",
      //   url: "/master/auto-email-report",
      //   icon: "icon-arrow-right",
      //   description: "autoemailreport_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 75,
      //   action: "read",
      //   resource: "Auto Email Report",
      // },
      {
        name: "Auto Email Report V3",
        url: "/master/auto-email-v3",
        icon: "icon-arrow-right",
        description: "autoemailreport_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 75,
        action: "read",
        resource: "Auto Email Report",
      },
      {
        name: "aspectRatio",
        url: "/master/aspect-ratios",
        icon: "icon-arrow-right",
        description: "aspect_ratio_msg",
        permissions: [Role.SuperAdmin, Role.HoManager],
        module_id: 181,
        action: "read",
        resource: "Aspect Ratio",
      },
      {
        name: "movieResolution",
        url: "/master/movie-resolutions",
        icon: "icon-arrow-right",
        description: "movie_resolutions_msg",
        permissions: [Role.SuperAdmin, Role.HoManager],
        module_id: 182,
        action: "read",
        resource: "Movie Resolution",
      },
      {
        name: "movieExperience",
        url: "/master/movie-experiences",
        icon: "icon-arrow-right",
        description: "movie_experiences_msg",
        permissions: [Role.SuperAdmin, Role.HoManager],
        module_id: 183,
        action: "read",
        resource: "Movie Experience",
      },
      {
        name: "Translations",
        url: "/master/translations-list",
        icon: "icon-arrow-right",
        description: "translation_list_msg",
        permissions: [Role.SuperAdmin, Role.HoManager],
        module_id: 195,
        action: "read",
        resource: "Translations",
      },
      {
        name: "Seat Reservation Type",
        url: "/master/seat-reservation-types",
        icon: "icon-arrow-right",
        description: "seat_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 65,
        action: "read",
        resource: "Seat Reservation Type",
      },
      {
        name: "Fnb Labels",
        url: "/master/fnb-labels",
        icon: "icon-arrow-right",
        description: "Fnb Labels",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 237,
        action: "read",
        resource: "Fnb Labels",
      },
    ],
  },
  /**
   * MASTERS END
   */

  //  FNB MASTER ROUTES
  {
    id: 5,
    name: "foodNbev",
    url: "/fnb",
    icon: "icon-fnb",
    permissions:
      authenticationService.get("ENABLE_FNB") === "Y"
        ? [Role.SuperAdmin, Role.CinemaManager, Role.HoManager]
        : [Role.SuperAdmin, Role.HoManager],
    isCollapsed: false,
    children: [
      {
        name: "rawmaterialsCategories",
        url: "/fnb/raw-materials-categories",
        icon: "icon-arrow-right",
        description: "rawmaterialscategory_dash_msg",
        cine_direct_sale: "N",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 78,
        action: "read",
        resource: "F&B item",
      },
      {
        name: "rawmaterials",
        url: "/fnb/raw-materials",
        icon: "icon-arrow-right",
        description: "rawmaterials_dash_msg",
        cine_direct_sale: "N",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 79,
        action: "read",
        resource: "F&B item",
      },
      {
        name: "vendor",
        url: "/fnb/vendors",
        icon: "icon-arrow-right",
        description: "vendors_dash_msg",
        cine_direct_sale: "N",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 80,
        action: "read",
        resource: "Vendors",
      },
      {
        name: "modifiers",
        url: "/fnb/modifier-categories",
        icon: "icon-arrow-right",
        description: "modifiers_dash_msg",
        cine_direct_sale: "N",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 78,
        action: "read",
        resource: "F&B item",
      },
      {
        name: "purchaseOrder",
        url: "/fnb/purchase-order",
        icon: "icon-arrow-right",
        description: "puchase_order_dash_msg",
        cine_direct_sale: "N",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 81,
        action: "read",
        resource: "Purchase Order",
      },
      // {
      //   name: "storeManagement",
      //   url: "/fnb/store-management",
      //   icon: "icon-arrow-right",
      //   description: "storemanagement_dash_msg",
      //   cine_direct_sale: "N",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 82,
      //   action: "read",
      //   resource: "Store Management",
      // },
      {
        name: "PO Inward / GRN",
        url: "/fnb/stock-in",
        icon: "icon-arrow-right",
        description: "stock_in_dash_msg",
        cine_direct_sale: "N",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 83,
        keywords: ["invent", "inward", "GRN"],
        action: "read",
        resource: "Inward",
      },
      // {
      //   name: "property_in_out",
      //   url: "/fnb/property-in-out",
      //   icon: "icon-arrow-right",
      //   description: "property_in_out_dash_msg",
      //   cine_direct_sale: "N",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 303,
      //   keywords: ["proerty", "IN/Out", "Adjustment", "stock"],
      //   action: "read",
      //   resource: "Property In Out",
      // },
      // {
      //   name: "propertyInOutLogs",
      //   url: "/fnb/property-in-out-logs",
      //   icon: "icon-arrow-right",
      //   description: "property_in_out_dash_msg",
      //   cine_direct_sale: "N",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 161,
      //   action: "read",
      //   resource: "Property In/Out Logs",
      // },
      {
        name: "transferStock",
        // url: "/fnb/transfer-stocks",
        url: "/fnb/transfer-stocks-v2",
        icon: "icon-arrow-right",
        description: "transfer_stocks_dash_msg",
        cine_direct_sale: "N",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 84,
        action: "update",
        resource: "Transfer Stocks",
      },
      {
        name: "transferStockLogs",
        url: "/fnb/transfer-stocks-logs",
        icon: "icon-arrow-right",
        description: "transfer_stocks_logs_dash_msg",
        cine_direct_sale: "N",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 85,
        action: "read",
        resource: "Transfer Stock Log",
      },
      {
        name: "Stocks Transfer Request Logs",
        url: "/fnb/stocks-tranfer-requests",
        icon: "icon-arrow-right",
        description: "transfer_stocks_logs_dash_msg",
        cine_direct_sale: "N",
        keywords: ["transfer", "stock", "request", "inventory"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 344,
        action: "read",
        resource: "Stock Transfer Requests",
      },
      {
        name: "Minimum Stock Levels",
        url: "/fnb/minimum-stock-logs",
        icon: "icon-arrow-right",
        description: "transfer_stocks_logs_dash_msg",
        cine_direct_sale: "N",
        keywords: ["minimum", "threshold", "stock", "logs"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 345,
        action: "read",
        resource: "Minimum Stock Logs",
      },
      {
        name: "Inventory Mails Notifications",
        url: "/master/add-inventory-mails",
        icon: "icon-arrow-right",
        description: "Add Inventory Mails",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 346,
        action: "read",
        resource: "Inventory Notification Settings",
      },
      {
        name: "Stock Variance Reasons",
        url: "/fnb/stock-take-reasons",
        icon: "icon-arrow-right",
        description: "reasons_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager],
        module_id: 312,
        action: "read",
        resource: "Stock Variance Reasons",
      },
      {
        name: "stocktake",
        url: "/fnb/stock-take",
        icon: "icon-arrow-right",
        description: "stock_take_dash_msg",
        cine_direct_sale: "N",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 86,
        action: "read",
        resource: "Stock Take",
      },
      {
        name: "stocktakeLogs",
        url: "/fnb/stock-take-logs",
        icon: "icon-arrow-right",
        description: "stock_take_logs_dash_msg",
        cine_direct_sale: "N",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 161,
        action: "read",
        resource: "Stock Take Logs",
      },
      {
        name: "stocktakesummary",
        url: "/fnb/stock-take-summary",
        icon: "icon-arrow-right",
        description: "stock_take_logs_dash_msg",
        cine_direct_sale: "N",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 161,
        action: "read",
        resource: "Stock Take Logs",
      },
      {
        name: "concessionStock",
        url: "/fnb/concession-stock",
        icon: "icon-arrow-right",
        description: "concession_stock_dash_msg",
        cine_direct_sale: "N",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 87,
        action: "read",
        resource: "Concession Stock",
      },
      {
        name: "foodCategories",
        url: "/fnb/food-categories",
        icon: "icon-arrow-right",
        description: "food_categories_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 88,
        action: "read",
        resource: "Food Categories",
      },
      {
        id: 20,
        name: "Recipe",
        url: "/fnb/recipes",
        icon: "icon-fnb",
        permissions: [],
        isCollapsed: false,
        children: [
          {
            name: "recipe",
            url: "/fnb/recipes",
            icon: "icon-arrow-right",
            description: "recipes_dash_msg",
            keywords: ["Recipe", "recep"],
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 89,
            action: "read",
            resource: "Recipes",
          },
          {
            name: "subrecipe",
            url: "/fnb/subrecipes",
            icon: "icon-arrow-right",
            description: "recipes_dash_msg",
            keywords: ["Recipe", "recep", "sub", "subrecipe", "subrecep"],
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 238,
            action: "read",
            resource: "Sub Recipe",
          },
        ],
      },
      {
        name: "customization",
        url: "/fnb/customization",
        icon: "icon-arrow-right",
        description: "fnb_customization_dash_msg",
        cine_direct_sale: "N",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 164,
        action: "read",
        resource: "F&B Customization",
      },
      {
        name: "fbItems",
        url: "/fnb/fnb-items",
        icon: "icon-arrow-right",
        description: "fnb_items_dash_msg",
        keywords: [
          "food and beverage items",
          "Concessions",
          "fnb",
          "f&b",
          "items",
          "food",
          "beverages",
          "f &",
          "f and",
        ],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 90,
        action: "read",
        resource: "F&B item",
      },
      // {
      //   name: "Vip Fnb",
      //   url: "/fnb/vip-fnb",
      //   icon: "icon-arrow-right",
      //   description: "vip_fnb",
      //   keywords: ["vip fnb"],
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 245,
      //   action: "read",
      //   resource: "VipFnb",
      //   only_visible_on: [
      //     {
      //       key_name: CLIENT_NAME.EMPIRE,
      //     },
      //     {
      //       key_name: CLIENT_NAME.LEBANON,
      //     },
      //   ],
      // },
      // {
      //   name: 'rateCard',
      //   url: '/fnb/rateCard',
      //   icon: 'icon-arrow-right',
      //   description: '',
      //   permissions: [Role.SuperAdmin, Role.HoManager],
      // },
      // {
      //   name: 'fbPricing',
      //   url: '/fnb/fnb-pricing',
      //   icon: 'icon-arrow-right',
      //   description: '',
      //   permissions: [Role.SuperAdmin, Role.HoManager],
      //   module_id: 152

      // },
      {
        name: "wastemanagement",
        url: "/fnb/fnb-wastage",
        icon: "icon-arrow-right",
        cine_direct_sale: "N",
        description: "fnb_wastage_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 91,
        action: "read",
        resource: "Waste Management",
      },
      {
        name: "goodreturn",
        url: "/fnb/good-return",
        icon: "icon-arrow-right",
        description: "goods_return_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 33,
        action: "read",
        resource: "Goods Return",
      },
      {
        name: "Fnb Stations",
        url: "/fnb/fnb-stations",
        icon: "icon-arrow-right",
        description: "fnb stations",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 295,
        action: "read",
        resource: "fnb stations",
      },
    ],
  },

  {
    id: 6,
    name: "reports",
    url: "/reports",
    icon: "icon-report",
    permissions: [
      Role.SuperAdmin,
      Role.CinemaManager,
      Role.HoManager,
      Role.Distributor,
    ],
    isCollapsed: false,
    children: [
      {
        name: "Report Builder FnB",
        url: "/reports/report-builder-fnb",
        icon: "icon-arrow-right",
        description: "Report Builder FnB",
        keywords: ["fnb", "builder", "beta"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 231,
        action: "read",
        resource: "Report Builder FnB",
      },
      // {
      //   name: "Loyalty Overview",
      //   url: "/reports/loyalty-overview-report",
      //   icon: "icon-arrow-right",
      //   description: "Loyalty Overview & Settlements",
      //   keywords: ["Loyalty", "Overview", "loyality", "settlements"],
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 280,
      //   action: "read",
      //   resource: "Loyalty Overview",
      // },
      // {
      //   name: "Loyalty Settlements",
      //   url: "/reports/loyalty-settlement-report",
      //   icon: "icon-arrow-right",
      //   description: "Loyalty Overview & Settlements",
      //   keywords: ["Loyalty", "Overview", "loyality", "settlements"],
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 281,
      //   action: "read",
      //   resource: "Loyalty Settlements",
      // },
      // {
      //   name: "Website Cash Card Status",
      //   url: "/reports/cash-card-status",
      //   icon: "icon-arrow-right",
      //   description: "online_cc_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 234,
      //   action: "read",
      //   resource: "Website Cash Card Status",
      // },
      // {
      //   name: "cinemaOverviewReport",
      //   url: "/reports/showoverview",
      //   icon: "icon-arrow-right",
      //   description: "Show Overview",
      //   permissions: [
      //     Role.SuperAdmin,
      //     Role.HoManager,
      //     Role.CinemaManager,
      //     Role.ProgrammingManager,
      //   ],
      //   module_id: 201,
      //   action: "read",
      //   resource: "Advance Sales Report",
      // },
      // {
      //   name: "Advance Sales Report",
      //   url: "/reports/advance-sales-report",
      //   icon: "icon-arrow-right",
      //   description: "Show Overview",
      //   permissions: [
      //     Role.SuperAdmin,
      //     Role.HoManager,
      //     Role.CinemaManager,
      //     Role.ProgrammingManager,
      //   ],
      //   module_id: 133,
      //   action: "read",
      //   resource: "Advance Sales Report",
      // },
      {
        name: "Hourly SPH Report",
        url: "/reports/hourly-sph-report",
        icon: "icon-arrow-right",
        description: "Show Overview",
        permissions: [
          Role.SuperAdmin,
          Role.HoManager,
          Role.CinemaManager,
          Role.ProgrammingManager,
        ],
        module_id: 134,
        action: "read",
        resource: "Hourly SPH Report",
      },
      {
        name: "occupancyreport",
        url: "/reports/occupancy",
        icon: "icon-arrow-right",
        description: "Occupancy Reports",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 189,
        action: "read",
        resource: "Occupancy Reports",
      },
      {
        name: "Occupancy Analysis Report",
        url: "/reports/occupancy-analysis-report",
        icon: "icon-arrow-right",
        description: "Occupancy Analysis Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 239,
        action: "read",
        resource: "Occupancy Analysis Report",
      },
      {
        name: "Show Date Wise Admits Report",
        url: "/reports/show-details-report",
        icon: "icon-arrow-right",
        description: "Show Date Wise Admits Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 310,
        action: "read",
        resource: "Show Date Wise Admits Report",
      },
      // {
      //   name: "Summary and Performance Report",
      //   url: "/reports/performance-summary-report",
      //   icon: "icon-arrow-right",
      //   description: "perforamce and summary report",
      //   permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
      //   module_id: 214,
      //   action: "read",
      //   resource: "Summary and Performance Report",
      // },
      //   {
      //   name: "Reserved Unpaid Bookings",
      //   url: "/cinema-manager/reserve-seats-list",
      //   icon: "icon-arrow-right",
      //   description: "reserveseats_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 22,
      //   action: "read",
      //   resource: "Reserve Seats",
      // },
      {
        name: "Summary and Performance Report Lebanon",
        url: "/reports/performance-summary-report-v4",
        icon: "icon-arrow-right",
        description: "perforamce and summary report V4",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 214,
        action: "read",
        resource: "Summary and Performance Report",
        only_visible_on: [
          {
            key_name: CLIENT_NAME.LEBANON,
          },
        ],
      },
      {
        name: "Summary And Performance Report",
        url: "/reports/summary-performance-report",
        icon: "icon-arrow-right",
        description: "Summary And Performance Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 214,
        only_available_on: [
          {
            key_name: CLIENT_NAME.EPIX,
            url: "/reports/summary-performance-report-epix",
          },
          {
            key_name: CLIENT_NAME.EMPIRE,
            url: "/reports/summary-performance-report-empire",
          },
        ],
        action: "read",
        resource: "Summary and Performance Report",
      },
      // {
      //   name: "Summary Performance Rent Report",
      //   url: "/reports/summary-performance-report-epix-rent",
      //   icon: "icon-arrow-right",
      //   description: "Summary Performance Rent Report",
      //   permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
      //   module_id: 324,
      //   only_available_on: [
      //     {
      //       key_name: CLIENT_NAME.EPIX,
      //       url: "/reports/summary-performance-report-epix-rent",
      //     },
      //   ],
      //   action: "read",
      //   resource: "Summary Performance Rent Report ",
      // },

      {
        name: "User Cashier Summary  Report",
        url: "/reports/user-cashier-summary-report",
        icon: "icon-arrow-right",
        description: "User Cashier Summary  Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 214,

        action: "read",
        resource: "User Cashier Summary  Report",
      },
      {
        name: "Summary User Transaction Log Report",
        url: "/reports/summary-user-transaction-log-report",
        icon: "icon-arrow-right",
        description: "Summary User Transaction Log Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 214,

        action: "read",
        resource: "Summary User Transaction Log Report",
      },
      // {
      //   name: "Summary",
      //   url: "/reports/summary",
      //   icon: "icon-arrow-right",
      //   description: "Summary",
      //   permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
      //   module_id: 93,
      //   action: "read",
      //   resource: "Summary",
      // },
      {
        name: "net_revenue_report",
        url: "/reports/net-revenue-report",
        icon: "icon-arrow-right",
        description: "net_revenue_msg",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 263,
        action: "read",
        resource: "Net Revenue Report",
      },
      {
        name: "gcamreport",
        url: "/reports/gcam-report",
        icon: "icon-arrow-right",
        description: "gcam_report_dash_msg",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 215,
        action: "read",
        resource: "GCAM Report",
        only_visible_on: [
          {
            key_name: CLIENT_NAME.EMPIRE,
          },
          {
            key_name: CLIENT_NAME.IRAQ,
          },
          {
            key_name: CLIENT_NAME.BILDHAUS,
          },
          {
            key_name: CLIENT_NAME.CINEMA_AKIL,
          },
          {
            key_name: CLIENT_NAME.XANADU,
          },
          {
            key_name: CLIENT_NAME.PETRO,
          },
          {
            key_name: CLIENT_NAME.QFX,
          },
          {
            key_name: CLIENT_NAME.LEBANON,
          },
          {
            key_name: CLIENT_NAME.STUESSIHOF,
          },
        ],
      },
      {
        name: "Muncipality Report",
        url: "/reports/Muncipality-report",
        icon: "icon-arrow-right",
        description: "muncipality_report_dash_msg",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 273,
        only_visible_on: [
          {
            key_name: CLIENT_NAME.STAR,
          },
          {
            key_name: CLIENT_NAME.WOW,
          },
        ],
        action: "read",
        resource: "Municipality Report",
      },
      {
        name: "MTax Report",
        url: "/reports/mtax-report",
        icon: "icon-arrow-right",
        description: "mtax_report_dash_msg",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 215,
        action: "read",
        resource: "GCAM Report",
        only_visible_on: [
          {
            key_name: CLIENT_NAME.STAR,
          },
          {
            key_name: CLIENT_NAME.WOW,
          },
        ],
      },
      {
        name: "Box Office Summary Report",
        url: "/reports/box-office-report",
        icon: "icon-arrow-right",
        description: "box office summary report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 216,
        action: "read",
        resource: "Box Office Summary  Report",
        only_available_on: [
          {
            key_name: CLIENT_NAME.LEBANON,
            url: "/reports/box-office-report-lebanon",
          },
        ],
      },
      {
        name: "Cashier Shift Close",
        url: "/reports/cashier-shift-close",
        icon: "icon-arrow-right",
        description: "box office summary report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 249,
        action: "read",
        resource: "Shifts",
      },
      {
        name: "Voucher Useage Report",
        url: "/reports/voucher-useage-report",
        icon: "icon-arrow-right",
        description: "Voucher Useage Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 274,
        action: "read",
        resource: "Voucher Useage Report",
      },
      {
        name: "Traffic Flow Analysis Report",
        url: "/reports/traffic-flow-analysis",
        icon: "icon-arrow-right",
        description: "traffic_flow_analysis_msg",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 317,
        action: "read",
        resource: "Traffic Flow Analysis Report",
      },
      {
        name: "Week Wise Movie History Report",
        url: "/reports/week-wise-movie-history-report",
        icon: "icon-arrow-right",
        description: "Week Wise Movie History Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 320,
        action: "read",
        resource: "Week Wise Movie History Report",
      },
      {
        name: "Advance FnB Report",
        url: "/reports/advance-fnb-report",
        icon: "icon-arrow-right",
        description: "Advance FnB Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 275,
        action: "read",
        resource: "Advance FnB Report",
      },
      {
        name: "E-Wallet Report",
        url: "/reports/e-wallet-report",
        icon: "icon-arrow-right",
        description: "E-Wallet Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 279,
        action: "read",
        resource: "EWallet Report",
      },
      // {
      //   name: "Detailed Prior Sales Report",
      //   url: "/reports/detailed-prior-sales-report",
      //   icon: "icon-arrow-right",
      //   description: "Detailed Prior Sales Report",
      //   permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
      //   module_id: 285,
      //   action: "read",
      //   resource: "Detailed Prior Sales Report",
      // },
      {
        name: "Detailed Advance Sales Report",
        url: "/reports/detailed-advanced-sales-report",
        icon: "icon-arrow-right",
        description: "Detailed Advance Sales Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 286,
        action: "read",
        resource: "Detailed Advance Sales Report",
      },
      {
        name: "Transactions Summary Report",
        url: "/reports/transaction-summary-report",
        icon: "icon-arrow-right",
        description: "Transaction Summary Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 287,
        action: "read",
        resource: "Transactions Summary Report",
      },
      {
        name: "Product Sale Report",
        url: "/reports/productSaleReport",
        icon: "icon-arrow-right",
        description: "Product Sale Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 288,
        action: "read",
        resource: "Product Sale Report",
      },
      // {
      //   name: "Electronic Payments Report",
      //   url: "/reports/electronic-payments-report",
      //   icon: "icon-arrow-right",
      //   description: "Transaction Summary Report",
      //   permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
      //   module_id: 289,
      //   action: "read",
      //   resource: "Electronic Payments Report",
      //   only_available_on: [
      //     {
      //       key_name: CLIENT_NAME.CINEPOLIS_OMAN,
      //       url: "/reports/electronic-payments-report",
      //     },
      //   ],
      // },
      {
        name: "Offer Redemption Report",
        url: "/reports/offer-redemption-report",
        icon: "icon-arrow-right",
        description: "Offer Redemption Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 290,
        action: "read",
        resource: "Offer Redemption Report",
      },
      {
        name: "Month And Day Wise Report",
        url: "/reports/month-and-daywise-report",
        icon: "icon-arrow-right",
        description: "Transaction Summary Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 291,
        action: "read",
        resource: "Month And Day Wise Report",
      },
      // {
      //   name: "Daily Cashup Report",
      //   url: "/reports/daily-cashup-report",
      //   icon: "icon-arrow-right",
      //   description: "Daily Cashup Report",
      //   permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
      //   module_id: 292,
      //   action: "read",
      //   resource: "Daily ashup Report",
      // },
      // {
      //   name: "User Collection Report",
      //   url: "/reports/user-collection-report",
      //   icon: "icon-arrow-right",
      //   description: "User Collection Report",
      //   permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
      //   module_id: 279,
      //   action: "read",
      //   resource: "User Collection Report",
      // },

      {
        name: "Daily Operations Report",
        url: "/reports/daily-operations-report",
        icon: "icon-arrow-right",
        description: "Daily Operations Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 293,
        action: "read",
        resource: "Daily Operations Report",
      },
      {
        name: "Distributor Report",
        url: "/reports/distributor-report-star",
        icon: "icon-arrow-right",
        description: "Distributor Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 259,
        only_visible_on: [
          {
            key_name: CLIENT_NAME.STAR,
          },
          {
            key_name: CLIENT_NAME.WOW,
          },
        ],
        action: "read",
        resource: "Distributor Report",
      },
      {
        name: "distributorDetailedSummaryOman",
        url: "/reports/cinema-reports/distributor-report-cinepolis",
        icon: "icon-arrow-right",
        description: "distributor_detailed_dash_msg_oman",
        keywords: ["distributor", "oman"],
        permissions: [
          Role.SuperAdmin,
          Role.CinemaManager,
          Role.Distributor,
          Role.HoManager,
        ],
        module_id: 294,
        action: "read",
        resource: "Distributor Report Cinepolis",
        only_visible_on: [
          {
            key_name: CLIENT_NAME.CINEPOLIS_OMAN,
          },
          {
            key_name: CLIENT_NAME.CINEPOLIS_KSA,
          },
        ],
      },
      {
        name: "Municipality Report Detail",
        url: "/reports/municipality-report-detail",
        icon: "icon-arrow-right",
        description: "Municipality Report Detail",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 260,
        only_visible_on: [
          {
            key_name: CLIENT_NAME.STAR,
          },
          {
            key_name: CLIENT_NAME.WOW,
          },
        ],
        action: "read",
        resource: "Municipality Detail Report",
      },
      {
        name: "Municipality Report Detail (With Complimentary)",
        url: "/reports/municipality-report-detail-with-complimentary",
        icon: "icon-arrow-right",
        description: "Municipality Report Detail(With Complimentary)",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 260,
        only_visible_on: [
          {
            key_name: CLIENT_NAME.STAR,
          },
        ],
        action: "read",
        resource: "Municipality Detail Report",
      },
      {
        name: "Municipality Report Summary",
        url: "/reports/municipality-report-summary",
        icon: "icon-arrow-right",
        description: "Municipality Report Summary",
        keywords: ["Municipality"],
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 261,
        only_visible_on: [
          {
            key_name: CLIENT_NAME.STAR,
          },
          {
            key_name: CLIENT_NAME.WOW,
          },
        ],
        action: "read",
        resource: "Municipality Report Summary",
      },
      {
        name: "Screen Scheduling Report",
        url: "/reports/screen-scheduling",
        icon: "icon-arrow-right",
        description: "Screen Scheduling Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 276,
        action: "read",
        resource: "Screen Scheduling Report",
      },
      {
        name: "Sales Book",
        url: "/reports/sales-book",
        icon: "icon-arrow-right",
        description: "Sales Book",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 251,
        only_visible_on: [
          {
            key_name: CLIENT_NAME.QFX,
          },
        ],
        action: "read",
        resource: "Sales Book",
      },
      {
        name: "Sales Return With Cancel Reason",
        url: "/reports/sales-return-with-cancel-reason",
        icon: "icon-arrow-right",
        description: "Sales Return With Cancel Reason",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 252,
        only_visible_on: [
          {
            key_name: CLIENT_NAME.QFX,
          },
        ],
        action: "read",
        resource: "Sales Return With Cancel Reason",
      },
      {
        name: "Concession Item Sales Report",
        url: "/reports/concession-item-sales",
        icon: "icon-arrow-right",
        description: "Concession Item Sales Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 253,
        action: "read",
        resource: "Concession Item Sales Report",
      },
      {
        name: "DCR Finance Report",
        url: "/reports/dcr-finance-report",
        icon: "icon-arrow-right",
        description: "DCR Finance Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 266,
        only_visible_on: [
          {
            key_name: CLIENT_NAME.QFX,
          },
          {
            key_name: CLIENT_NAME.STAR,
          },
        ],
        action: "read",
        resource: "DCR Finance Report",
      },
      {
        name: "Product Sales Report",
        url: "/reports/product-sales-report",
        icon: "icon-arrow-right",
        description: "Product Sales Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 267,
        only_visible_on: [
          {
            key_name: CLIENT_NAME.QFX,
          },
        ],
        action: "read",
        resource: "Product Sales Report",
      },
      {
        name: "Screen Aggregator Report",
        url: "/reports/aggregator-report",
        icon: "icon-arrow-right",
        description: "Aggregator Report",
        keywords: ["aggregator"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 254,
        action: "read",
        resource: "Aggregator",
      },
      // {
      //   name: "GCAM & Vat Detailed Report",
      //   url: "/reports/gcam-vat-detailed-report",
      //   icon: "icon-arrow-right",
      //   description: "GCAM & Vat Detailed Report",
      //   permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
      //   module_id: 255,
      //   action: "read",
      //   resource: "GCAM & Vat Detailed Report",
      // },
      {
        name: "Rate Card Report",
        url: "/reports/rate-card-report",
        icon: "icon-arrow-right",
        description: "Rate Card Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 218,
        action: "read",
        resource: "Rate Card Report",
      },
      {
        name: "Housekeeping Report",
        url: "/reports/house-keeping-report",
        icon: "icon-arrow-right",
        description: "House Keeping Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 219,
        action: "read",
        resource: "Housekeeping Report",
      },
      {
        name: "Sales Register Report",
        url: "/reports/sales-register-report-beta",
        icon: "icon-arrow-right",
        description: "Sales Register Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 220,
        action: "read",
        resource: "Sales Register Report",
        only_visible_on: [
          {
            key_name: CLIENT_NAME.PETRO,
          },
          {
            key_name: CLIENT_NAME.IRAQ,
          },
          {
            key_name: CLIENT_NAME.LEBANON,
          },
          {
            key_name: CLIENT_NAME.STAR,
          },
          {
            key_name: CLIENT_NAME.CINEPOLIS_OMAN,
          },
          {
            key_name: CLIENT_NAME.CINEPOLIS_KSA,
          },
          {
            key_name: CLIENT_NAME.WOW,
          },
          {
            key_name: CLIENT_NAME.QFX,
          },
          {
            key_name: CLIENT_NAME.CINEPOLIS_OMAN,
          },
          {
            key_name: CLIENT_NAME.PLAYCINEMA,
          },
          {
            key_name: CLIENT_NAME.CINERJI,
          },
          // {
          //   key_name: CLIENT_NAME.EPIX,
          // },
        ],
        only_available_on: [
          // {
          //   key_name: CLIENT_NAME.EMPIRE,
          //   url: "/reports/sales-register-report-v1",
          // },
          {
            key_name: CLIENT_NAME.STAR,
            url: "/reports/sales-register-report-star",
          },
          {
            key_name: CLIENT_NAME.CINEPOLIS_OMAN,
            url: "/reports/sales-register-report-cinepolis",
          },
          // {
          //   key_name: CLIENT_NAME.EPIX,
          //   url: "/reports/sales-register-report-beta",
          // },
          {
            key_name: CLIENT_NAME.WOW,
            url: "/reports/sales-register-report-wow",
          },
        ],
      },
      // {
      //   name: "Sales Register Report",
      //   url: "/reports/sales-register-report-beta",
      //   icon: "icon-arrow-right",
      //   description: "Sales Register Report-Beta",
      //   tagDescription: "-Old (Sep.23)",
      //   permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
      //   module_id: 220,
      //   action: "read",
      //   resource: "Sales Register Report-Beta",
      //   // only_visible_on: [
      //   //   {
      //   //     key_name: CLIENT_NAME.EMPIRE,
      //   //   },
      //   // ],
      // },
      {
        name: "Sales Register Report",
        url: "/reports/sales-register-report-v1",
        icon: "icon-arrow-right",
        description: "Sales Register Report-Beta",
        tagDescription: "-New (Oct.23 Onwards)",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 220,
        action: "read",
        resource: "Sales Register Report-Beta",
        only_visible_on: [
          {
            key_name: CLIENT_NAME.EMPIRE,
          },
          {
            key_name: CLIENT_NAME.EPIX,
          },
          {
            key_name: CLIENT_NAME.MIF,
          },
        ],
      },
      // {
      //   name: "Sales Register Report Beta",
      //   url: "/reports/sales-register-report-beta",
      //   icon: "icon-arrow-right",
      //   description: "Sales Register Report",
      //   permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
      //   module_id: 220,
      //   action: "read",
      //   resource: "Sales Register Report Beta"
      // },
      {
        name: "Item Sales Register Report",
        url: "/reports/item-sales-register-report",
        icon: "icon-arrow-right",
        description: "Item Sales Register Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 246,
        action: "read",
        resource: "Item Sales Register",
        only_visible_on: [
          {
            key_name: CLIENT_NAME.EMPIRE,
          },
          {
            key_name: CLIENT_NAME.PETRO,
          },
          {
            key_name: CLIENT_NAME.IRAQ,
          },
          {
            key_name: CLIENT_NAME.LEBANON,
          },
          {
            key_name: CLIENT_NAME.STAR,
          },
          {
            key_name: CLIENT_NAME.CINEPOLIS_OMAN,
          },
          {
            key_name: CLIENT_NAME.CINEPOLIS_KSA,
          },
          {
            key_name: CLIENT_NAME.WOW,
          },
          {
            key_name: CLIENT_NAME.QFX,
          },
          {
            key_name: CLIENT_NAME.WOW,
          },
          {
            key_name: CLIENT_NAME.MIF,
          },
          // {
          //   key_name: CLIENT_NAME.EPIX,
          // },
        ],
      },
      {
        name: "Sales Logs",
        url: "/reports/sales-logs",
        icon: "icon-arrow-right",
        description: "Sales Logs",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 247,

        only_visible_on: [
          {
            key_name: CLIENT_NAME.EMPIRE,
          },
          {
            key_name: CLIENT_NAME.PETRO,
          },
          {
            key_name: CLIENT_NAME.IRAQ,
          },
          {
            key_name: CLIENT_NAME.QFX,
          },
        ],
        action: "read",
        resource: "Sales Logs",
      },
      {
        name: "Item Logs",
        url: "/reports/item-sales-logs",
        icon: "icon-arrow-right",
        description: "Item Logs",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 248,
        action: "read",
        resource: "Item Logs",
        only_visible_on: [
          {
            key_name: CLIENT_NAME.EMPIRE,
          },
          {
            key_name: CLIENT_NAME.PETRO,
          },
          {
            key_name: CLIENT_NAME.IRAQ,
          },
          {
            key_name: CLIENT_NAME.QFX,
          },
        ],
      },
      {
        name: "E-Transactions Report",
        url: "/reports/etransactions-report",
        icon: "icon-arrow-right",
        description: "E-Transactions Report",
        keywords: ["e transaction", "e-transaction", "e transactions"],
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 221,
        action: "read",
        resource: "E-Transactions Report",
      },
      {
        name: "Refund Show Detail Report",
        url: "/reports/refund-show-detail-report",
        icon: "icon-arrow-right",
        description: "Refund Show Detail Report",
        keywords: ["fnb refund", "refund", "fnbrefund"],
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 222,
        action: "read",
        resource: "Refund Show Detail Report",
      },
      {
        name: "FnB Refund Report",
        url: "/reports/refund-fnb-report",
        icon: "icon-arrow-right",
        description: "FnB Refund Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 279,
        action: "read",
        resource: "FnB Refund Report",
      },
      {
        name: "Receipt Summary",
        url: "/reports/receipt-summary",
        icon: "icon-arrow-right",
        description: "Receipt summary report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 223,
        action: "read",
        resource: "Receipt Summary Report",
        only_available_on: [
          {
            key_name: CLIENT_NAME.QFX,
            url: "/reports/receipt-summary-v2",
          },
          {
            key_name: CLIENT_NAME.STAR,
            url: "/reports/receipt-summary-v2",
          },
          {
            key_name: CLIENT_NAME.WOW,
            url: "/reports/receipt-summary-v2",
          },
          {
            key_name: CLIENT_NAME.LEBANON,
            url: "/reports/receipt-summary-lbp",
          },
        ],
      },
      {
        name: "FnB Combo Sales Report",
        url: "/reports/fnb-combo-sales-report",
        icon: "icon-arrow-right",
        description: "fnb combo sales report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 224,
        action: "read",
        resource: "FnB Combo Sales Report",
      },
      {
        name: "Box Office Receipt Report",
        url: "/reports/box-office-receipt-report",
        icon: "icon-arrow-right",
        description: "Box Office Receipt report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 225,
        action: "read",
        resource: "Box Office Receipt Report",
      },
      {
        name: "Online Bookings Report",
        url: "/reports/online-bookings-report",
        icon: "icon-arrow-right",
        description: "Online Bookings Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 226,
        action: "read",
        resource: "Online Bookings Report",
      },
      {
        name: "Online Booking Fee Report",
        url: "/reports/online-booking-fee-report",
        icon: "icon-arrow-right",
        description: "Online Booking Fee Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 355,
        action: "read",
        resource: "Online Booking Fee Report",
      },
      {
        name: "Raw Material Supplier Wise Cost Report",
        url: "/reports/raw-material-supplier-wise-cost-report",
        icon: "icon-arrow-right",
        description: "Raw Material Supplier Wise Cost Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 227,
        action: "read",
        resource: "Raw Material Supplier Wise Cost Report",
      },
      {
        name: "FnB Sales Report",
        url: "/reports/fnb-sales-report",
        icon: "icon-arrow-right",
        description: "FnB Sales Report Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 256,
        action: "read",
        resource: "FnB Sales Report",
      },
      {
        name: "Cashier Revenue Report",
        url: "/reports/cashier-revenue-report",
        icon: "icon-arrow-right",
        description: "Cashier Revenue Report",
        keywords: ["Rdr", "rdr", "Cashier", "Revenue"],
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 217,
        action: "read",
        resource: "Cashier Revenue Report",
      },
      {
        name: "Cashier Shift Summary",
        url: "/reports/cashier-shift-summary",
        icon: "icon-arrow-right",
        description: "Cashier Shfit Summary",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 257,
        action: "read",
        resource: "Cashier Shift Summary",
      },
      {
        name: "Screenwise Occupancy Summary Report",
        url: "/reports/screenwise-occupancy-summary-report",
        icon: "icon-arrow-right",
        description: "Screenwise Occupany Summary Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 239,
        action: "read",
        resource: " Screenwise Occupancy Summary Report",
      },
      {
        name: "F&B Delivery partner sales ",
        url: "/reports/fnb-partner-sales-report",
        icon: "icon-arrow-right",
        description: "F&B Delivery partner sales ",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 258,
        action: "read",
        resource: "Fnb Delivery partner sales ",
      },
      // {
      //   name: "Movie Pass Sales Report",
      //   url: "/reports/movie-pass-sales",
      //   icon: "icon-arrow-right",
      //   description: "Movie Pass Sales Report",
      //   permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
      //   module_id: 283,
      //   action: "read",
      //   resource: "Movie Pass Sales Report",
      // },
      {
        name: "Merchandise Transactions",
        url: "/reports/merchandise-transactions",
        icon: "icon-arrow-right",
        description: "Merchandise Transactions",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 313,
        action: "read",
        only_visible_on: [
          {
            key_name: CLIENT_NAME.CINEMA_AKIL,
          },
        ],
        resource: "Merchandise",
      },
      {
        name: "FAB Offer Report",
        url: "/reports/fab-offer-report",
        icon: "icon-arrow-right",
        description: "FAB Offer Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 290,
        action: "read",
        resource: "FAB Offer Report",
      },
      {
        name: "Movie Wise Collection Report",
        url: "/reports/movie-wise-collection-report",
        icon: "icon-arrow-right",
        description: "Movie Wise Collection Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 290,
        action: "read",
        resource: "Movie Wise Collection Report",
      },
      {
        id: 6,
        name: "Daily Sales Records",
        url: "",
        icon: "",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        isCollapsed: false,
        children: [
          {
            name: "Daily Sales Records",
            url: "/reports/daily-sales-reports/dailysalesreport",
            icon: "icon-arrow-right",
            description: "daily_sales_report_dash_msg",
            permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
            module_id: 95,
            action: "read",
            resource: "Daily Sales Report",
            only_available_on: [
              {
                key_name: CLIENT_NAME.STUESSIHOF,
                url: "/reports/daily-sales-reports/daily-sales-report",
              },
              {
                key_name: CLIENT_NAME.EMPIRE,
                url: "/reports/daily-sales-reports/daily-sales-summary-report",
              },
              {
                key_name: CLIENT_NAME.LEBANON,
                url: "/reports/daily-sales-reports/daily-sales-summary-report-lebanon",
              },
              {
                key_name: CLIENT_NAME.XANADU,
                url: "/reports/daily-sales-reports/daily-sales-report",
              },
              {
                key_name: CLIENT_NAME.IRAQ,
                url: "/reports/daily-sales-reports/daily-sales-summary-report",
              },
              {
                key_name: CLIENT_NAME.BILDHAUS,
                url: "/reports/daily-sales-reports/daily-sales-summary-report",
              },
              {
                key_name: CLIENT_NAME.STAR,
                url: "/reports/daily-sales-reports/daily-sales-report-v4",
              },
              {
                key_name: CLIENT_NAME.WOW,
                url: "/reports/daily-sales-reports/daily-sales-report-v4",
              },
              {
                key_name: CLIENT_NAME.QFX,
                url: "/reports/daily-sales-reports/daily-sales-report-v4",
              },
              {
                key_name: CLIENT_NAME.EPIX,
                url: "/reports/daily-sales-reports/daily-sales-report-v4",
              },
            ],
          },
          {
            name: "aggregatorsDailySalesReport",
            url: "/reports/daily-sales-reports/aggregator-daily-sales-report",
            icon: "icon-arrow-right",
            description: "aggregator_daily_sales_report_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 100,
            action: "read",
            resource: "Aggregator Daily Sales Report",
          },
          {
            name: "Daily Sales And Collection Report",
            url: "/reports/daily-sales-reports/daily-sales-and-collection-report",
            icon: "icon-arrow-right",
            description: "Daily Sales And Collection",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            // only_visible_on: [
            //   {
            //     key_name: CLIENT_NAME.STAR,
            //   },
            // ],
            module_id: 264,
            action: "read",
            resource: "Daily Sales And Collection Report",
          },
          {
            name: "Daily Sales And Collection Report New",
            url: "/reports/daily-sales-reports/daily-sales-and-collection-report-epix",
            icon: "icon-arrow-right",
            description: "Daily Sales And Collection",
            keywords: ["daily", "sales", "collection"],
            only_visible_on: [
              {
                key_name: CLIENT_NAME.EPIX,
              },
            ],
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            // only_visible_on: [
            //   {
            //     key_name: CLIENT_NAME.STAR,
            //   },
            // ],
            module_id: 264,
            action: "read",
            resource: "Daily Sales And Collection Report New",
          },
        ],
      },
      {
        id: 6,
        name: "cinemaReport",
        url: "",
        icon: "",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        isCollapsed: false,
        children: [
          {
            name: "screencollectionreport",
            url: "/reports/cinema-reports/screen-wise-collection-report",
            icon: "icon-arrow-right",
            description: "screenwise_dash_msg",
            permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
            keywords: ["auditorium", "hall"],
            module_id: 97,
            action: "read",
            resource: "Screen Wise Collection Report",
          },
          // {
          //   name: "distributorcollectionreport",
          //   url: "/reports/cinema-reports/distributor-collection-report",
          //   icon: "icon-arrow-right",
          //   description: "distributor_collection_dash_msg",
          //   permissions: [
          //     Role.SuperAdmin,
          //     Role.CinemaManager,
          //     Role.Distributor,
          //     Role.HoManager
          //   ],
          //   module_id: 98,
          //   only_available_on: [
          //     {
          //       key_name: CLIENT_NAME.CINEMA_AKIL,
          //       url:
          //         "/reports/cinema-reports/distributor-collection-report-v3"
          //     },
          //     {
          //       key_name: CLIENT_NAME.EMPIRE,
          //       url:
          //         "/reports/cinema-reports/distributor-collection-report-v3"
          //     },
          //     {
          //       key_name: CLIENT_NAME.IRAQ,
          //       url:
          //         "/reports/cinema-reports/distributor-collection-report-v3"
          //     },
          //     {
          //       key_name: CLIENT_NAME.PETRO,
          //       url:
          //         "/reports/cinema-reports/distributor-collection-report-v3"
          //     }
          //   ]
          // },
          {
            name: "Distributor Collection Report",
            url: "/reports/cinema-reports/distributor-collection-report-v5-qfx",
            icon: "icon-arrow-right",
            description: "distributor_collection_dash_msg",
            permissions: [
              Role.SuperAdmin,
              Role.CinemaManager,
              Role.Distributor,
              Role.HoManager,
            ],
            module_id: 98,
            action: "read",
            resource: "Distributor Collection Report",
            only_available_on: [
              {
                key_name: CLIENT_NAME.CINEMA_AKIL,
                url: "/reports/cinema-reports/distributor-collection-report-v3",
              },
              {
                key_name: CLIENT_NAME.EMPIRE,
                url: "/reports/cinema-reports/distributor-collection-report-v3",
              },
              {
                key_name: CLIENT_NAME.IRAQ,
                url: "/reports/cinema-reports/distributor-collection-report-v3",
              },
              {
                key_name: CLIENT_NAME.PETRO,
                url: "/reports/cinema-reports/distributor-collection-report-v3",
              },
              {
                key_name: CLIENT_NAME.QFX,
                url: "/reports/cinema-reports/distributor-collection-report-v5-qfx",
              },
              {
                key_name: CLIENT_NAME.LEBANON,
                url: "/reports/cinema-reports/distributor-collection-report-lebanon",
              },
              {
                key_name: CLIENT_NAME.CINEPOLIS_OMAN,
                url: "/reports/cinema-reports/distributor-report-cinepolis",
              },
              {
                key_name: CLIENT_NAME.EPIX,
                url: "/reports/cinema-reports/distributor-report-epix",
              },
              {
                key_name: CLIENT_NAME.CINEPOLIS_KSA,
                url: "/reports/cinema-reports/distributor-report-cinepolis",
              },
            ],
          },
          {
            name: "distributorSummary",
            url: "/reports/cinema-reports/distributor-summary",
            icon: "icon-arrow-right",
            description: "distributor_collection_dash_msg",
            permissions: [
              Role.SuperAdmin,
              Role.CinemaManager,
              Role.Distributor,
              Role.HoManager,
            ],
            module_id: 232,
            action: "read",
            resource: "Distributor Summary",
            only_available_on: [
              {
                key_name: CLIENT_NAME.CINEMA_AKIL,
                url: "/reports/cinema-reports/distributor-summary",
              },
              {
                key_name: CLIENT_NAME.CINEPOLIS_OMAN,
                url: "/reports/cinema-reports/distributor-report-cinepolis",
              },
              {
                key_name: CLIENT_NAME.CINEPOLIS_KSA,
                url: "/reports/cinema-reports/distributor-report-cinepolis",
              },
            ],
          },

          // /*
          {
            name: "distributorDetailedSummary",
            url: "/reports/cinema-reports/distributor-detailed-report",
            icon: "icon-arrow-right",
            description: "distributor_detailed_dash_msg",
            permissions: [
              Role.SuperAdmin,
              Role.CinemaManager,
              Role.Distributor,
              Role.HoManager,
            ],
            module_id: 272,
            action: "read",
            resource: "Distributor Detailed Report",
            only_visible_on: [
              {
                key_name: CLIENT_NAME.EMPIRE,
                url: "/reports/cinema-reports/distributor-detailed-report",
              },
              {
                key_name: CLIENT_NAME.IRAQ,
                url: "/reports/cinema-reports/distributor-detailed-report",
              },
              {
                key_name: CLIENT_NAME.PLAYCINEMA,
                url: "/reports/cinema-reports/distributor-detailed-report",
              },
            ],
          },
          // */
          {
            name: "Distributor Share Summary Report",
            url: "/reports/cinema-reports/distributor-share-summary-report",
            icon: "icon-arrow-right",
            description: "Distributor Share Summary Report",
            permissions: [
              Role.SuperAdmin,
              Role.CinemaManager,
              Role.Distributor,
              Role.HoManager,
            ],
            module_id: 326,
            action: "read",
            resource: "Distributor Share Summary Report",
          },
          {
            name: "Distributor Share Summary Week Wise Report",
            url: "/reports/cinema-reports/distributor-share-summary-week-wise-report",
            icon: "icon-arrow-right",
            description: "Distributor Share Summary Week Wise Report",
            permissions: [
              Role.SuperAdmin,
              Role.CinemaManager,
              Role.Distributor,
              Role.HoManager,
            ],
            module_id: 327,
            action: "read",
            resource: "Distributor Share Summary Week Wise Report",
          },
        ],
      },
      {
        name: "transactions",
        url: "/reports/transactions",
        icon: "icon-arrow-right",
        description: "transaction_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 34,
        action: "read",
        resource: "Transactions",
      },
      {
        name: "Reservations Log",
        url: "/reports/show-reservations",
        icon: "icon-arrow-right",
        description: "reservations_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 235,
        action: "read",
        resource: "Reservations Log",
      },
      {
        name: "unpaidBooking",
        url: "/reports/unpaid-bookings",
        icon: "icon-arrow-right",
        description: "unpaid_booking_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 198,
        action: "read",
        resource: "Unpaid Booking",
      },
      {
        name: "Call Center Bookings",
        url: "/reports/call-center-bookings",
        icon: "icon-arrow-right",
        description: "Call center bookings list",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 353,
        action: "read",
        resource: "Call Center Bookings",
      },
      {
        name: "Refund Analysis Report",
        // url: "/reports/transaction-refund-report",
        url: "/reports/transactions-refund-report",
        icon: "icon-arrow-right",
        description: "transaction_refund_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 27,
        action: "read",
        resource: "Refund Analysis Report",
      },
      {
        name: "Ticket Invoices",
        url: "/reports/ticket-invoices-report",
        icon: "icon-arrow-right",
        description: "Ticket Invoices",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 331,
        action: "read",
        resource: "Ticket Invoices",
      },
      {
        name: "Screens tax & vat overall Report",
        url: "/reports/screen-tax-vat-overall-report",
        icon: "icon-arrow-right",
        description: "Screens tax & vat overall Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 332,
        action: "read",
        resource: "Screens tax & vat overall Report",
      },
      {
        name: "Ticket Reprint Report",
        url: "/reports/ticket-reprint-report",
        icon: "icon-arrow-right",
        description: "Ticket Reprint Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 335,
        action: "read",
        resource: "Ticket Reprint Report",
      },
      {
        name: "Cinema Tax Overall Analysis Report",
        url: "/reports/cinema-tax-overall-analsysis-report",
        icon: "icon-arrow-right",
        description: "Cinema Tax Overall Analysis Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 333,
        action: "read",
        resource: "Cinema Tax Overall Analysis Report",
      },
           {
        name: "Distributor Share Report New",
        url: "/reports/distributor-share-report-new",
        icon: "icon-arrow-right",
        description: "Distributor Share Report New",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 333,
        action: "read",
        resource: "Distributor Share Report New",
      },
      {
        name: "Cinema Tax Screen Analysis Report",
        url: "/reports/cinema-tax-screen-analsysis-report",
        icon: "icon-arrow-right",
        description: "Cinema Tax Screen Analysis Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 336,
        action: "read",
        resource: "Cinema Tax Screen Analysis Report",
      },
      {
        name: "Cashier Settlement Report",
        url: "/reports/cashier-settlement-report",
        icon: "icon-arrow-right",
        description: "Cashier Settlement Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 338,
        action: "read",
        resource: "Cashier Settlement Report",
      },
      {
        name: "Cashier Analysis Report",
        url: "/reports/cashier-analysis-report",
        icon: "icon-arrow-right",
        description: "Cashier Analysis Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 338,
        action: "read",
        resource: "Cashier Analysis Report",
      },
      {
        name: "Swap and Transaction Refund Report",
        url: "/reports/swap-transaction-refund-report",
        icon: "icon-arrow-right",
        description: "Swap and transaction_refund_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 240,
        action: "read",
        resource: "Swap and Refund Transactions Report",
      },
      {
        name: "swapTransactions",
        url: "/reports/swap-transaction",
        icon: "icon-arrow-right",
        description: "swap_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 185,
        action: "read",
        resource: "Swap Transactions",
      },
      {
        name: "Staff Performance Report",
        url: "/reports/staff-performance-report",
        icon: "icon-arrow-right",
        description: "Staff Performance Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 302,
        action: "read",
        resource: "Staff Performance Report",
      },
      // {
      //   name: "F&B Sales Analysis Report",
      //   url: "/reports/fnb-sales-analysis-report",
      //   icon: "icon-arrow-right",
      //   description: "F&B Sales Analysis Report",
      //   permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
      //   module_id: 303,
      //   action: "read",
      //   resource: "F&B Sales Analysis Report",
      // },
      {
        name: "Offers-Vouchers Consumption Summary Report",
        url: "/reports/get-offers-vouchers-consumption-summary-report",
        icon: "icon-arrow-right",
        description: "Offers-Vouchers Consumption Summary Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 290,
        action: "read",
        resource: "Offers-Vouchers Consumption Summary Report",
      },
      // {
      //   name: "Get DCR And Performance Report",
      //   url: "/reports/getDCRPerformanceReport",
      //   icon: "icon-arrow-right",
      //   description: "Get DCR And Performance Report",
      //   permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
      //   module_id: 303,
      //   action: "read",
      //   resource: "Get DCR And Performance Report",
      // },
      {
        name: "DCR And Performance Report",
        url: "/reports/dcr-performance-report",
        icon: "icon-arrow-right",
        description: "DCR And Performance Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 290,
        action: "read",
        resource: "DCR And Performance Report",
      },
      {
        name: "Class Wise Seat Summary Report",
        url: "/reports/seat-classwise-sales-summary",
        icon: "icon-arrow-right",
        description: "Class Wise Seat Summary Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 290,
        action: "read",
        resource: "Class Wise Seat Summary Report",
      },
      {
        name: "Movie Wise Summary Report",
        url: "/reports/movie-wise-summary-report",
        icon: "icon-arrow-right",
        description: "Movie Wise Summary Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 290,
        action: "read",
        resource: "Movie Wise Summary Report",
      },
      {
        name: "Online & Offline Transaction Report",
        url: "/reports/online-offline-transactions-report",
        icon: "icon-arrow-right",
        description: "Online & Offline Transaction Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 288,
        action: "read",
        resource: "Online & Offline Transaction Report",
      },
      {
        id: 6,
        name: "movieReports",
        url: "",
        icon: "",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        isCollapsed: false,
        children: [
          {
            name: "movieanalytics",
            url: "/reports/movie-reports/movie-analytics",
            icon: "icon-arrow-right",
            description: "movie_analytics_dash_msg",
            permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
            module_id: 132,
            action: "read",
            resource: "Movie Analytics Report",
          },
          // {
          //   name: "filmwisecollectionreport",
          //   url: "/reports/movie-reports/film-wise-collection-report-v2",
          //   icon: "icon-arrow-right",
          //   description: "film_wise_collection_report_dash_msg",
          //   permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
          //   module_id: 96,
          //   action: "read",
          //   resource: "Film Wise Collection Report",
          //   only_available_on: [
          //     {
          //       key_name: CLIENT_NAME.CINEMA_AKIL,
          //       url: "/reports/movie-reports/film-wise-collection-report",
          //     },
          //   ],
          // },
          // {
          //   name: "Online Aggregators Transaction Report",
          //   url: "/reports/movie-reports/aggregators-report",
          //   icon: "icon-arrow-right",
          //   description: "aggregators_report_dash_msg",
          //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
          //   module_id: 99,
          //   action: "read",
          //   resource: "Aggregators Transactions Report",
          // },
          {
            name: "advancebookingreport",
            url: "/reports/movie-reports/advance-booking-report",
            icon: "icon-arrow-right",
            description: "advancebookingreport_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 108,
            action: "read",
            resource: "Advance Booking Report",
          },
        ],
      },
      {
        id: 6,
        name: "fandbReports",
        url: "",
        icon: "",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        isCollapsed: false,
        children: [
          {
            name: "fandbAnalytics",
            url: "/reports/fnb-reports/fnb-analytics",
            icon: "icon-arrow-right",
            description: "FandsBAnalytics_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 130,
            action: "read",
            resource: "F&B Analytics",
          },
          {
            name: "F&B Category Analytics",
            url: "/reports/fnb-reports/fnb-category-analytics",
            icon: "icon-arrow-right",
            description: "FandsBAnalyticsCategory_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 130,
            action: "read",
            resource: "F&B Analytics",
            only_visible_on: [
              {
                key_name: CLIENT_NAME.STAR,
              },
              {
                key_name: CLIENT_NAME.WOW,
              },
            ],
          },
          {
            name: "Fnbtransactions",
            url: "/reports/fnb-reports/fnb-transactions",
            icon: "icon-arrow-right",
            description: "Fnbtransaction_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 162,
            action: "read",
            resource: "F&B Transactions",
          },
          {
            name: "F&B App orders",
            url: "/reports/fnb-reports/fnb-orders",
            icon: "icon-arrow-right",
            description: "Fnborders_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 163,
            action: "read",
            resource: "F&B App Orders",
          },
          {
            name: "Recipe Report",
            url: "/reports/fnb-reports/recipe-report",
            icon: "icon-arrow-right",
            description: "receipereport_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 101,
            action: "read",
            resource: "Receipe Report",
          },
          // {
          //   name: "fastmovingreport",
          //   url: "/reports/fnb-reports/fast-moving-report",
          //   icon: "icon-arrow-right",
          //   description: "fastmovingreport_dash_msg",
          //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
          //   module_id: 102,
          //   action: "read",
          //   resource: "Fast Moving Report",
          // },
          {
            name: "concessiondailyReport",
            url: "/reports/fnb-reports/concession-daily-report",
            icon: "icon-arrow-right",
            description: "concessiondailyReport_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 103,
            action: "read",
            resource: "Concession Daily Report",
          },
          // {
          //   name: "cogsReport",
          //   url: "/reports/fnb-reports/cogs-report",
          //   icon: "icon-arrow-right",
          //   description: "cogsReport_dash_msg",
          //   permissions: [
          //     Role.SuperAdmin,
          //     Role.HoManager,
          //     Role.CinemaManager,
          //   ],
          //   module_id: 104,
          //   action: "read",
          //   resource: "COGS Report",
          // },
          {
            name: "COGS Report",
            url: "/reports/fnb-reports/cogs-report-v2",
            icon: "icon-arrow-right",
            description: "cogsReport_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 104,
            action: "read",
            resource: "COGS Report",
          },
          {
            name: "Food Cost Report",
            url: "/reports/fnb-reports/food-cost-report",
            icon: "icon-arrow-right",
            description: "food Cost",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 300,
            action: "read",
            resource: "Food Cost Report",
          },
              {
                        name: "3D Glass Report",
                        url: "/reports/fnb-reports/3d-glass-report",
                        icon: "icon-arrow-right",
                        description: "3D Glass Report",
                        permissions: [
                          Role.SuperAdmin,
                          Role.HoManager,
                          Role.CinemaManager,
                        ],
                        module_id: 300,
                        action: "read",
                        resource: "3D Glass Report",
                      },
          {
            name: "Cash Drawer - Manual Opening Logs",
            url: "/reports/cash-drawer-logs-report",
            icon: "icon-arrow-right",
            description: "Cahs Drower Logs Report",
            permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
            module_id: 304,
            action: "read",
            resource: "Cahs Drower Logs Report",
          },
          {
            name: "stockwastageReport",
            url: "/reports/fnb-reports/stock-wastage-report",
            icon: "icon-arrow-right",
            description: "stockwastageReport_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 105,
            action: "read",
            resource: "Stock Wastage Report",
          },
          {
            name: "currentStockReport",
            url: "/reports/fnb-reports/current-stock-report",
            icon: "icon-arrow-right",
            description: "currentStockReport_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 106,
            action: "read",
            resource: "Current Stock Report",
          },
          {
            name: "Payment Typeswise Sales Report",
            url: "/reports/fnb-reports/municipality-report",
            icon: "icon-arrow-right",
            description: "municipalityReport_dash_msg",
            keywords: ["typewise sales report"],
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 107,
            action: "read",
            resource: "Payment Typeswise Sales Report",
          },
          {
            name: "expiryreport",
            url: "/reports/fnb-reports/expiry-report",
            icon: "icon-arrow-right",
            description: "expiryreport_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 137,
            action: "read",
            resource: "Expiry Report",
          },
          {
            name: "addonsreport",
            url: "/reports/fnb-reports/add-ons-report",
            icon: "icon-arrow-right",
            description: "addonsreport_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 177,
            action: "read",
            resource: "Add Ons Report",
          },
          {
            name: "customizationreport",
            url: "/reports/fnb-reports/customization-report",
            icon: "icon-arrow-right",
            description: "customizationreport_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 179,
            action: "read",
            resource: "Customization Report",
          },
        ],
      },
    ],
  },

  {
    id: 7,
    name: "marketing",
    url: "/marketing-master",
    icon: "icon-marketing",
    permissions: [],
    isCollapsed: false,
    children: [
      // {
      //   name: "E-Wallet",
      //   url: "/marketing/e-wallet",
      //   icon: "icon-arrow-right",
      //   description: "eWallet_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 243,
      //   action: "read",
      //   resource: "E-Wallet",
      // },
      // {
      //   name: "movie_pass",
      //   url: "/cinema-manager/movie-pass",
      //   icon: "icon-arrow-right",
      //   description: "ratecardgroup_dash_msg",
      //   keywords: ["Movie", "Pass", "Gift", "Card", "Membership"],
      //   permissions: [
      //     Role.SuperAdmin,
      //     Role.HoManager,
      //     Role.CinemaManager,
      //   ],
      //   module_id: 282,
      //   action: "read",
      //   resource: "Movie Pass",
      // },
      // {
      //   name: "Merchandise",
      //   keywords: ["Merchandise", "tshi"],
      //   url: "/cinema-manager/merchandise",
      //   icon: "icon-arrow-right",
      //   description: "checklists_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 313,
      //   action: "read",
      //   only_visible_on: [
      //     {
      //       key_name: CLIENT_NAME.CINEMA_AKIL,
      //     },
      //     {
      //       key_name: CLIENT_NAME.STAR,
      //     },
      //   ],
      //   resource: "Merchandise",
      // },
      // {
      //   name: "Cash Cards",
      //   url: "/marketing/cash-cards",
      //   icon: "icon-arrow-right",
      //   description: "cashcards_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 159,
      //   action: "read",
      //   resource: "Cash Cards",
      // },
      // {
      //   name: "Cash Card Gallery",
      //   url: "/marketing/list-cash-cards-gallery",
      //   icon: "icon-arrow-right",
      //   description: "cashcards_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 228,
      //   action: "read",
      //   resource: "Cash Card Gallery",
      // },
      {
        id: 7,
        name: "Courtsey",
        url: "",
        icon: "icon-arrow-right",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        isCollapsed: false,
        children: [
          {
            name: "Courtsey Users",
            url: "/marketing/courtsey-users",
            icon: "icon-arrow-right",
            description: "Fnb Courtsey Report",
            keywords: ["courtsey", "Courstey", "fnb", "Report"],
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 343,
            action: "read",
            resource: "Fnb Courtsey Report",
          },
          {
            name: "Courtsey Groups",
            url: "/marketing/courtsey-groups",
            icon: "icon-arrow-right",
            description: "Fnb Courtsey Report",
            keywords: ["courtsey", "Courstey", "fnb", "Report"],
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 343,
            action: "read",
            resource: "Fnb Courtsey Report",
          },
        ],
      },
      // {
      //   name: "CMS Pages",
      //   url: "/marketing/list-pages",
      //   icon: "icon-arrow-right",
      //   description: "pages_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 229,
      //   action: "read",
      //   resource: "CMS Pages",
      // },
      {
        id: 20,
        name: "Content Management",
        url: "",
        icon: "icon-marketing",
        permissions: [],
        isCollapsed: false,
        children: [
          {
            name: "CMS Pages",
            url: "/content-management/list-pages",
            icon: "icon-arrow-right",
            description: "pages_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 229,
            action: "read",
            resource: "CMS Pages",
          },
        ],
      },
      {
        name: "Offer Group Type",
        url: "/marketing/offer-group-type",
        icon: "icon-arrow-right",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        description: "Grouping for offers",
        module_id: 296,
        action: "read",
        resource: "Offer Group Type",
      },
      {
        name: "Promotions & Offers",
        url: "/marketing/promotions-and-offers",
        icon: "icon-arrow-right",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        description: "promotionsandoffer_dash_msg",
        module_id: 109,
        action: "read",
        resource: "Promotions & Offers",
      },
      // {
      //   name: "voucher",
      //   url: "/marketing/vouchers",
      //   icon: "icon-arrow-right",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   description: "voucher_dash_msg",
      //   module_id: 110,
      //   action: "read",
      //   resource: "Vouchers",
      // },
      {
        name: "Vouchers",
        url: "/vouchers/get-vouchers-v2",
        icon: "icon-arrow-right",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        description: "voucher_dash_msg",
        module_id: 110,
        action: "read",
        resource: "Vouchers",
      },
      {
        name: "Customer Loyalty Points",
        url: "/marketing/customer-loyalty-points",
        icon: "icon-arrow-right",
        description: "customerloyaltypoints_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 112,
        action: "read",
        resource: "Customer Loyalty Points",
      },
      // {
      //   name: "Loyalty Logs",
      //   url: "/marketing/loyalty-logs",
      //   icon: "icon-arrow-right",
      //   description: "Upp Loyalty Logs",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 297,
      //   action: "read",
      //   resource: "Loyalty Logs",
      // },
      {
        name: "Global Loyalty Settings",
        url: "/marketing/global-loyalty-settings",
        icon: "icon-arrow-right",
        description: "globalloyaltysettings_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 113,
        action: "read",
        resource: "Global Loyalty Settings",
      },
      {
        name: "Cinema Loyalty Settings",
        url: "/marketing/cinema-loyalty-settings",
        icon: "icon-arrow-right",
        description: "cinemaloyaltysetting_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 114,
        action: "read",
        resource: "Cinema Loyalty Settings",
      },
      // {
      //   name: "Loyalty",
      //   url: "/marketing/loyalty",
      //   icon: "icon-arrow-right",
      //   description: "Loyalty",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 111,
      //   action: "read",
      //   resource: "Loyalty",
      // },
      {
        name: "Bank",
        url: "/marketing/bank",
        icon: "icon-arrow-right",
        description: "bank_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 115,
        action: "read",
        resource: "Bank",
      },
      // {
      //   name: "institution",
      //   url: "/marketing/institution",
      //   icon: "icon-arrow-right",
      //   description: "institution_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 116,
      //   action: "read",
      //   resource: "Institution",
      // },
      {
        name: "Offer Types",
        url: "/marketing/offer-types",
        icon: "icon-arrow-right",
        description: "offertypes_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 117,
        action: "read",
        resource: "Offer Types",
      },
      {
        name: "Bin Numbers",
        url: "/marketing/bin-Numbers",
        icon: "icon-arrow-right",
        description: "binnumbers_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 118,
        action: "read",
        resource: "Bin Numbers",
      },
      {
        name: "customer",
        url: "/marketing/customers",
        icon: "icon-arrow-right",
        description: "customer_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 119,
        action: "read",
        resource: "customer",
      },
      {
        name: "Card Type",
        url: "/marketing/card-type",
        icon: "icon-arrow-right",
        description: "cardtype_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 120,
        action: "read",
        resource: "Card Type",
      },
      // {
      //   name: "referral-code",
      //   url: "/master/referral-code",
      //   icon: "icon-arrow-right",
      //   description: "referralCode_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 194,
      //   action: "read",
      //   resource: "Referral",
      // },
      // {
      //   name: "Merchandise Vouchers",
      //   url: "/vouchers/get-vouchers-merch",
      //   icon: "icon-arrow-right",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   description: "voucher_dash_msg",
      //   module_id: 313,
      //   action: "read",
      //   resource: "Vouchers",
      //   only_visible_on: [
      //     {
      //       key_name: CLIENT_NAME.CINEMA_AKIL,
      //     },
      //   ],
      // },
      {
        name: "Customers Verification",
        url: "/marketing/customers_verification",
        icon: "icon-arrow-right",
        description: "customers_verification",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 322,
        action: "read",
        resource: "customers_verification",
      },
    ],
  },
  {
    id: 14,
    name: "List of Pages",
    url: "/pages",
    icon: "icon-marketing",
    permissions: [],
    isCollapsed: false,
    only_visible_on: [
      {
        key_name: CLIENT_NAME.EMPIRE,
      },
      {
        key_name: CLIENT_NAME.IRAQ,
      },
      {
        key_name: CLIENT_NAME.BILDHAUS,
      },
      {
        key_name: CLIENT_NAME.STAR,
      },
      {
        key_name: CLIENT_NAME.WOW,
      },
      {
        key_name: CLIENT_NAME.CINEMA_AKIL,
      },
    ],
    children: [
      {
        name: "View List Of Pages",
        url: "/pages/view-list-of-pages",
        icon: "icon-arrow-right",
        description: "View List of Pages",
        keywords: ["view list of pages"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 208,
        action: "read",
        resource: "View List of Pages",
        only_available_on: [
          {
            key_name: CLIENT_NAME.EMPIRE,
            url: "/pages/view-list-of-pages",
          },
          {
            key_name: CLIENT_NAME.IRAQ,
            url: "/pages/view-list-of-pages",
          },
          {
            key_name: CLIENT_NAME.BILDHAUS,
            url: "/pages/view-list-of-pages",
          },
          {
            key_name: CLIENT_NAME.STAR,
            url: "/pages/view-list-of-pages",
          },
          {
            key_name: CLIENT_NAME.WOW,
            url: "/pages/view-list-of-pages",
          },
          {
            key_name: CLIENT_NAME.CINEMA_AKIL,
            url: "/pages/view-list-of-pages",
          },
        ],
      },
      {
        name: "List Of Pages",
        url: "/pages/list-of-pages",
        icon: "icon-arrow-right",
        description: "List of Pages",
        keywords: ["add list of pages"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 207,
        action: "read",
        resource: "List Of Pages",
        only_available_on: [
          {
            key_name: CLIENT_NAME.EMPIRE,
            url: "/pages/list-of-pages",
          },
          {
            key_name: CLIENT_NAME.IRAQ,
            url: "/pages/list-of-pages",
          },
          {
            key_name: CLIENT_NAME.BILDHAUS,
            url: "/pages/list-of-pages",
          },
          {
            key_name: CLIENT_NAME.STAR,
            url: "/pages/list-of-pages",
          },
          {
            key_name: CLIENT_NAME.WOW,
            url: "/pages/list-of-pages",
          },
          {
            key_name: CLIENT_NAME.CINEMA_AKIL,
            url: "/pages/list-of-pages",
          },
        ],
      },
    ],
  },
  {
    id: 15,
    name: "Pop Up Pages",
    url: "/pop-up-pages",
    icon: "icon-marketing",
    permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
    isCollapsed: false,

    only_visible_on: [
      {
        key_name: CLIENT_NAME.EMPIRE,
      },
      {
        key_name: CLIENT_NAME.IRAQ,
      },
      {
        key_name: CLIENT_NAME.STAR,
      },
      {
        key_name: CLIENT_NAME.WOW,
      },
      {
        key_name: CLIENT_NAME.BILDHAUS,
      },
      {
        key_name: CLIENT_NAME.CINEMA_AKIL,
      },
    ],
    only_available_on: [
      {
        key_name: CLIENT_NAME.EMPIRE,
        url: "/pop-up-pages/get-popup-pages",
      },
      {
        key_name: CLIENT_NAME.IRAQ,
        url: "/pop-up-pages/get-popup-pages",
      },
      {
        key_name: CLIENT_NAME.BILDHAUS,
        url: "/pop-up-pages/get-popup-pages",
      },
      {
        key_name: CLIENT_NAME.STAR,
        url: "/pop-up-pages/get-popup-pages",
      },
      {
        key_name: CLIENT_NAME.WOW,
        url: "/pop-up-pages/get-popup-pages",
      },
      {
        key_name: CLIENT_NAME.CINEMA_AKIL,
        url: "/pop-up-pages/get-popup-pages",
      },
    ],
    children: [
      {
        name: "Add Pop Up Pages",
        url: "/pop-up-pages/add-popup-page",
        icon: "icon-arrow-right",
        description: "Pop Up pages",
        keywords: ["add list of pop up pages"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 209,
        action: "read",
        resource: "Add Pop Up Pages",
        only_available_on: [
          {
            key_name: CLIENT_NAME.EMPIRE,
            url: "/pop-up-pages/add-popup-page",
          },
          {
            key_name: CLIENT_NAME.IRAQ,
            url: "/pop-up-pages/add-popup-page",
          },
          {
            key_name: CLIENT_NAME.BILDHAUS,
            url: "/pop-up-pages/add-popup-page",
          },
          {
            key_name: CLIENT_NAME.STAR,
            url: "/pop-up-pages/add-popup-page",
          },
          {
            key_name: CLIENT_NAME.WOW,
            url: "/pop-up-pages/add-popup-page",
          },
          {
            key_name: CLIENT_NAME.CINEMA_AKIL,
            url: "/pop-up-pages/add-popup-page",
          },
        ],
      },
      {
        name: "View Pop Up Pages",
        url: "/pop-up-pages/get-popup-pages",
        icon: "icon-arrow-right",
        description: "Pop Up pages",
        keywords: ["get list of pop up pages"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 210,
        action: "read",
        resource: "View Pop Up Pages",
        only_available_on: [
          {
            key_name: CLIENT_NAME.EMPIRE,
            url: "/pop-up-pages/get-popup-pages",
          },
          {
            key_name: CLIENT_NAME.IRAQ,
            url: "/pop-up-pages/get-popup-pages",
          },
          {
            key_name: CLIENT_NAME.BILDHAUS,
            url: "/pop-up-pages/get-popup-pages",
          },
          {
            key_name: CLIENT_NAME.STAR,
            url: "/pop-up-pages/get-popup-pages",
          },
          {
            key_name: CLIENT_NAME.WOW,
            url: "/pop-up-pages/get-popup-pages",
          },
          {
            key_name: CLIENT_NAME.CINEMA_AKIL,
            url: "/pop-up-pages/get-popup-pages",
          },
        ],
      },
    ],
  },
  {
    id: 16,
    name: "Qr Code",
    url: "/qr-code",
    icon: "icon-marketing",
    permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
    isCollapsed: false,

    only_visible_on: [
      {
        key_name: CLIENT_NAME.EMPIRE,
      },
      {
        key_name: CLIENT_NAME.IRAQ,
      },
      {
        key_name: CLIENT_NAME.BILDHAUS,
      },
      {
        key_name: CLIENT_NAME.STAR,
      },
      {
        key_name: CLIENT_NAME.WOW,
      },
      {
        key_name: CLIENT_NAME.CINEMA_AKIL,
      },
    ],

    children: [
      {
        name: "QR Code List",
        url: "/qr-code/list-qr-codes",
        icon: "icon-arrow-right",
        description: "qr code pages",
        keywords: ["qr code"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 211,
        action: "read",
        resource: "QR Code List",
        only_available_on: [
          {
            key_name: CLIENT_NAME.EMPIRE,
            url: "/qr-code/list-qr-codes",
          },
          {
            key_name: CLIENT_NAME.IRAQ,
            url: "/qr-code/list-qr-codes",
          },
          {
            key_name: CLIENT_NAME.BILDHAUS,
            url: "/qr-code/list-qr-codes",
          },
          {
            key_name: CLIENT_NAME.STAR,
            url: "/qr-code/list-qr-codes",
          },
          {
            key_name: CLIENT_NAME.WOW,
            url: "/qr-code/list-qr-codes",
          },
          {
            key_name: CLIENT_NAME.CINEMA_AKIL,
            url: "/qr-code/list-qr-codes",
          },
        ],
      },
    ],
  },
];
const localNavItems = [
  {
    name: "Home",
    url: "/home",
    icon: "icon-home",
    show: true,
    isCollapsed: false,
    children: [
      {
        name: "Home",
        url: "/home/homepage",
        icon: "icon-arrow-right",

        description: "home_page_msg",
        show: true,
        // action: "read",
        // resource: "",
      },
      // {
      //   name: 'Setup',
      //   url: '/setup/welcome',
      //   icon: 'icon-arrow-right'
      // },
    ],
  },

  /**
   * USER MANAGEMENT START
   */

  {
    id: 1,
    name: "user_management",
    url: "/user-management",
    icon: "icon-master",
    permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
    isCollapsed: false,
    children: [
      {
        name: "user",
        url: "/user-management/users",
        icon: "icon-arrow-right",
        description: "user_dash_msg",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 1,
        action: "read",
        resource: "Users",
      },
      {
        name: "Aggregator User",
        url: "/user-management/aggregator-users",
        icon: "icon-arrow-right",
        description: "aggregatoruser_dash_msg",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 2,
        action: "read",
        resource: "Aggregator User",
      },
      {
        name: "Roles",
        url: "/user-management/roles-list",
        icon: "icon-arrow-right",
        description: "role_dash_msg",
        permissions: [Role.SuperAdmin],
        module_id: 3,
        action: "read",
        resource: "Roles",
      },
      {
        name: "designation",
        url: "/user-management/designations",
        icon: "icon-arrow-right",
        description: "designation_dash_msg",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 4,
        action: "read",
        resource: "Designations",
      },
      {
        name: "department",
        url: "/user-management/list-department",
        icon: "icon-arrow-right",
        description: "department_msg",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 5,
        action: "read",
        resource: "Department",
      },
      {
        name: "gender",
        url: "/user-management/genders",
        icon: "icon-arrow-right",
        description: "gender_dash_msg",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 6,
        action: "read",
        resource: "Gender",
      },
      {
        name: "martialstatus",
        url: "/user-management/marital-status",
        icon: "icon-arrow-right",
        description: "marital_dash_msg",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 7,
        action: "read",
        resource: "Marital Status",
      },
      {
        name: "userAuditLog",
        url: "/user-management/user-audit-log",
        icon: "icon-arrow-right",
        description: "userAuditLog_dash_msg",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 9,
        action: "read",
        resource: "User Audit Log",
      },
      {
        name: "App Report Users",
        url: "/user-management/app-report-users",
        icon: "icon-arrow-right",
        description: "App Report Users",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 298,
        action: "read",
        resource: "App Report Users",
      },
      {
        id: 1,
        name: "shifts",
        url: "",
        icon: "icon-arrow-right",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        isCollapsed: false,
        // action: "read",
        // resource: "Shifts",
        children: [
          {
            name: "shifts",
            url: "/cinema-manager/shifts",
            icon: "icon-arrow-right",
            description: "shift_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 11,
            action: "read",
            resource: "Shifts",
          },
          {
            name: "User Shifts",
            url: "/cinema-manager/user-shifts",
            icon: "icon-arrow-right",
            description: "user_shift_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 13,
            action: "read",
            resource: "User Shift",
          },
          {
            name: "Shift Close",
            url: "/cinema-manager/shifts-close",
            icon: "icon-arrow-right",
            description: "shiftclose_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 24,
            action: "read",
            resource: "Shifts",
          },
        ],
      },
    ],
  },

  /**
   * USER MANAGEMENT END
   */

  /**
   * Exhibitor MANAGEMENT START
   */

  {
    id: 2,
    name: "exhibitor_management",
    url: "/exhibitor-management",
    icon: "icon-cinema-management",
    permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
    isCollapsed: false,
    children: [
      // {
      //   name: "aggregator_user",
      //   url: "/user-management/aggregator-users",
      //   icon: "icon-arrow-right",
      //   description: "aggregatoruser_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
      //   module_id: 2,
      // },
      // {
      //   name: "Aggregators",
      //   url: "/cinema-manager/aggregators",
      //   icon: "icon-arrow-right",
      //   description: "checklists_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 143,
      //   action: "read",
      //   resource: "Checklists",
      // },
      {
        name: "View Rate Card Group",
        url: "/cinema-manager/view-rate-card-group",
        icon: "icon-arrow-right",
        description: "checklists_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 166,
        action: "read",
        resource: "Checklists",
      },
      {
        name: "Access Rights For Schedule",
        url: "/cinema-manager/access-rights-for-schedule",
        icon: "icon-arrow-right",
        description: "schedule_access_msg",
        keywords: ["access", "rights"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 12,
        action: "read",
        resource: "Access Rights For Schedule",
      },
      {
        name: "salesChannelForFoodAndBeverages",
        url: "/cinema-manager/access-rights-for-fnb",
        icon: "icon-arrow-right",
        keywords: ["access", "rights"],
        description: "fnb_access_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 186,
        action: "read",
        resource: "Access Rights For FnB",
      },
      {
        name: "scheduleList",
        url: "/cinema-manager/schedule-comments",
        icon: "icon-arrow-right",
        description: "schedule_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 141,
        action: "read",
        resource: "Schedule",
      },
      {
        name: "movie",
        url: "/cinema-manager/movies",
        icon: "icon-arrow-right",
        description: "movie_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 14,
        action: "read",
        resource: "Movies",
      },
      {
        name: "Movie Rate Card",
        url: "/cinema-manager/movie-rate-card",
        icon: "icon-arrow-right",
        description: "manageMovieRateCardHere",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 197,
        action: "read",
        resource: "Movie Rate Card",
      },
      {
        name: "Cinema Settings",
        url: "/cinema-manager/cinema-settings",
        icon: "icon-arrow-right",
        description: "cinemasettings_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 15,
        action: "read",
        resource: "Cinema Settings",
      },
      {
        name: "cinemas",
        url: "/cinema-manager/cinemas",
        icon: "icon-arrow-right",
        description: "cinema_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 16,
        action: "read",
        resource: "Cinemas",
      },
      {
        name: "Cinema FnB App Qrcodes",
        url: "/cinema-manager/cinema-fnb-app-qrcode",
        icon: "icon-arrow-right",
        description: "cinema_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 259,
        action: "read",
        resource: "Cinema FnB App Qrcodes",
      },
      {
        name: "screen",
        url: "/cinema-manager/screens",
        icon: "icon-arrow-right",
        description: "screen_dash_msg",
        keywords: ["auditorium", "hall"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 17,
        action: "read",
        resource: "Screens",
      },
      {
        name: "screentype",
        url: "/cinema-manager/screen-type",
        icon: "icon-arrow-right",
        keywords: ["auditorium", "hall"],
        description: "screentype_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 171,
        action: "read",
        resource: "Screen Type",
      },
      {
        name: "screensizeformat",
        url: "/cinema-manager/screen-size-format",
        icon: "icon-arrow-right",
        keywords: ["auditorium", "hall"],
        description: "screensize_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 172,
        action: "read",
        resource: "Screen Size Format",
      },
      {
        name: "seatLayout",
        url: "/cinema-manager/seat-layout",
        icon: "icon-arrow-right",
        description: "seatlayout_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 18,
        action: "read",
        resource: "Seat Layout",
      },
      {
        name: "Manage Broken Seats",
        url: "/cinema-manager/manage-broken-seat",
        icon: "icon-arrow-right",
        description: "seatlayout_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 329,
        action: "read",
        resource: "Manage Broken Seats",
      },
      {
        id: 2,
        name: "ticketPricing",
        url: "",
        icon: "icon-arrow-right",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        isCollapsed: false,
        children: [
          {
            name: "Tax Settings",
            url: "/cinema-manager/tax-settings",
            icon: "icon-arrow-right",
            description: "chargesettings_dash_msg",
            keywords: ["GST", "gst", "VAT", "vat", "price", "Tax", "tax"],
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 19,
            action: "read",
            resource: "Charge Settings",
          },
          {
            name: "privateRateCardGroup",
            url: "/cinema-manager/list-private-rate-card",
            icon: "icon-arrow-right",
            description: "ratecardgroup_dash_msg",
            keywords: ["Private", "rate", "Card", "Group"],
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 188,
            action: "read",
            resource: "Private Rate Card",
          },
          {
            name: "Movie Addon Charges",
            url: "/cinema-manager/addon_charges",
            icon: "icon-arrow-right",
            description: "Addon_charges_dash_msg",
            keywords: ["Addon", "charges", "taxes", "custom"],
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 233,
            action: "read",
            resource: "Movie Addon Charges",
          },
          {
            name: "Tax Types",
            url: "/master/tax-types",
            icon: "icon-arrow-right",
            description: "chargetypes_dash_msg",
            keywords: ["GST", "gst", "VAT", "vat", "Tax", "tax"],
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 45,
            action: "read",
            resource: "Charge Types",
          },
        ],
      },
      {
        name: "manualBillingCategories",
        url: "/cinema-manager/billing-categories",
        icon: "icon-arrow-right",
        description: "mbCAtegories_dash_msg",
        keywords: ["categories", "manual bill", "billings", "bill"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 270,
        only_visible_on: [
          {
            key_name: CLIENT_NAME.QFX,
          },
          {
            key_name: CLIENT_NAME.EPIX,
          },
          {
            key_name: CLIENT_NAME.EMPIRE,
          },
        ],
        action: "read",
        resource: "Manual Bill Categories",
      },
      {
        name: "manualBillingItems",
        url: "/cinema-manager/billing-items",
        icon: "icon-arrow-right",
        description: "mbItems_dash_msg",
        keywords: ["items", "manual bill", "billings", "bill", "manual items"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 269,
        only_visible_on: [
          {
            key_name: CLIENT_NAME.QFX,
          },
          {
            key_name: CLIENT_NAME.EPIX,
          },
          {
            key_name: CLIENT_NAME.EMPIRE,
          },
        ],
        action: "read",
        resource: "Manual Bill Items",
      },
      {
        name: "manual_bill",
        url: "/cinema-manager/manual-bill",
        icon: "icon-arrow-right",
        description: "manual_bill_dash",
        keywords: ["manual bill", "billings", "bill", "manual", "DTA"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 271,
        only_visible_on: [
          {
            key_name: CLIENT_NAME.QFX,
          },
          {
            key_name: CLIENT_NAME.EPIX,
          },
          {
            key_name: CLIENT_NAME.EMPIRE,
          },
        ],
        action: "read",
        resource: "Manual Bill",
      },
      {
        name: "Manual Bills",
        url: "/cinema-manager/bill-transactions",
        icon: "icon-arrow-right",
        description: "manual_bill_trx_dash",
        keywords: [
          "manual bill",
          "billings",
          "bill",
          "manual",
          "DTA",
          "manual bills",
          "bill transactions",
        ],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 268,
        only_visible_on: [
          {
            key_name: CLIENT_NAME.QFX,
          },
          {
            key_name: CLIENT_NAME.EPIX,
          },
          {
            key_name: CLIENT_NAME.EMPIRE,
          },
        ],
        action: "read",
        resource: "Manual Bill Report",
      },
      // {
      //   name: "credit_note",
      //   url: "/cinema-manager/credit-note",
      //   icon: "icon-arrow-right",
      //   description: "credit_note_dash",
      //   keywords: ["credit note", "notes", "credit", "refund", "DTA"],
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 305,
      //   only_visible_on: [
      //     {
      //       key_name: CLIENT_NAME.QFX,
      //     },
      //   ],
      //   action: "read",
      //   resource: "Credit Notes",
      // },
      {
        name: "schedule",
        url: "/cinema-manager/view-schedule",
        icon: "icon-arrow-right",
        description: "view_schedule_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 21,
        action: "read",
        resource: "Schedule",
      },
      {
        name: "schedulebeta",
        url: "/cinema-manager/view-schedule-beta",
        icon: "icon-arrow-right",
        description: "view_schedule_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 21,
        action: "read",
        resource: "Schedule",
      },
      {
        name: "Schedule Overview",
        url: "/cinema-manager/view-schedule-overview",
        icon: "icon-arrow-right",
        description: "view_schedule_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 21,
        action: "read",
        resource: "Schedule",
      },
      {
        name: "Scheduled Movies Order",
        url: "/cinema-manager/scheduled-movies-order",
        icon: "icon-arrow-right",
        description: "Scheduled Movies Order",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 21,
        action: "read",
        resource: "Schedule",
      },
      {
        name: "plannedschedule",
        url: "/cinema-manager/view-planned-schedule",
        icon: "icon-arrow-right",
        description: "plannedschedule_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 140,
        action: "read",
        resource: "Planned Schedule",
      },
      {
        name: "Reserved Seats",
        url: "/cinema-manager/reserve-seats-list",
        icon: "icon-arrow-right",
        description: "reserveseats_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 22,
        action: "read",
        resource: "Reserve Seats",
      },
      // {
      //   name: "Reserved Seats",
      //   url: "/cinema-manager/reserve-seats",
      //   icon: "icon-arrow-right",
      //   description: "reserveseats_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 22,
      //   action: "read",
      //   resource: "Reserve Seats",
      // },
      {
        name: "Back Office Booking",
        url: "/cinema-manager/past-booking",
        icon: "icon-arrow-right",
        description: "reserveseats_dash_msg",
        keywords: [
          "back",
          "back office",
          "bookings",
          "past",
          "Past Bookings",
          "Back Office Booking",
          "Book",
        ],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 196,
        action: "read",
        resource: "Back Office Booking",
      },

      {
        name: "floatAmount",
        url: "/cinema-manager/float-amount",
        icon: "icon-arrow-right",
        description: "floatamount_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 23,
        action: "read",
        resource: "Float Amount",
      },
      {
        name: "makeARefund",
        url: "/cinema-manager/make-a-refund",
        icon: "icon-arrow-right",
        description: "makearefund_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.OnlineSupport],
        module_id: 25,
        action: "read",
        resource: "Make A Refund",
      },

      {
        name: "Payment Gateway Refund",
        url: "/cinema-manager/payment-gateway-refund",
        icon: "icon-arrow-right",
        description: "Payment Gateway Refund",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.OnlineSupport],
        keywords: ["refund", "payment", "gateway"],
        module_id: 25,
        action: "read",
        resource: "Make A Refund",
        only_available_on: [
          ...Object.keys(CLIENT_NAME)
            .map((x) => CLIENT_NAME[x])
            .filter((x) => x !== CLIENT_NAME.EMPIRE)
            .filter((x) => x !== CLIENT_NAME.QFX)
            .filter((x) => x !== CLIENT_NAME.STAR)
            .filter((x) => x !== CLIENT_NAME.CINEPOLIS_OMAN)
            .filter((x) => x !== CLIENT_NAME.CINEPOLIS_KSA)
            .filter((x) => x !== CLIENT_NAME.EPIX)
            .filter((x) => x !== CLIENT_NAME.MIF)
            .map((x) => {
              return {
                key_name: x,
                url: "/reports/show-reservations",
              };
            }),

          {
            key_name: CLIENT_NAME.EMPIRE,
            url: "/cinema-manager/payment-gateway-refund",
          },
          {
            key_name: CLIENT_NAME.QFX,
            url: "/cinema-manager/payment-gateway-refund",
          },
          {
            key_name: CLIENT_NAME.STAR,
            url: "/cinema-manager/star-payment-gateway-refund",
          },
          {
            key_name: CLIENT_NAME.CINEPOLIS_OMAN,
            url: "/cinema-manager/cinepolis-payment-gateway-refund",
          },
          {
            key_name: CLIENT_NAME.CINEPOLIS_KSA,
            url: "/cinema-manager/cinepolis-payment-gateway-refund",
          },
          {
            key_name: CLIENT_NAME.EPIX,
            url: "/cinema-manager/epix-payment-gateway-refund",
          },
          {
            key_name: CLIENT_NAME.WOW,
            url: "/cinema-manager/star-payment-gateway-refund",
          },
          {
            key_name: CLIENT_NAME.MIF,
            url: "/cinema-manager/payment-gateway-refund",
          },
        ],
      },
      {
        name: "showrefund",
        url: "/cinema-manager/show-refund",
        icon: "icon-arrow-right",
        description: "showrefund_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.OnlineSupport],
        module_id: 26,
        action: "read",
        resource: "Show Refund",
      },
      {
        name: "hardwareSettings",
        url: "/cinema-manager/hardware-settings",
        icon: "icon-arrow-right",
        description: "hardwaresettings_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 31,
        action: "read",
        resource: "Hardware Settings",
      },
      {
        name: "Ticket Type",
        url: "/master/ticket-type",
        icon: "icon-arrow-right",
        description: "ticket_type_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 165,
        action: "read",
        resource: "Ticket Type",
      },

      {
        name: "Audit Logs",
        url: "/cinema-manager/fnb-audit-logs",
        icon: "icon-arrow-right",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        isCollapsed: false,
        children: [
          // {
          //   name: "Fnb Audit Logs",
          //   url: "/cinema-manager/fnb-audit-logs",
          //   icon: "icon-arrow-right",
          //   description: "fnbauditlogs_dash_msg",
          //   permissions: [
          //     Role.SuperAdmin,
          //     Role.HoManager,
          //     Role.CinemaManager,
          //   ],
          //   module_id: 147,
          //   action: "read",
          //   resource: "F&B Audit Log",
          // },
          {
            name: "scheduleauditlogs",
            url: "/cinema-manager/schedule-audit-logs",
            icon: "icon-arrow-right",
            description: "scheduleauditlogs_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 148,
            action: "read",
            resource: "Schedule Audit Log",
          },
          // {
          //   name: "systemLogs",
          //   url: "/cinema-manager/system-logs",
          //   icon: "icon-arrow-right",
          //   description: "systemLogs_dash_msg",
          //   permissions: [
          //     Role.SuperAdmin,
          //     Role.HoManager,
          //     Role.CinemaManager,
          //   ],
          //   module_id: 173,
          //   action: "read",
          //   resource: "System Logs",
          // },
        ],
      },

      {
        name: "fnbDynamicPricing",
        url: "/cinema-manager/fnb-dynamic-pricing",
        icon: "icon-arrow-right",
        keywords: ["price", "food", "beverages", "dynamic", "pricing"],
        description: "fnbDynamicPricing_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 158,
        action: "read",
        resource: "F&B Dynamic Pricing",
      },
    ],
  },

  /**
   * DISTRIBUTORS START
   */
  {
    id: 3,
    name: "distributor",
    url: "/distributor",
    icon: "icon-distributor",
    permissions: [
      Role.SuperAdmin,
      Role.CinemaManager,
      Role.HoManager,
      Role.Distributor,
    ],
    isCollapsed: false,
    children: [
      {
        name: "distributor",
        url: "/distributor/distributors",
        icon: "icon-arrow-right",
        description: "distributor_dash_msg",
        permissions: [
          Role.SuperAdmin,
          Role.HoManager,
          Role.CinemaManager,
          Role.Distributor,
        ],
        module_id: 40,
        action: "read",
        resource: "Distributors",
      },
      {
        name: "shareType",
        url: "/distributor/distributor-share-type",
        icon: "icon-arrow-right",
        description: "sharetype_dash_msg",
        permissions: [
          Role.SuperAdmin,
          Role.HoManager,
          Role.CinemaManager,
          Role.Distributor,
        ],
        module_id: 37,
        action: "read",
        resource: "Share Type",
      },
      {
        name: "contract",
        url: "/distributor/contract",
        icon: "icon-arrow-right",
        description: "contract_dash_msg",
        permissions: [
          Role.SuperAdmin,
          Role.HoManager,
          Role.CinemaManager,
          Role.Distributor,
        ],
        module_id: 39,
        action: "read",
        resource: "Contract",
      },
      {
        name: "weekwiseContract",
        url: "/distributor/weekwise-contract",
        icon: "icon-arrow-right",
        description: "weekwiseContract_dash_msg",
        permissions: [
          Role.SuperAdmin,
          Role.HoManager,
          Role.CinemaManager,
          Role.Distributor,
        ],
        module_id: 146,
        action: "read",
        resource: "Weekwise Contract",
      },
      {
        name: "distributorContract",
        url: "/distributor/distributor-contract",
        icon: "icon-arrow-right",
        description: "distributorContract_dash_msg",
        permissions: [
          Role.SuperAdmin,
          Role.HoManager,
          Role.CinemaManager,
          Role.Distributor,
        ],
        module_id: 145,
        action: "read",
        resource: "Distributor Contract",
      },
      // {
      //   name: "Distributor Deduction",
      //   url: "/distributor/distributor-deduction",
      //   icon: "icon-arrow-right",
      //   description: "distributorContract_dash_msg",
      //   permissions: [
      //     Role.SuperAdmin,
      //     Role.HoManager,
      //     Role.CinemaManager,
      //     Role.Distributor,
      //   ],
      //   module_id: 38,
      //   action: "read",
      //   resource: "Distributor Deduction",
      // },
    ],
  },
  {
    id: 4,
    name: "master",
    url: "/master",
    icon: "icon-suitcase",
    permissions: [Role.SuperAdmin, Role.HoManager],
    isCollapsed: false,
    children: [
      // {
      //   name: "imageGallery",
      //   url: "/master/image-gallery",
      //   icon: "icon-arrow-right",
      //   description: "imagegallery_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 175,
      //   action: "read",
      //   resource: "Image Gallery",
      // },
      {
        name: "Tax Types",
        url: "/master/tax-types",
        icon: "icon-arrow-right",
        description: "chargetypes_dash_msg",
        keywords: ["GST", "gst", "VAT", "vat", "Tax", "tax"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 45,
        action: "read",
        resource: "Charge Types",
      },
      {
        name: "banners",
        url: "/master/banners",
        icon: "icon-arrow-right",
        description: "banners_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 127,
        action: "read",
        resource: "Banners",
      },
      {
        name: "Global Options Settings",
        url: "/master/global-options-settings",
        icon: "icon-arrow-right",
        description: "global_options_dash_msg",
        keywords: [
          "global",
          "global settings",
          "Global Options",
          "Global Options Settings",
          "settings",
        ],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 203,
        action: "read",
        resource: "Global Options Settings",
      },
      {
        name: "cinematypes",
        url: "/master/cinema-types",
        icon: "icon-arrow-right",
        description: "cinematypes_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 155,
        action: "read",
        resource: "Cinema Type",
      },
      {
        name: "tiertypes",
        url: "/master/tier-types",
        icon: "icon-arrow-right",
        description: "tiertypes_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager],
        module_id: 156,
        action: "read",
        resource: "Tier Type",
      },
      {
        name: "country",
        url: "/master/countries",
        icon: "icon-arrow-right",
        description: "country_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager],
        module_id: 41,
        action: "read",
        resource: "Country",
      },
      {
        name: "state",
        url: "/master/states",
        icon: "icon-arrow-right",
        description: "state_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager],
        module_id: 42,
        action: "read",
        resource: "States",
      },
      {
        name: "city",
        url: "/master/cities",
        icon: "icon-arrow-right",
        description: "city_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager],
        module_id: 43,
        action: "read",
        resource: "Cities",
      },
      {
        name: "region",
        url: "/master/regions",
        icon: "icon-arrow-right",
        description: "region_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager],
        module_id: 174,
        action: "read",
        resource: "Region",
      },
      {
        name: "territory",
        url: "/master/territory",
        icon: "icon-arrow-right",
        description: "territory_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager],
        module_id: 307,
        action: "read",
        resource: "Territory",
      },
      {
        name: "denomination",
        url: "/master/denominations",
        icon: "icon-arrow-right",
        description: "denomination_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 44,
        action: "read",
        resource: "Denominations",
      },
      {
        name: "productioncompany",
        url: "/distributor/productions",
        icon: "icon-arrow-right",
        description: "production_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 46,
        action: "read",
        resource: "Production Companies",
      },
      {
        name: "censorrating",
        url: "/master/ratings",
        icon: "icon-arrow-right",
        description: "rating_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 47,
        action: "read",
        resource: "Censor Ratings",
      },
      {
        name: "crew",
        url: "/master/crews",
        icon: "icon-arrow-right",
        description: "crew_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 48,
        action: "read",
        resource: "Crews",
      },
      {
        name: "Cast & Crew Details",
        url: "/master/cast-crew",
        icon: "icon-arrow-right",
        description: "crew_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 48,
        action: "read",
        resource: "Crews",
      },
      {
        name: "currency",
        url: "/master/currencies",
        icon: "icon-arrow-right",
        description: "currency_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 49,
        action: "read",
        resource: "Currencies",
      },
      // {
      //   name: "currency_conversion",
      //   url: "/master/currencies-conversion",
      //   icon: "icon-arrow-right",
      //   description: "currency_conversation_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 176,
      //   action: "read",
      //   resource: "Currency Conversion",
      // },

      {
        name: "comments",
        url: "/master/schedule-comments-master",
        icon: "icon-arrow-right",
        description: "comments_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 141,
        action: "read",
        resource: "Comments",
      },
      {
        name: "bookingsource",
        url: "/master/booking-sources",
        icon: "icon-arrow-right",
        description: "bookingsource_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 50,
        action: "read",
        resource: "Booking Source",
      },
      {
        name: "genre",
        url: "/master/genres",
        icon: "icon-arrow-right",
        description: "genre_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 53,
        action: "read",
        resource: "Genre",
      },
      {
        name: "labels",
        url: "/master/movie-labels",
        icon: "icon-arrow-right",
        description: "label_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 194,
        action: "read",
        resource: "FNB Label",
      },
      {
        name: "screen_seat_type_group",
        url: "/master/screen-seat-type-group",
        icon: "icon-arrow-right",
        description: "sstg_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 194,
        action: "read",
        resource: "Screen Seat Type Group",
      },
      {
        name: "Hardware Locations",
        url: "/master/hardware-locations",
        icon: "icon-arrow-right",
        description: "hardwareLocations_dash",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 236,
        action: "read",
        resource: "Hardware Locations",
      },
      {
        name: "hardware",
        url: "/master/hardwares",
        icon: "icon-arrow-right",
        description: "hardware_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 54,
        action: "read",
        resource: "Hardwares",
      },
      {
        name: "language",
        url: "/master/languages",
        icon: "icon-arrow-right",
        description: "language_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 55,
        action: "read",
        resource: "Language",
      },
      {
        name: "imagesetting",
        url: "/master/image-settings",
        icon: "icon-arrow-right",
        description: "imagesetting_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 56,
        action: "read",
        resource: "Image Setting",
      },
      {
        name: "movieformat",
        url: "/master/movie-formats",
        icon: "icon-arrow-right",
        description: "format_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 57,
        action: "read",
        resource: "Movie Format",
      },
      {
        name: "moviecategory",
        url: "/master/movie-categories",
        icon: "icon-arrow-right",
        description: "movie_category_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        keywords: ["mini", "festival", "minifestival"],
        module_id: 58,
        action: "read",
        resource: "Movie Category",
      },
      {
        name: "organization",
        url: "/master/organizations",
        icon: "icon-arrow-right",
        description: "org_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 60,
        action: "read",
        resource: "Organizations",
      },
      {
        name: "paymentmode",
        url: "/master/payment-modes",
        icon: "icon-arrow-right",
        description: "payment_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 61,
        action: "read",
        resource: "Payment Mode",
      },
      {
        name: "refundreason",
        url: "/master/refund-reasons",
        icon: "icon-arrow-right",
        description: "refund_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 62,
        action: "read",
        resource: "Refund Reason",
      },
      {
        name: "soundformats",
        url: "/master/sound-formats",
        icon: "icon-arrow-right",
        description: "sound_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 152,
        action: "read",
        resource: "Sound Format",
      },
      {
        name: "clients",
        url: "/master/clients",
        icon: "icon-arrow-right",
        description: "clients_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 160,
        action: "read",
        resource: "Clients",
      },
      {
        name: "unitconverter",
        url: "/master/unit-converter",
        icon: "icon-arrow-right",
        description: "unitconverter_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 128,
        action: "read",
        resource: "Unit Converter",
      },
      {
        name: "unitofmeasurement",
        url: "/master/unit-of-measurment",
        icon: "icon-arrow-right",
        description: "unitofmeasurement_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 67,
        action: "read",
        resource: "Unit of Measurements",
      },
      {
        name: "weekday",
        url: "/master/weekdays",
        icon: "icon-arrow-right",
        description: "weekday_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 68,
        action: "read",
        resource: "Weekdays",
      },
      {
        name: "bookingusercategory",
        url: "/master/booking-user-category",
        icon: "icon-arrow-right",
        description: "bookingusercategory_dash_msg",
        permissions: [],
        module_id: 69,
        action: "read",
        resource: "Booking User Category",
      },
      {
        name: "cinematemplate",
        url: "/master/cinema-ticket-templates",
        icon: "icon-arrow-right",
        description: "cinematickettemplate_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 74,
        action: "read",
        resource: "Cinema Ticket Templates",
      },
      // {
      //   name: "autoemailreportv2",
      //   url: "/master/auto-emailer-v2",
      //   icon: "icon-arrow-right",
      //   description: "autoemailreport_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 75,
      //   action: "read",
      //   resource: "Auto Email Report",
      // },
      // {
      //   name: "autoemailreport",
      //   url: "/master/auto-email-report",
      //   icon: "icon-arrow-right",
      //   description: "autoemailreport_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 75,
      //   action: "read",
      //   resource: "Auto Email Report",
      // },
      {
        name: "Auto Email Report V3",
        url: "/master/auto-email-v3",
        icon: "icon-arrow-right",
        description: "autoemailreport_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 75,
        action: "read",
        resource: "Auto Email Report",
      },
      {
        name: "aspectRatio",
        url: "/master/aspect-ratios",
        icon: "icon-arrow-right",
        description: "aspect_ratio_msg",
        permissions: [Role.SuperAdmin, Role.HoManager],
        module_id: 181,
        action: "read",
        resource: "Aspect Ratio",
      },
      {
        name: "movieResolution",
        url: "/master/movie-resolutions",
        icon: "icon-arrow-right",
        description: "movie_resolutions_msg",
        permissions: [Role.SuperAdmin, Role.HoManager],
        module_id: 182,
        action: "read",
        resource: "Movie Resolution",
      },
      {
        name: "movieExperience",
        url: "/master/movie-experiences",
        icon: "icon-arrow-right",
        description: "movie_experiences_msg",
        permissions: [Role.SuperAdmin, Role.HoManager],
        module_id: 183,
        action: "read",
        resource: "Movie Experience",
      },
      {
        name: "Translations",
        url: "/master/translations-list",
        icon: "icon-arrow-right",
        description: "translation_list_msg",
        permissions: [Role.SuperAdmin, Role.HoManager],
        module_id: 195,
        action: "read",
        resource: "Translations",
      },
      {
        name: "Seat Reservation Type",
        url: "/master/seat-reservation-types",
        icon: "icon-arrow-right",
        description: "seat_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 65,
        action: "read",
        resource: "Seat Reservation Type",
      },
      {
        name: "Fnb Labels",
        url: "/master/fnb-labels",
        icon: "icon-arrow-right",
        description: "Fnb Labels",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 237,
        action: "read",
        resource: "Fnb Labels",
      },
    ],
  },
  /**
   * MASTERS END
   */

  //  FNB MASTER ROUTES
  {
    id: 5,
    name: "foodNbev",
    url: "/fnb",
    icon: "icon-fnb",
    permissions:
      authenticationService.get("ENABLE_FNB") === "Y"
        ? [Role.SuperAdmin, Role.CinemaManager, Role.HoManager]
        : [Role.SuperAdmin, Role.HoManager],
    isCollapsed: false,
    children: [
      {
        name: "rawmaterialsCategories",
        url: "/fnb/raw-materials-categories",
        icon: "icon-arrow-right",
        description: "rawmaterialscategory_dash_msg",
        cine_direct_sale: "N",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 78,
        action: "read",
        resource: "F&B item",
      },
      {
        name: "rawmaterials",
        url: "/fnb/raw-materials",
        icon: "icon-arrow-right",
        description: "rawmaterials_dash_msg",
        cine_direct_sale: "N",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 79,
        action: "read",
        resource: "F&B item",
      },
      {
        name: "modifiers",
        url: "/fnb/modifier-categories",
        icon: "icon-arrow-right",
        description: "modifiers_dash_msg",
        cine_direct_sale: "N",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 78,
        action: "read",
        resource: "F&B item",
      },
      {
        name: "vendor",
        url: "/fnb/vendors",
        icon: "icon-arrow-right",
        description: "vendors_dash_msg",
        cine_direct_sale: "N",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 80,
        action: "read",
        resource: "Vendors",
      },
      {
        name: "purchaseOrder",
        url: "/fnb/purchase-order",
        icon: "icon-arrow-right",
        description: "puchase_order_dash_msg",
        cine_direct_sale: "N",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 81,
        action: "read",
        resource: "Purchase Order",
      },
      {
        name: "storeManagement",
        url: "/fnb/store-management",
        icon: "icon-arrow-right",
        description: "storemanagement_dash_msg",
        cine_direct_sale: "N",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 82,
        action: "read",
        resource: "Store Management",
      },
      {
        name: "PO Inward / GRN",
        url: "/fnb/stock-in",
        icon: "icon-arrow-right",
        description: "stock_in_dash_msg",
        cine_direct_sale: "N",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 83,
        keywords: ["invent", "inward", "GRN"],
        action: "read",
        resource: "Inward",
      },
      {
        name: "property_in_out",
        url: "/fnb/property-in-out",
        icon: "icon-arrow-right",
        description: "property_in_out_dash_msg",
        cine_direct_sale: "N",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 303,
        keywords: ["proerty", "IN/Out", "Adjustment", "stock"],
        action: "read",
        resource: "Property In Out",
      },
      {
        name: "propertyInOutLogs",
        url: "/fnb/property-in-out-logs",
        icon: "icon-arrow-right",
        description: "property_in_out_dash_msg",
        cine_direct_sale: "N",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 161,
        action: "read",
        resource: "Property In/Out Logs",
      },
      {
        name: "transferStock",
        // url: "/fnb/transfer-stocks",
        url: "/fnb/transfer-stocks-v2",
        icon: "icon-arrow-right",
        description: "transfer_stocks_dash_msg",
        cine_direct_sale: "N",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 84,
        action: "update",
        resource: "Transfer Stocks",
      },
      {
        name: "transferStockLogs",
        url: "/fnb/transfer-stocks-logs",
        icon: "icon-arrow-right",
        description: "transfer_stocks_logs_dash_msg",
        cine_direct_sale: "N",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 85,
        action: "read",
        resource: "Transfer Stock Log",
      },
      {
        name: "Stocks Transfer Request Logs",
        url: "/fnb/stocks-tranfer-requests",
        icon: "icon-arrow-right",
        description: "transfer_stocks_logs_dash_msg",
        cine_direct_sale: "N",
        keywords: ["transfer", "stock", "request", "inventory"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 344,
        action: "read",
        resource: "Stock Transfer Requests",
      },
      {
        name: "Minimum Stock Levels",
        url: "/fnb/minimum-stock-logs",
        icon: "icon-arrow-right",
        description: "transfer_stocks_logs_dash_msg",
        cine_direct_sale: "N",
        keywords: ["minimum", "threshold", "stock", "logs"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 345,
        action: "read",
        resource: "Minimum Stock Logs",
      },
      {
        name: "Inventory Mails Notifications",
        url: "/master/add-inventory-mails",
        icon: "icon-arrow-right",
        description: "Add Inventory Mails",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 346,
        action: "read",
        resource: "Inventory Notification Settings",
      },
      {
        name: "Stock Variance Reasons",
        url: "/fnb/stock-take-reasons",
        icon: "icon-arrow-right",
        description: "reasons_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager],
        module_id: 312,
        action: "read",
        resource: "Stock Variance Reasons",
      },
      {
        name: "stocktake",
        url: "/fnb/stock-take",
        icon: "icon-arrow-right",
        description: "stock_take_dash_msg",
        cine_direct_sale: "N",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 86,
        action: "read",
        resource: "Stock Take",
      },
      {
        name: "stocktakeLogs",
        url: "/fnb/stock-take-logs",
        icon: "icon-arrow-right",
        description: "stock_take_logs_dash_msg",
        cine_direct_sale: "N",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 161,
        action: "read",
        resource: "Stock Take Logs",
      },
      {
        name: "stocktakesummary",
        url: "/fnb/stock-take-summary",
        icon: "icon-arrow-right",
        description: "stock_take_logs_dash_msg",
        cine_direct_sale: "N",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 161,
        action: "read",
        resource: "Stock Take Logs",
      },
      {
        name: "concessionStock",
        url: "/fnb/concession-stock",
        icon: "icon-arrow-right",
        description: "concession_stock_dash_msg",
        cine_direct_sale: "N",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 87,
        action: "read",
        resource: "Concession Stock",
      },
      {
        name: "foodCategories",
        url: "/fnb/food-categories",
        icon: "icon-arrow-right",
        description: "food_categories_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 88,
        action: "read",
        resource: "Food Categories",
      },
      {
        id: 20,
        name: "Recipe",
        url: "/fnb/recipes",
        icon: "icon-fnb",
        permissions: [],
        isCollapsed: false,
        children: [
          {
            name: "recipe",
            url: "/fnb/recipes",
            icon: "icon-arrow-right",
            description: "recipes_dash_msg",
            keywords: ["Recipe", "recep"],
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 89,
            action: "read",
            resource: "Recipes",
          },
          {
            name: "subrecipe",
            url: "/fnb/subrecipes",
            icon: "icon-arrow-right",
            description: "recipes_dash_msg",
            keywords: ["Recipe", "recep", "sub", "subrecipe", "subrecep"],
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 238,
            action: "read",
            resource: "Sub Recipe",
          },
        ],
      },
      {
        name: "customization",
        url: "/fnb/customization",
        icon: "icon-arrow-right",
        description: "fnb_customization_dash_msg",
        cine_direct_sale: "N",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 164,
        action: "read",
        resource: "F&B Customization",
      },
      {
        name: "fbItems",
        url: "/fnb/fnb-items",
        icon: "icon-arrow-right",
        description: "fnb_items_dash_msg",
        keywords: [
          "food and beverage items",
          "Concessions",
          "fnb",
          "f&b",
          "items",
          "food",
          "beverages",
          "f &",
          "f and",
        ],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 90,
        action: "read",
        resource: "F&B item",
      },
      // {
      //   name: "Vip Fnb",
      //   url: "/fnb/vip-fnb",
      //   icon: "icon-arrow-right",
      //   description: "vip_fnb",
      //   keywords: ["vip fnb"],
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 245,
      //   action: "read",
      //   resource: "VipFnb",
      //   only_visible_on: [
      //     {
      //       key_name: CLIENT_NAME.EMPIRE,
      //     },
      //     {
      //       key_name: CLIENT_NAME.LEBANON,
      //     },
      //   ],
      // },
      // {
      //   name: 'rateCard',
      //   url: '/fnb/rateCard',
      //   icon: 'icon-arrow-right',
      //   description: '',
      //   permissions: [Role.SuperAdmin, Role.HoManager],
      // },
      // {
      //   name: 'fbPricing',
      //   url: '/fnb/fnb-pricing',
      //   icon: 'icon-arrow-right',
      //   description: '',
      //   permissions: [Role.SuperAdmin, Role.HoManager],
      //   module_id: 152

      // },
      {
        name: "wastemanagement",
        url: "/fnb/fnb-wastage",
        icon: "icon-arrow-right",
        cine_direct_sale: "N",
        description: "fnb_wastage_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 91,
        action: "read",
        resource: "Waste Management",
      },
      {
        name: "goodreturn",
        url: "/fnb/good-return",
        icon: "icon-arrow-right",
        description: "goods_return_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 33,
        action: "read",
        resource: "Goods Return",
      },
      {
        name: "Fnb Stations",
        url: "/fnb/fnb-stations",
        icon: "icon-arrow-right",
        description: "fnb stations",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 295,
        action: "read",
        resource: "fnb stations",
      },
    ],
  },

  {
    id: 6,
    name: "reports",
    url: "/reports",
    icon: "icon-report",
    permissions: [
      Role.SuperAdmin,
      Role.CinemaManager,
      Role.HoManager,
      Role.Distributor,
    ],
    isCollapsed: false,
    children: [
      {
        name: "Report Builder FnB",
        url: "/reports/report-builder-fnb",
        icon: "icon-arrow-right",
        description: "Report Builder FnB",
        keywords: ["fnb", "builder", "beta"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 231,
        action: "read",
        resource: "Report Builder FnB",
      },
      {
        name: "Entry Point Activity Report",
        url: "/reports/entry-activity-report",
        icon: "icon-arrow-right",
        description: "Entry Point Activity Report",
        keywords: ["entry", "activity", "report", "point", "usher", "scan"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 340,
        action: "read",
        resource: "Entry Point Activity Report",
      },
      {
        name: "Fnb Courtsey Report",
        url: "/reports/fnb-courtsey-report",
        icon: "icon-arrow-right",
        description: "Fnb Courtsey Report",
        keywords: ["courtsey", "Courstey", "fnb", "Report"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 343,
        action: "read",
        resource: "Fnb Courtsey Report",
      },
      {
        name: "Fnb Courtsey Refund Report",
        url: "/reports/fnb-courtsey-refund-report",
        icon: "icon-arrow-right",
        description: "Fnb Courtsey Refund Report",
        keywords: ["courtsey", "Courstey", "fnb", "Report", "refund"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 343,
        action: "read",
        resource: "Fnb Courtsey Report",
      },
      // {
      //   name: "Loyalty Overview",
      //   url: "/reports/loyalty-overview-report",
      //   icon: "icon-arrow-right",
      //   description: "Loyalty Overview & Settlements",
      //   keywords: ["Loyalty", "Overview", "loyality", "settlements"],
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 280,
      //   action: "read",
      //   resource: "Loyalty Overview",
      // },
      // {
      //   name: "Loyalty Settlements",
      //   url: "/reports/loyalty-settlement-report",
      //   icon: "icon-arrow-right",
      //   description: "Loyalty Overview & Settlements",
      //   keywords: ["Loyalty", "Overview", "loyality", "settlements"],
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 281,
      //   action: "read",
      //   resource: "Loyalty Settlements",
      // },
      // {
      //   name: "Website Cash Card Status",
      //   url: "/reports/cash-card-status",
      //   icon: "icon-arrow-right",
      //   description: "online_cc_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 234,
      //   action: "read",
      //   resource: "Website Cash Card Status",
      // },
      // {
      //   name: "cinemaOverviewReport",
      //   url: "/reports/showoverview",
      //   icon: "icon-arrow-right",
      //   description: "Show Overview",
      //   permissions: [
      //     Role.SuperAdmin,
      //     Role.HoManager,
      //     Role.CinemaManager,
      //     Role.ProgrammingManager,
      //   ],
      //   module_id: 201,
      //   action: "read",
      //   resource: "Advance Sales Report",
      // },
      // {
      //   name: "Advance Sales Report",
      //   url: "/reports/advance-sales-report",
      //   icon: "icon-arrow-right",
      //   description: "Show Overview",
      //   permissions: [
      //     Role.SuperAdmin,
      //     Role.HoManager,
      //     Role.CinemaManager,
      //     Role.ProgrammingManager,
      //   ],
      //   module_id: 133,
      //   action: "read",
      //   resource: "Advance Sales Report",
      // },
      {
        name: "Hourly SPH Report",
        url: "/reports/hourly-sph-report",
        icon: "icon-arrow-right",
        description: "Show Overview",
        permissions: [
          Role.SuperAdmin,
          Role.HoManager,
          Role.CinemaManager,
          Role.ProgrammingManager,
        ],
        module_id: 134,
        action: "read",
        resource: "Hourly SPH Report",
      },
      {
        name: "occupancyreport",
        url: "/reports/occupancy",
        icon: "icon-arrow-right",
        description: "Occupancy Reports",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 189,
        action: "read",
        resource: "Occupancy Reports",
      },
      {
        name: "Occupancy Analysis Report",
        url: "/reports/occupancy-analysis-report",
        icon: "icon-arrow-right",
        description: "Occupancy Analysis Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 239,
        action: "read",
        resource: "Occupancy Analysis Report",
      },
      {
        name: "Show Date Wise Admits Report",
        url: "/reports/show-details-report",
        icon: "icon-arrow-right",
        description: "Show Date Wise Admits Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 310,
        action: "read",
        resource: "Show Date Wise Admits Report",
      },
      // {
      //   name: "Summary and Performance Report",
      //   url: "/reports/performance-summary-report",
      //   icon: "icon-arrow-right",
      //   description: "perforamce and summary report",
      //   permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
      //   module_id: 214,
      //   action: "read",
      //   resource: "Summary and Performance Report",
      // },
      //   {
      //   name: "Reserved Unpaid Bookings",
      //   url: "/cinema-manager/reserve-seats-list",
      //   icon: "icon-arrow-right",
      //   description: "reserveseats_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 22,
      //   action: "read",
      //   resource: "Reserve Seats",
      // },
      {
        name: "Summary and Performance Report Lebanon",
        url: "/reports/performance-summary-report-v4",
        icon: "icon-arrow-right",
        description: "perforamce and summary report V4",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 214,
        action: "read",
        resource: "Summary and Performance Report",
        only_visible_on: [
          {
            key_name: CLIENT_NAME.LEBANON,
          },
        ],
      },
      {
        name: "Summary And Performance Report",
        url: "/reports/summary-performance-report",
        icon: "icon-arrow-right",
        description: "Summary And Performance Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 214,
        only_available_on: [
          {
            key_name: CLIENT_NAME.EPIX,
            url: "/reports/summary-performance-report-epix",
          },
          {
            key_name: CLIENT_NAME.EMPIRE,
            url: "/reports/summary-performance-report-empire",
          },
        ],
        action: "read",
        resource: "Summary and Performance Report",
      },
      // {
      //   name: "Summary Performance Rent Report",
      //   url: "/reports/summary-performance-report-epix-rent",
      //   icon: "icon-arrow-right",
      //   description: "Summary Performance Rent Report",
      //   permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
      //   module_id: 324,
      //   only_available_on: [
      //     {
      //       key_name: CLIENT_NAME.EPIX,
      //       url: "/reports/summary-performance-report-epix-rent",
      //     },
      //   ],
      //   action: "read",
      //   resource: "Summary Performance Rent Report ",
      // },

      {
        name: "User Cashier Summary  Report",
        url: "/reports/user-cashier-summary-report",
        icon: "icon-arrow-right",
        description: "User Cashier Summary  Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 214,

        action: "read",
        resource: "User Cashier Summary  Report",
      },
      {
        name: "Summary User Transaction Log Report",
        url: "/reports/summary-user-transaction-log-report",
        icon: "icon-arrow-right",
        description: "Summary User Transaction Log Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 214,

        action: "read",
        resource: "Summary User Transaction Log Report",
      },
      // {
      //   name: "Summary",
      //   url: "/reports/summary",
      //   icon: "icon-arrow-right",
      //   description: "Summary",
      //   permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
      //   module_id: 93,
      //   action: "read",
      //   resource: "Summary",
      // },
      {
        name: "net_revenue_report",
        url: "/reports/net-revenue-report",
        icon: "icon-arrow-right",
        description: "net_revenue_msg",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 263,
        action: "read",
        resource: "Net Revenue Report",
      },
      {
        name: "gcamreport",
        url: "/reports/gcam-report",
        icon: "icon-arrow-right",
        description: "gcam_report_dash_msg",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 215,
        action: "read",
        resource: "GCAM Report",
        only_visible_on: [
          {
            key_name: CLIENT_NAME.EMPIRE,
          },
          {
            key_name: CLIENT_NAME.IRAQ,
          },
          {
            key_name: CLIENT_NAME.BILDHAUS,
          },
          {
            key_name: CLIENT_NAME.CINEMA_AKIL,
          },
          {
            key_name: CLIENT_NAME.XANADU,
          },
          {
            key_name: CLIENT_NAME.PETRO,
          },
          {
            key_name: CLIENT_NAME.QFX,
          },
          {
            key_name: CLIENT_NAME.LEBANON,
          },
          {
            key_name: CLIENT_NAME.STUESSIHOF,
          },
        ],
      },
      {
        name: "Muncipality Report",
        url: "/reports/Muncipality-report",
        icon: "icon-arrow-right",
        description: "muncipality_report_dash_msg",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 273,
        only_visible_on: [
          {
            key_name: CLIENT_NAME.STAR,
          },
          {
            key_name: CLIENT_NAME.WOW,
          },
        ],
        action: "read",
        resource: "Municipality Report",
      },
      {
        name: "MTax Report",
        url: "/reports/mtax-report",
        icon: "icon-arrow-right",
        description: "mtax_report_dash_msg",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 215,
        action: "read",
        resource: "GCAM Report",
        only_visible_on: [
          {
            key_name: CLIENT_NAME.STAR,
          },
          {
            key_name: CLIENT_NAME.WOW,
          },
        ],
      },
      {
        name: "Box Office Summary Report",
        url: "/reports/box-office-report",
        icon: "icon-arrow-right",
        description: "box office summary report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 216,
        action: "read",
        resource: "Box Office Summary  Report",
        only_available_on: [
          {
            key_name: CLIENT_NAME.LEBANON,
            url: "/reports/box-office-report-lebanon",
          },
        ],
      },
      {
        name: "Cashier Shift Close",
        url: "/reports/cashier-shift-close",
        icon: "icon-arrow-right",
        description: "box office summary report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 249,
        action: "read",
        resource: "Shifts",
      },
      {
        name: "Voucher Useage Report",
        url: "/reports/voucher-useage-report",
        icon: "icon-arrow-right",
        description: "Voucher Useage Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 274,
        action: "read",
        resource: "Voucher Useage Report",
      },
      {
        name: "Traffic Flow Analysis Report",
        url: "/reports/traffic-flow-analysis",
        icon: "icon-arrow-right",
        description: "traffic_flow_analysis_msg",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 317,
        action: "read",
        resource: "Traffic Flow Analysis Report",
      },
      {
        name: "Week Wise Movie History Report",
        url: "/reports/week-wise-movie-history-report",
        icon: "icon-arrow-right",
        description: "Week Wise Movie History Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 320,
        action: "read",
        resource: "Week Wise Movie History Report",
      },
      {
        name: "Advance FnB Report",
        url: "/reports/advance-fnb-report",
        icon: "icon-arrow-right",
        description: "Advance FnB Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 275,
        action: "read",
        resource: "Advance FnB Report",
      },
      {
        name: "E-Wallet Report",
        url: "/reports/e-wallet-report",
        icon: "icon-arrow-right",
        description: "E-Wallet Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 279,
        action: "read",
        resource: "EWallet Report",
      },
      // {
      //   name: "Detailed Prior Sales Report",
      //   url: "/reports/detailed-prior-sales-report",
      //   icon: "icon-arrow-right",
      //   description: "Detailed Prior Sales Report",
      //   permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
      //   module_id: 285,
      //   action: "read",
      //   resource: "Detailed Prior Sales Report",
      // },
      {
        name: "Detailed Advance Sales Report",
        url: "/reports/detailed-advanced-sales-report",
        icon: "icon-arrow-right",
        description: "Detailed Advance Sales Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 286,
        action: "read",
        resource: "Detailed Advance Sales Report",
      },
      {
        name: "Transactions Summary Report",
        url: "/reports/transaction-summary-report",
        icon: "icon-arrow-right",
        description: "Transaction Summary Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 287,
        action: "read",
        resource: "Transactions Summary Report",
      },
      {
        name: "Product Sale Report",
        url: "/reports/productSaleReport",
        icon: "icon-arrow-right",
        description: "Product Sale Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 288,
        action: "read",
        resource: "Product Sale Report",
      },
      // {
      //   name: "Electronic Payments Report",
      //   url: "/reports/electronic-payments-report",
      //   icon: "icon-arrow-right",
      //   description: "Transaction Summary Report",
      //   permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
      //   module_id: 289,
      //   action: "read",
      //   resource: "Electronic Payments Report",
      //   only_available_on: [
      //     {
      //       key_name: CLIENT_NAME.CINEPOLIS_OMAN,
      //       url: "/reports/electronic-payments-report",
      //     },
      //   ],
      // },
      {
        name: "Offer Redemption Report",
        url: "/reports/offer-redemption-report",
        icon: "icon-arrow-right",
        description: "Offer Redemption Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 290,
        action: "read",
        resource: "Offer Redemption Report",
      },
      {
        name: "Month And Day Wise Report",
        url: "/reports/month-and-daywise-report",
        icon: "icon-arrow-right",
        description: "Transaction Summary Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 291,
        action: "read",
        resource: "Month And Day Wise Report",
      },
      // {
      //   name: "Daily Cashup Report",
      //   url: "/reports/daily-cashup-report",
      //   icon: "icon-arrow-right",
      //   description: "Daily Cashup Report",
      //   permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
      //   module_id: 292,
      //   action: "read",
      //   resource: "Daily ashup Report",
      // },
      // {
      //   name: "User Collection Report",
      //   url: "/reports/user-collection-report",
      //   icon: "icon-arrow-right",
      //   description: "User Collection Report",
      //   permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
      //   module_id: 279,
      //   action: "read",
      //   resource: "User Collection Report",
      // },

      {
        name: "Daily Operations Report",
        url: "/reports/daily-operations-report",
        icon: "icon-arrow-right",
        description: "Daily Operations Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 293,
        action: "read",
        resource: "Daily Operations Report",
      },
      {
        name: "Distributor Report",
        url: "/reports/distributor-report-star",
        icon: "icon-arrow-right",
        description: "Distributor Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 259,
        only_visible_on: [
          {
            key_name: CLIENT_NAME.STAR,
          },
          {
            key_name: CLIENT_NAME.WOW,
          },
        ],
        action: "read",
        resource: "Distributor Report",
      },
      {
        name: "distributorDetailedSummaryOman",
        url: "/reports/cinema-reports/distributor-report-cinepolis",
        icon: "icon-arrow-right",
        description: "distributor_detailed_dash_msg_oman",
        keywords: ["distributor", "oman"],
        permissions: [
          Role.SuperAdmin,
          Role.CinemaManager,
          Role.Distributor,
          Role.HoManager,
        ],
        module_id: 294,
        action: "read",
        resource: "Distributor Report Cinepolis",
        only_visible_on: [
          {
            key_name: CLIENT_NAME.CINEPOLIS_OMAN,
          },
          {
            key_name: CLIENT_NAME.CINEPOLIS_KSA,
          },
        ],
      },
      {
        name: "Municipality Report Detail",
        url: "/reports/municipality-report-detail",
        icon: "icon-arrow-right",
        description: "Municipality Report Detail",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 260,
        only_visible_on: [
          {
            key_name: CLIENT_NAME.STAR,
          },
          {
            key_name: CLIENT_NAME.WOW,
          },
        ],
        action: "read",
        resource: "Municipality Detail Report",
      },
      {
        name: "Municipality Report Detail (With Complimentary)",
        url: "/reports/municipality-report-detail-with-complimentary",
        icon: "icon-arrow-right",
        description: "Municipality Report Detail(With Complimentary)",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 260,
        only_visible_on: [
          {
            key_name: CLIENT_NAME.STAR,
          },
        ],
        action: "read",
        resource: "Municipality Detail Report",
      },
      {
        name: "Municipality Report Summary",
        url: "/reports/municipality-report-summary",
        icon: "icon-arrow-right",
        description: "Municipality Report Summary",
        keywords: ["Municipality"],
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 261,
        only_visible_on: [
          {
            key_name: CLIENT_NAME.STAR,
          },
          {
            key_name: CLIENT_NAME.WOW,
          },
        ],
        action: "read",
        resource: "Municipality Report Summary",
      },
      {
        name: "Screen Scheduling Report",
        url: "/reports/screen-scheduling",
        icon: "icon-arrow-right",
        description: "Screen Scheduling Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 276,
        action: "read",
        resource: "Screen Scheduling Report",
      },
      {
        name: "Sales Book",
        url: "/reports/sales-book",
        icon: "icon-arrow-right",
        description: "Sales Book",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 251,
        only_visible_on: [
          {
            key_name: CLIENT_NAME.QFX,
          },
        ],
        action: "read",
        resource: "Sales Book",
      },
      {
        name: "Sales Return With Cancel Reason",
        url: "/reports/sales-return-with-cancel-reason",
        icon: "icon-arrow-right",
        description: "Sales Return With Cancel Reason",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 252,
        only_visible_on: [
          {
            key_name: CLIENT_NAME.QFX,
          },
        ],
        action: "read",
        resource: "Sales Return With Cancel Reason",
      },
      {
        name: "Concession Item Sales Report",
        url: "/reports/concession-item-sales",
        icon: "icon-arrow-right",
        description: "Concession Item Sales Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 253,
        action: "read",
        resource: "Concession Item Sales Report",
      },
      {
        name: "DCR Finance Report",
        url: "/reports/dcr-finance-report",
        icon: "icon-arrow-right",
        description: "DCR Finance Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 266,
        only_visible_on: [
          {
            key_name: CLIENT_NAME.QFX,
          },
          {
            key_name: CLIENT_NAME.STAR,
          },
        ],
        action: "read",
        resource: "DCR Finance Report",
      },
      {
        name: "Product Sales Report",
        url: "/reports/product-sales-report",
        icon: "icon-arrow-right",
        description: "Product Sales Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 267,
        only_visible_on: [
          {
            key_name: CLIENT_NAME.QFX,
          },
        ],
        action: "read",
        resource: "Product Sales Report",
      },
      {
        name: "Screen Aggregator Report",
        url: "/reports/aggregator-report",
        icon: "icon-arrow-right",
        description: "Aggregator Report",
        keywords: ["aggregator"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 254,
        action: "read",
        resource: "Aggregator",
      },
      // {
      //   name: "GCAM & Vat Detailed Report",
      //   url: "/reports/gcam-vat-detailed-report",
      //   icon: "icon-arrow-right",
      //   description: "GCAM & Vat Detailed Report",
      //   permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
      //   module_id: 255,
      //   action: "read",
      //   resource: "GCAM & Vat Detailed Report",
      // },
      {
        name: "Rate Card Report",
        url: "/reports/rate-card-report",
        icon: "icon-arrow-right",
        description: "Rate Card Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 218,
        action: "read",
        resource: "Rate Card Report",
      },
      {
        name: "Housekeeping Report",
        url: "/reports/house-keeping-report",
        icon: "icon-arrow-right",
        description: "House Keeping Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 219,
        action: "read",
        resource: "Housekeeping Report",
      },
      {
        name: "Sales Register Report",
        url: "/reports/sales-register-report-beta",
        icon: "icon-arrow-right",
        description: "Sales Register Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 220,
        action: "read",
        resource: "Sales Register Report",
        only_visible_on: [
          {
            key_name: CLIENT_NAME.PETRO,
          },
          {
            key_name: CLIENT_NAME.IRAQ,
          },
          {
            key_name: CLIENT_NAME.LEBANON,
          },
          {
            key_name: CLIENT_NAME.STAR,
          },
          {
            key_name: CLIENT_NAME.CINEPOLIS_OMAN,
          },
          {
            key_name: CLIENT_NAME.CINEPOLIS_KSA,
          },
          {
            key_name: CLIENT_NAME.WOW,
          },
          {
            key_name: CLIENT_NAME.QFX,
          },
          {
            key_name: CLIENT_NAME.CINEPOLIS_OMAN,
          },
          {
            key_name: CLIENT_NAME.PLAYCINEMA,
          },
          {
            key_name: CLIENT_NAME.CINERJI,
          },
          // {
          //   key_name: CLIENT_NAME.EPIX,
          // },
        ],
        only_available_on: [
          // {
          //   key_name: CLIENT_NAME.EMPIRE,
          //   url: "/reports/sales-register-report-v1",
          // },
          {
            key_name: CLIENT_NAME.STAR,
            url: "/reports/sales-register-report-star",
          },
          {
            key_name: CLIENT_NAME.CINEPOLIS_OMAN,
            url: "/reports/sales-register-report-cinepolis",
          },
          // {
          //   key_name: CLIENT_NAME.EPIX,
          //   url: "/reports/sales-register-report-beta",
          // },
          {
            key_name: CLIENT_NAME.WOW,
            url: "/reports/sales-register-report-wow",
          },
        ],
      },
      // {
      //   name: "Sales Register Report",
      //   url: "/reports/sales-register-report-beta",
      //   icon: "icon-arrow-right",
      //   description: "Sales Register Report-Beta",
      //   tagDescription: "-Old (Sep.23)",
      //   permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
      //   module_id: 220,
      //   action: "read",
      //   resource: "Sales Register Report-Beta",
      //   // only_visible_on: [
      //   //   {
      //   //     key_name: CLIENT_NAME.EMPIRE,
      //   //   },
      //   // ],
      // },
      {
        name: "Sales Register Report",
        url: "/reports/sales-register-report-v1",
        icon: "icon-arrow-right",
        description: "Sales Register Report-Beta",
        tagDescription: "-New (Oct.23 Onwards)",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 220,
        action: "read",
        resource: "Sales Register Report-Beta",
        only_visible_on: [
          {
            key_name: CLIENT_NAME.EMPIRE,
          },
          {
            key_name: CLIENT_NAME.EPIX,
          },
          {
            key_name: CLIENT_NAME.MIF,
          },
        ],
      },
      // {
      //   name: "Sales Register Report Beta",
      //   url: "/reports/sales-register-report-beta",
      //   icon: "icon-arrow-right",
      //   description: "Sales Register Report",
      //   permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
      //   module_id: 220,
      //   action: "read",
      //   resource: "Sales Register Report Beta"
      // },
      {
        name: "Item Sales Register Report",
        url: "/reports/item-sales-register-report",
        icon: "icon-arrow-right",
        description: "Item Sales Register Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 246,
        action: "read",
        resource: "Item Sales Register",
        only_visible_on: [
          {
            key_name: CLIENT_NAME.EMPIRE,
          },
          {
            key_name: CLIENT_NAME.PETRO,
          },
          {
            key_name: CLIENT_NAME.IRAQ,
          },
          {
            key_name: CLIENT_NAME.LEBANON,
          },
          {
            key_name: CLIENT_NAME.STAR,
          },
          {
            key_name: CLIENT_NAME.CINEPOLIS_OMAN,
          },
          {
            key_name: CLIENT_NAME.CINEPOLIS_KSA,
          },
          {
            key_name: CLIENT_NAME.WOW,
          },
          {
            key_name: CLIENT_NAME.QFX,
          },
          {
            key_name: CLIENT_NAME.WOW,
          },
          {
            key_name: CLIENT_NAME.MIF,
          },
          // {
          //   key_name: CLIENT_NAME.EPIX,
          // },
        ],
      },
      {
        name: "Sales Logs",
        url: "/reports/sales-logs",
        icon: "icon-arrow-right",
        description: "Sales Logs",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 247,

        only_visible_on: [
          {
            key_name: CLIENT_NAME.EMPIRE,
          },
          {
            key_name: CLIENT_NAME.PETRO,
          },
          {
            key_name: CLIENT_NAME.IRAQ,
          },
          {
            key_name: CLIENT_NAME.QFX,
          },
        ],
        action: "read",
        resource: "Sales Logs",
      },
      {
        name: "Item Logs",
        url: "/reports/item-sales-logs",
        icon: "icon-arrow-right",
        description: "Item Logs",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 248,
        action: "read",
        resource: "Item Logs",
        only_visible_on: [
          {
            key_name: CLIENT_NAME.EMPIRE,
          },
          {
            key_name: CLIENT_NAME.PETRO,
          },
          {
            key_name: CLIENT_NAME.IRAQ,
          },
          {
            key_name: CLIENT_NAME.QFX,
          },
        ],
      },
      {
        name: "E-Transactions Report",
        url: "/reports/etransactions-report",
        icon: "icon-arrow-right",
        description: "E-Transactions Report",
        keywords: ["e transaction", "e-transaction", "e transactions"],
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 221,
        action: "read",
        resource: "E-Transactions Report",
      },
      {
        name: "Refund Show Detail Report",
        url: "/reports/refund-show-detail-report",
        icon: "icon-arrow-right",
        description: "Refund Show Detail Report",
        keywords: ["fnb refund", "refund", "fnbrefund"],
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 222,
        action: "read",
        resource: "Refund Show Detail Report",
      },
      {
        name: "FnB Refund Report",
        url: "/reports/refund-fnb-report",
        icon: "icon-arrow-right",
        description: "FnB Refund Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 279,
        action: "read",
        resource: "FnB Refund Report",
      },
      {
        name: "Receipt Summary",
        url: "/reports/receipt-summary",
        icon: "icon-arrow-right",
        description: "Receipt summary report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 223,
        action: "read",
        resource: "Receipt Summary Report",
        only_available_on: [
          {
            key_name: CLIENT_NAME.QFX,
            url: "/reports/receipt-summary-v2",
          },
          {
            key_name: CLIENT_NAME.STAR,
            url: "/reports/receipt-summary-v2",
          },
          {
            key_name: CLIENT_NAME.WOW,
            url: "/reports/receipt-summary-v2",
          },
          {
            key_name: CLIENT_NAME.LEBANON,
            url: "/reports/receipt-summary-lbp",
          },
        ],
      },
      {
        name: "FnB Combo Sales Report",
        url: "/reports/fnb-combo-sales-report",
        icon: "icon-arrow-right",
        description: "fnb combo sales report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 224,
        action: "read",
        resource: "FnB Combo Sales Report",
      },
      {
        name: "Box Office Receipt Report",
        url: "/reports/box-office-receipt-report",
        icon: "icon-arrow-right",
        description: "Box Office Receipt report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 225,
        action: "read",
        resource: "Box Office Receipt Report",
      },
      {
        name: "Online Bookings Report",
        url: "/reports/online-bookings-report",
        icon: "icon-arrow-right",
        description: "Online Bookings Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 226,
        action: "read",
        resource: "Online Bookings Report",
      },
      {
        name: "Online Booking Fee Report",
        url: "/reports/online-booking-fee-report",
        icon: "icon-arrow-right",
        description: "Online Booking Fee Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 355,
        action: "read",
        resource: "Online Booking Fee Report",
      },
      {
        name: "Raw Material Supplier Wise Cost Report",
        url: "/reports/raw-material-supplier-wise-cost-report",
        icon: "icon-arrow-right",
        description: "Raw Material Supplier Wise Cost Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 227,
        action: "read",
        resource: "Raw Material Supplier Wise Cost Report",
      },
      {
        name: "FnB Sales Report",
        url: "/reports/fnb-sales-report",
        icon: "icon-arrow-right",
        description: "FnB Sales Report Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 256,
        action: "read",
        resource: "FnB Sales Report",
      },
      {
        name: "Cashier Revenue Report",
        url: "/reports/cashier-revenue-report",
        icon: "icon-arrow-right",
        description: "Cashier Revenue Report",
        keywords: ["Rdr", "rdr", "Cashier", "Revenue"],
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 217,
        action: "read",
        resource: "Cashier Revenue Report",
      },
      {
        name: "Cashier Shift Summary",
        url: "/reports/cashier-shift-summary",
        icon: "icon-arrow-right",
        description: "Cashier Shfit Summary",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 257,
        action: "read",
        resource: "Cashier Shift Summary",
      },
      {
        name: "Screenwise Occupancy Summary Report",
        url: "/reports/screenwise-occupancy-summary-report",
        icon: "icon-arrow-right",
        description: "Screenwise Occupany Summary Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 239,
        action: "read",
        resource: " Screenwise Occupancy Summary Report",
      },
      {
        name: "F&B Delivery partner sales ",
        url: "/reports/fnb-partner-sales-report",
        icon: "icon-arrow-right",
        description: "F&B Delivery partner sales ",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 258,
        action: "read",
        resource: "Fnb Delivery partner sales ",
      },
      // {
      //   name: "Movie Pass Sales Report",
      //   url: "/reports/movie-pass-sales",
      //   icon: "icon-arrow-right",
      //   description: "Movie Pass Sales Report",
      //   permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
      //   module_id: 283,
      //   action: "read",
      //   resource: "Movie Pass Sales Report",
      // },
      {
        name: "Merchandise Transactions",
        url: "/reports/merchandise-transactions",
        icon: "icon-arrow-right",
        description: "Merchandise Transactions",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 313,
        action: "read",
        only_visible_on: [
          {
            key_name: CLIENT_NAME.CINEMA_AKIL,
          },
        ],
        resource: "Merchandise",
      },
      {
        name: "FAB Offer Report",
        url: "/reports/fab-offer-report",
        icon: "icon-arrow-right",
        description: "FAB Offer Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 290,
        action: "read",
        resource: "FAB Offer Report",
      },
      {
        name: "Movie Wise Collection Report",
        url: "/reports/movie-wise-collection-report",
        icon: "icon-arrow-right",
        description: "Movie Wise Collection Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 290,
        action: "read",
        resource: "Movie Wise Collection Report",
      },
      {
        id: 6,
        name: "Daily Sales Records",
        url: "",
        icon: "",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        isCollapsed: false,
        children: [
          {
            name: "Daily Sales Records",
            url: "/reports/daily-sales-reports/dailysalesreport",
            icon: "icon-arrow-right",
            description: "daily_sales_report_dash_msg",
            permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
            module_id: 95,
            action: "read",
            resource: "Daily Sales Report",
            only_available_on: [
              {
                key_name: CLIENT_NAME.STUESSIHOF,
                url: "/reports/daily-sales-reports/daily-sales-report",
              },
              {
                key_name: CLIENT_NAME.EMPIRE,
                url: "/reports/daily-sales-reports/daily-sales-summary-report",
              },
              {
                key_name: CLIENT_NAME.LEBANON,
                url: "/reports/daily-sales-reports/daily-sales-summary-report-lebanon",
              },
              {
                key_name: CLIENT_NAME.XANADU,
                url: "/reports/daily-sales-reports/daily-sales-report",
              },
              {
                key_name: CLIENT_NAME.IRAQ,
                url: "/reports/daily-sales-reports/daily-sales-summary-report",
              },
              {
                key_name: CLIENT_NAME.BILDHAUS,
                url: "/reports/daily-sales-reports/daily-sales-summary-report",
              },
              {
                key_name: CLIENT_NAME.STAR,
                url: "/reports/daily-sales-reports/daily-sales-report-v4",
              },
              {
                key_name: CLIENT_NAME.WOW,
                url: "/reports/daily-sales-reports/daily-sales-report-v4",
              },
              {
                key_name: CLIENT_NAME.QFX,
                url: "/reports/daily-sales-reports/daily-sales-report-v4",
              },
              {
                key_name: CLIENT_NAME.EPIX,
                url: "/reports/daily-sales-reports/daily-sales-report-v4",
              },
            ],
          },
          {
            name: "aggregatorsDailySalesReport",
            url: "/reports/daily-sales-reports/aggregator-daily-sales-report",
            icon: "icon-arrow-right",
            description: "aggregator_daily_sales_report_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 100,
            action: "read",
            resource: "Aggregator Daily Sales Report",
          },
          {
            name: "Daily Sales And Collection Report",
            url: "/reports/daily-sales-reports/daily-sales-and-collection-report",
            icon: "icon-arrow-right",
            description: "Daily Sales And Collection",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            // only_visible_on: [
            //   {
            //     key_name: CLIENT_NAME.STAR,
            //   },
            // ],
            module_id: 264,
            action: "read",
            resource: "Daily Sales And Collection Report",
          },
          {
            name: "Daily Sales And Collection Report New",
            url: "/reports/daily-sales-reports/daily-sales-and-collection-report-epix",
            icon: "icon-arrow-right",
            description: "Daily Sales And Collection",
            keywords: ["daily", "sales", "collection"],
            only_visible_on: [
              {
                key_name: CLIENT_NAME.EPIX,
              },
            ],
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            // only_visible_on: [
            //   {
            //     key_name: CLIENT_NAME.STAR,
            //   },
            // ],
            module_id: 264,
            action: "read",
            resource: "Daily Sales And Collection Report New",
          },
        ],
      },
      {
        id: 6,
        name: "cinemaReport",
        url: "",
        icon: "",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        isCollapsed: false,
        children: [
          {
            name: "screencollectionreport",
            url: "/reports/cinema-reports/screen-wise-collection-report",
            icon: "icon-arrow-right",
            description: "screenwise_dash_msg",
            permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
            keywords: ["auditorium", "hall"],
            module_id: 97,
            action: "read",
            resource: "Screen Wise Collection Report",
          },
          // {
          //   name: "distributorcollectionreport",
          //   url: "/reports/cinema-reports/distributor-collection-report",
          //   icon: "icon-arrow-right",
          //   description: "distributor_collection_dash_msg",
          //   permissions: [
          //     Role.SuperAdmin,
          //     Role.CinemaManager,
          //     Role.Distributor,
          //     Role.HoManager
          //   ],
          //   module_id: 98,
          //   only_available_on: [
          //     {
          //       key_name: CLIENT_NAME.CINEMA_AKIL,
          //       url:
          //         "/reports/cinema-reports/distributor-collection-report-v3"
          //     },
          //     {
          //       key_name: CLIENT_NAME.EMPIRE,
          //       url:
          //         "/reports/cinema-reports/distributor-collection-report-v3"
          //     },
          //     {
          //       key_name: CLIENT_NAME.IRAQ,
          //       url:
          //         "/reports/cinema-reports/distributor-collection-report-v3"
          //     },
          //     {
          //       key_name: CLIENT_NAME.PETRO,
          //       url:
          //         "/reports/cinema-reports/distributor-collection-report-v3"
          //     }
          //   ]
          // },
          {
            name: "Distributor Collection Report",
            url: "/reports/cinema-reports/distributor-collection-report-v5-qfx",
            icon: "icon-arrow-right",
            description: "distributor_collection_dash_msg",
            permissions: [
              Role.SuperAdmin,
              Role.CinemaManager,
              Role.Distributor,
              Role.HoManager,
            ],
            module_id: 98,
            action: "read",
            resource: "Distributor Collection Report",
            only_available_on: [
              {
                key_name: CLIENT_NAME.CINEMA_AKIL,
                url: "/reports/cinema-reports/distributor-collection-report-v3",
              },
              {
                key_name: CLIENT_NAME.EMPIRE,
                url: "/reports/cinema-reports/distributor-collection-report-v3",
              },
              {
                key_name: CLIENT_NAME.IRAQ,
                url: "/reports/cinema-reports/distributor-collection-report-v3",
              },
              {
                key_name: CLIENT_NAME.PETRO,
                url: "/reports/cinema-reports/distributor-collection-report-v3",
              },
              {
                key_name: CLIENT_NAME.QFX,
                url: "/reports/cinema-reports/distributor-collection-report-v5-qfx",
              },
              {
                key_name: CLIENT_NAME.LEBANON,
                url: "/reports/cinema-reports/distributor-collection-report-lebanon",
              },
              {
                key_name: CLIENT_NAME.CINEPOLIS_OMAN,
                url: "/reports/cinema-reports/distributor-report-cinepolis",
              },
              {
                key_name: CLIENT_NAME.EPIX,
                url: "/reports/cinema-reports/distributor-report-epix",
              },
              {
                key_name: CLIENT_NAME.CINEPOLIS_KSA,
                url: "/reports/cinema-reports/distributor-report-cinepolis",
              },
            ],
          },
          {
            name: "distributorSummary",
            url: "/reports/cinema-reports/distributor-summary",
            icon: "icon-arrow-right",
            description: "distributor_collection_dash_msg",
            permissions: [
              Role.SuperAdmin,
              Role.CinemaManager,
              Role.Distributor,
              Role.HoManager,
            ],
            module_id: 232,
            action: "read",
            resource: "Distributor Summary",
            only_available_on: [
              {
                key_name: CLIENT_NAME.CINEMA_AKIL,
                url: "/reports/cinema-reports/distributor-summary",
              },
              {
                key_name: CLIENT_NAME.CINEPOLIS_OMAN,
                url: "/reports/cinema-reports/distributor-report-cinepolis",
              },
              {
                key_name: CLIENT_NAME.CINEPOLIS_KSA,
                url: "/reports/cinema-reports/distributor-report-cinepolis",
              },
            ],
          },

          // /*
          {
            name: "distributorDetailedSummary",
            url: "/reports/cinema-reports/distributor-detailed-report",
            icon: "icon-arrow-right",
            description: "distributor_detailed_dash_msg",
            permissions: [
              Role.SuperAdmin,
              Role.CinemaManager,
              Role.Distributor,
              Role.HoManager,
            ],
            module_id: 272,
            action: "read",
            resource: "Distributor Detailed Report",
            only_visible_on: [
              {
                key_name: CLIENT_NAME.EMPIRE,
                url: "/reports/cinema-reports/distributor-detailed-report",
              },
              {
                key_name: CLIENT_NAME.IRAQ,
                url: "/reports/cinema-reports/distributor-detailed-report",
              },
              {
                key_name: CLIENT_NAME.PLAYCINEMA,
                url: "/reports/cinema-reports/distributor-detailed-report",
              },
            ],
          },
          // */
          {
            name: "Distributor Share Summary Report",
            url: "/reports/cinema-reports/distributor-share-summary-report",
            icon: "icon-arrow-right",
            description: "Distributor Share Summary Report",
            permissions: [
              Role.SuperAdmin,
              Role.CinemaManager,
              Role.Distributor,
              Role.HoManager,
            ],
            module_id: 326,
            action: "read",
            resource: "Distributor Share Summary Report",
          },
          {
            name: "Distributor Share Summary Week Wise Report",
            url: "/reports/cinema-reports/distributor-share-summary-week-wise-report",
            icon: "icon-arrow-right",
            description: "Distributor Share Summary Week Wise Report",
            permissions: [
              Role.SuperAdmin,
              Role.CinemaManager,
              Role.Distributor,
              Role.HoManager,
            ],
            module_id: 327,
            action: "read",
            resource: "Distributor Share Summary Week Wise Report",
          },
        ],
      },
      {
        name: "transactions",
        url: "/reports/transactions",
        icon: "icon-arrow-right",
        description: "transaction_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 34,
        action: "read",
        resource: "Transactions",
      },
      {
        name: "Reservations Log",
        url: "/reports/show-reservations",
        icon: "icon-arrow-right",
        description: "reservations_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 235,
        action: "read",
        resource: "Reservations Log",
      },
      {
        name: "Report Builder",
        url: "/reports/report-builder",
        icon: "icon-arrow-right",
        description: "reportbuilder_dash_msg",
        keywords: [
          "re",
          "rep",
          "report",
          "reports builder",
          "report builder",
          "transactions",
          "report builder transactions",
          "Report",
          "builder",
          "beta",
          "reportbuilder",
          "Report Builder",
        ],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 230,
        action: "read",
        resource: "Report Builder",
      },
      {
        name: "Report Builder FnB",
        url: "/reports/report-builder-fnb",
        icon: "icon-arrow-right",
        description: "Report Builder FnB",
        keywords: ["fnb", "builder", "beta"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 231,
        action: "read",
        resource: "Report Builder FnB",
      },
      {
        name: "unpaidBooking",
        url: "/reports/unpaid-bookings",
        icon: "icon-arrow-right",
        description: "unpaid_booking_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 198,
        action: "read",
        resource: "Unpaid Booking",
      },
      {
        name: "Call Center Bookings",
        url: "/reports/call-center-bookings",
        icon: "icon-arrow-right",
        description: "Call center bookings list",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 353,
        action: "read",
        resource: "Call Center Bookings",
      },
      {
        name: "Refund Analysis Report",
        // url: "/reports/transaction-refund-report",
        url: "/reports/transactions-refund-report",
        icon: "icon-arrow-right",
        description: "transaction_refund_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 27,
        action: "read",
        resource: "Refund Analysis Report",
      },
      {
        name: "Ticket Invoices",
        url: "/reports/ticket-invoices-report",
        icon: "icon-arrow-right",
        description: "Ticket Invoices",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 331,
        action: "read",
        resource: "Ticket Invoices",
      },
      {
        name: "Screens tax & vat overall Report",
        url: "/reports/screen-tax-vat-overall-report",
        icon: "icon-arrow-right",
        description: "Screens tax & vat overall Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 332,
        action: "read",
        resource: "Screens tax & vat overall Report",
      },
      {
        name: "Ticket Reprint Report",
        url: "/reports/ticket-reprint-report",
        icon: "icon-arrow-right",
        description: "Ticket Reprint Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 335,
        action: "read",
        resource: "Ticket Reprint Report",
      },
      {
        name: "Cinema Tax Overall Analysis Report",
        url: "/reports/cinema-tax-overall-analsysis-report",
        icon: "icon-arrow-right",
        description: "Cinema Tax Overall Analysis Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 333,
        action: "read",
        resource: "Cinema Tax Overall Analysis Report",
      },
             {
        name: "Distributor Share Report New",
        url: "/reports/distributor-share-report-new",
        icon: "icon-arrow-right",
        description: "Distributor Share Report New",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 333,
        action: "read",
        resource: "Distributor Share Report New",
      },
      {
        name: "Cinema Tax Screen Analysis Report",
        url: "/reports/cinema-tax-screen-analsysis-report",
        icon: "icon-arrow-right",
        description: "Cinema Tax Screen Analysis Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 336,
        action: "read",
        resource: "Cinema Tax Screen Analysis Report",
      },
      {
        name: "Cashier Settlement Report",
        url: "/reports/cashier-settlement-report",
        icon: "icon-arrow-right",
        description: "Cashier Settlement Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 338,
        action: "read",
        resource: "Cashier Settlement Report",
      },
      {
        name: "Cashier Analysis Report",
        url: "/reports/cashier-analysis-report",
        icon: "icon-arrow-right",
        description: "Cashier Analysis Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 338,
        action: "read",
        resource: "Cashier Analysis Report",
      },
      {
        name: "Swap and Transaction Refund Report",
        url: "/reports/swap-transaction-refund-report",
        icon: "icon-arrow-right",
        description: "Swap and transaction_refund_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 240,
        action: "read",
        resource: "Swap and Refund Transactions Report",
      },
      {
        name: "swapTransactions",
        url: "/reports/swap-transaction",
        icon: "icon-arrow-right",
        description: "swap_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 185,
        action: "read",
        resource: "Swap Transactions",
      },
      {
        name: "Staff Performance Report",
        url: "/reports/staff-performance-report",
        icon: "icon-arrow-right",
        description: "Staff Performance Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 302,
        action: "read",
        resource: "Staff Performance Report",
      },
      // {
      //   name: "F&B Sales Analysis Report",
      //   url: "/reports/fnb-sales-analysis-report",
      //   icon: "icon-arrow-right",
      //   description: "F&B Sales Analysis Report",
      //   permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
      //   module_id: 303,
      //   action: "read",
      //   resource: "F&B Sales Analysis Report",
      // },
      {
        name: "Offers-Vouchers Consumption Summary Report",
        url: "/reports/get-offers-vouchers-consumption-summary-report",
        icon: "icon-arrow-right",
        description: "Offers-Vouchers Consumption Summary Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 290,
        action: "read",
        resource: "Offers-Vouchers Consumption Summary Report",
      },
      // {
      //   name: "Get DCR And Performance Report",
      //   url: "/reports/getDCRPerformanceReport",
      //   icon: "icon-arrow-right",
      //   description: "Get DCR And Performance Report",
      //   permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
      //   module_id: 303,
      //   action: "read",
      //   resource: "Get DCR And Performance Report",
      // },
      {
        name: "DCR And Performance Report",
        url: "/reports/dcr-performance-report",
        icon: "icon-arrow-right",
        description: "DCR And Performance Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 290,
        action: "read",
        resource: "DCR And Performance Report",
      },
      {
        name: "Class Wise Seat Summary Report",
        url: "/reports/seat-classwise-sales-summary",
        icon: "icon-arrow-right",
        description: "Class Wise Seat Summary Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 290,
        action: "read",
        resource: "Class Wise Seat Summary Report",
      },
      {
        name: "Movie Wise Summary Report",
        url: "/reports/movie-wise-summary-report",
        icon: "icon-arrow-right",
        description: "Movie Wise Summary Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 290,
        action: "read",
        resource: "Movie Wise Summary Report",
      },
      {
        name: "Online & Offline Transaction Report",
        url: "/reports/online-offline-transactions-report",
        icon: "icon-arrow-right",
        description: "Online & Offline Transaction Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 288,
        action: "read",
        resource: "Online & Offline Transaction Report",
      },
      {
        name: "Concesion Item Wise Transfer Report",
        url: "/reports/material-transfer-as-per-store",
        icon: "icon-arrow-right",
        description: "Concesion Item Wise Transfer Report",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        module_id: 354,
        action: "read",
        resource: "Concesion Item Wise Transfer Report",
      },
      {
        id: 6,
        name: "movieReports",
        url: "",
        icon: "",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        isCollapsed: false,
        children: [
          {
            name: "movieanalytics",
            url: "/reports/movie-reports/movie-analytics",
            icon: "icon-arrow-right",
            description: "movie_analytics_dash_msg",
            permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
            module_id: 132,
            action: "read",
            resource: "Movie Analytics Report",
          },
          // {
          //   name: "filmwisecollectionreport",
          //   url: "/reports/movie-reports/film-wise-collection-report-v2",
          //   icon: "icon-arrow-right",
          //   description: "film_wise_collection_report_dash_msg",
          //   permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
          //   module_id: 96,
          //   action: "read",
          //   resource: "Film Wise Collection Report",
          //   only_available_on: [
          //     {
          //       key_name: CLIENT_NAME.CINEMA_AKIL,
          //       url: "/reports/movie-reports/film-wise-collection-report",
          //     },
          //   ],
          // },
          // {
          //   name: "Online Aggregators Transaction Report",
          //   url: "/reports/movie-reports/aggregators-report",
          //   icon: "icon-arrow-right",
          //   description: "aggregators_report_dash_msg",
          //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
          //   module_id: 99,
          //   action: "read",
          //   resource: "Aggregators Transactions Report",
          // },
          {
            name: "advancebookingreport",
            url: "/reports/movie-reports/advance-booking-report",
            icon: "icon-arrow-right",
            description: "advancebookingreport_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 108,
            action: "read",
            resource: "Advance Booking Report",
          },
        ],
      },
      {
        id: 6,
        name: "fandbReports",
        url: "",
        icon: "",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        isCollapsed: false,
        children: [
          {
            name: "fandbAnalytics",
            url: "/reports/fnb-reports/fnb-analytics",
            icon: "icon-arrow-right",
            description: "FandsBAnalytics_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 130,
            action: "read",
            resource: "F&B Analytics",
          },
          {
            name: "F&B Category Analytics",
            url: "/reports/fnb-reports/fnb-category-analytics",
            icon: "icon-arrow-right",
            description: "FandsBAnalyticsCategory_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 130,
            action: "read",
            resource: "F&B Analytics",
            only_visible_on: [
              {
                key_name: CLIENT_NAME.STAR,
              },
              {
                key_name: CLIENT_NAME.WOW,
              },
            ],
          },
          {
            name: "Fnbtransactions",
            url: "/reports/fnb-reports/fnb-transactions",
            icon: "icon-arrow-right",
            description: "Fnbtransaction_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 162,
            action: "read",
            resource: "F&B Transactions",
          },
          {
            name: "F&B App orders",
            url: "/reports/fnb-reports/fnb-orders",
            icon: "icon-arrow-right",
            description: "Fnborders_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 163,
            action: "read",
            resource: "F&B App Orders",
          },
          {
            name: "Recipe Report",
            url: "/reports/fnb-reports/recipe-report",
            icon: "icon-arrow-right",
            description: "receipereport_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 101,
            action: "read",
            resource: "Receipe Report",
          },
          // {
          //   name: "fastmovingreport",
          //   url: "/reports/fnb-reports/fast-moving-report",
          //   icon: "icon-arrow-right",
          //   description: "fastmovingreport_dash_msg",
          //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
          //   module_id: 102,
          //   action: "read",
          //   resource: "Fast Moving Report",
          // },
          {
            name: "concessiondailyReport",
            url: "/reports/fnb-reports/concession-daily-report",
            icon: "icon-arrow-right",
            description: "concessiondailyReport_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 103,
            action: "read",
            resource: "Concession Daily Report",
          },
          // {
          //   name: "cogsReport",
          //   url: "/reports/fnb-reports/cogs-report",
          //   icon: "icon-arrow-right",
          //   description: "cogsReport_dash_msg",
          //   permissions: [
          //     Role.SuperAdmin,
          //     Role.HoManager,
          //     Role.CinemaManager,
          //   ],
          //   module_id: 104,
          //   action: "read",
          //   resource: "COGS Report",
          // },
          {
            name: "COGS Report",
            url: "/reports/fnb-reports/cogs-report-v2",
            icon: "icon-arrow-right",
            description: "cogsReport_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 104,
            action: "read",
            resource: "COGS Report",
          },
          {
            name: "Food Cost Report",
            url: "/reports/fnb-reports/food-cost-report",
            icon: "icon-arrow-right",
            description: "food Cost",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 300,
            action: "read",
            resource: "Food Cost Report",
          },
          {
            name: "Cash Drawer - Manual Opening Logs",
            url: "/reports/cash-drawer-logs-report",
            icon: "icon-arrow-right",
            description: "Cahs Drower Logs Report",
            permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
            module_id: 304,
            action: "read",
            resource: "Cahs Drower Logs Report",
          },
          {
            name: "stockwastageReport",
            url: "/reports/fnb-reports/stock-wastage-report",
            icon: "icon-arrow-right",
            description: "stockwastageReport_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 105,
            action: "read",
            resource: "Stock Wastage Report",
          },
          {
            name: "currentStockReport",
            url: "/reports/fnb-reports/current-stock-report",
            icon: "icon-arrow-right",
            description: "currentStockReport_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 106,
            action: "read",
            resource: "Current Stock Report",
          },
          {
            name: "Payment Typeswise Sales Report",
            url: "/reports/fnb-reports/municipality-report",
            icon: "icon-arrow-right",
            description: "municipalityReport_dash_msg",
            keywords: ["typewise sales report"],
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 107,
            action: "read",
            resource: "Payment Typeswise Sales Report",
          },
          {
            name: "expiryreport",
            url: "/reports/fnb-reports/expiry-report",
            icon: "icon-arrow-right",
            description: "expiryreport_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 137,
            action: "read",
            resource: "Expiry Report",
          },
          {
            name: "addonsreport",
            url: "/reports/fnb-reports/add-ons-report",
            icon: "icon-arrow-right",
            description: "addonsreport_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 177,
            action: "read",
            resource: "Add Ons Report",
          },
          {
            name: "customizationreport",
            url: "/reports/fnb-reports/customization-report",
            icon: "icon-arrow-right",
            description: "customizationreport_dash_msg",
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 179,
            action: "read",
            resource: "Customization Report",
          },
          {
            name: "Ticket Report",
            url: "/reports/ticket-report",
            icon: "icon-arrow-right",
            description: "Ticket Report",
            permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
            module_id: 348,
            action: "read",
            resource: "Ticket Report",
          },
          {
            name: "Movie Overall Analysis Report",
            url: "/reports/movie-overall-analysis-report",
            icon: "icon-arrow-right",
            description: "Movie Overall Analysis Report",
            permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
            module_id: 342,
            action: "read",
            resource: "Movie Overall Analysis Report",
          },
          {
            name: "Fnb Sales Revenue Per Item",
            url: "/reports/fnb-sales-revenue-per-item",
            icon: "icon-arrow-right",
            description: "Movie Overall Analysis Report",
            permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
            module_id: 350,
            action: "read",
            resource: "Fnb Sales Revenue Per Item",
          },
          {
            name: "Remaning Item Per Concesion",
            url: "/reports/remaning-item-per-concession",
            icon: "icon-arrow-right",
            description: "Movie Overall Analysis Report",
            permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
            module_id: 349,
            action: "read",
            resource: "Remaning Item Per Concesion",
          },
        ],
      },
    ],
  },

  {
    id: 7,
    name: "marketing",
    url: "/marketing-master",
    icon: "icon-marketing",
    permissions: [],
    isCollapsed: false,
    children: [
      // {
      //   name: "E-Wallet",
      //   url: "/marketing/e-wallet",
      //   icon: "icon-arrow-right",
      //   description: "eWallet_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 243,
      //   action: "read",
      //   resource: "E-Wallet",
      // },
      // {
      //   name: "movie_pass",
      //   url: "/cinema-manager/movie-pass",
      //   icon: "icon-arrow-right",
      //   description: "ratecardgroup_dash_msg",
      //   keywords: ["Movie", "Pass", "Gift", "Card", "Membership"],
      //   permissions: [
      //     Role.SuperAdmin,
      //     Role.HoManager,
      //     Role.CinemaManager,
      //   ],
      //   module_id: 282,
      //   action: "read",
      //   resource: "Movie Pass",
      // },
      // {
      //   name: "Merchandise",
      //   keywords: ["Merchandise", "tshi"],
      //   url: "/cinema-manager/merchandise",
      //   icon: "icon-arrow-right",
      //   description: "checklists_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 313,
      //   action: "read",
      //   only_visible_on: [
      //     {
      //       key_name: CLIENT_NAME.CINEMA_AKIL,
      //     },
      //     {
      //       key_name: CLIENT_NAME.STAR,
      //     },
      //   ],
      //   resource: "Merchandise",
      // },
      // {
      //   name: "Cash Cards",
      //   url: "/marketing/cash-cards",
      //   icon: "icon-arrow-right",
      //   description: "cashcards_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 159,
      //   action: "read",
      //   resource: "Cash Cards",
      // },
      // {
      //   name: "Cash Card Gallery",
      //   url: "/marketing/list-cash-cards-gallery",
      //   icon: "icon-arrow-right",
      //   description: "cashcards_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 228,
      //   action: "read",
      //   resource: "Cash Card Gallery",
      // },
      {
        id: 7,
        name: "Courtsey",
        url: "",
        icon: "icon-arrow-right",
        permissions: [Role.SuperAdmin, Role.CinemaManager, Role.HoManager],
        isCollapsed: false,
        children: [
          {
            name: "Courtsey Users",
            url: "/marketing/courtsey-users",
            icon: "icon-arrow-right",
            description: "Fnb Courtsey Report",
            keywords: ["courtsey", "Courstey", "fnb", "Report"],
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 343,
            action: "read",
            resource: "Fnb Courtsey Report",
          },
          {
            name: "Courtsey Groups",
            url: "/marketing/courtsey-groups",
            icon: "icon-arrow-right",
            description: "Fnb Courtsey Report",
            keywords: ["courtsey", "Courstey", "fnb", "Report"],
            permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
            module_id: 343,
            action: "read",
            resource: "Fnb Courtsey Report",
          },
        ],
      },
      // {
      //   name: "CMS Pages",
      //   url: "/marketing/list-pages",
      //   icon: "icon-arrow-right",
      //   description: "pages_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 229,
      //   action: "read",
      //   resource: "CMS Pages",
      // },
      {
        name: "Offer Group Type",
        url: "/marketing/offer-group-type",
        icon: "icon-arrow-right",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        description: "Grouping for offers",
        module_id: 296,
        action: "read",
        resource: "Offer Group Type",
      },
      {
        name: "Promotions & Offers",
        url: "/marketing/promotions-and-offers",
        icon: "icon-arrow-right",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        description: "promotionsandoffer_dash_msg",
        module_id: 109,
        action: "read",
        resource: "Promotions & Offers",
      },
      // {
      //   name: "voucher",
      //   url: "/marketing/vouchers",
      //   icon: "icon-arrow-right",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   description: "voucher_dash_msg",
      //   module_id: 110,
      //   action: "read",
      //   resource: "Vouchers",
      // },
      {
        name: "Vouchers",
        url: "/vouchers/get-vouchers-v2",
        icon: "icon-arrow-right",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        description: "voucher_dash_msg",
        module_id: 110,
        action: "read",
        resource: "Vouchers",
      },
      {
        name: "Customer Loyalty Points",
        url: "/marketing/customer-loyalty-points",
        icon: "icon-arrow-right",
        description: "customerloyaltypoints_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 112,
        action: "read",
        resource: "Customer Loyalty Points",
      },
      // {
      //   name: "Loyalty Logs",
      //   url: "/marketing/loyalty-logs",
      //   icon: "icon-arrow-right",
      //   description: "Upp Loyalty Logs",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 297,
      //   action: "read",
      //   resource: "Loyalty Logs",
      // },
      {
        name: "Global Loyalty Settings",
        url: "/marketing/global-loyalty-settings",
        icon: "icon-arrow-right",
        description: "globalloyaltysettings_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 113,
        action: "read",
        resource: "Global Loyalty Settings",
      },
      {
        name: "Cinema Loyalty Settings",
        url: "/marketing/cinema-loyalty-settings",
        icon: "icon-arrow-right",
        description: "cinemaloyaltysetting_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 114,
        action: "read",
        resource: "Cinema Loyalty Settings",
      },
      // {
      //   name: "Loyalty",
      //   url: "/marketing/loyalty",
      //   icon: "icon-arrow-right",
      //   description: "Loyalty",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 111,
      //   action: "read",
      //   resource: "Loyalty",
      // },
      {
        name: "Bank",
        url: "/marketing/bank",
        icon: "icon-arrow-right",
        description: "bank_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 115,
        action: "read",
        resource: "Bank",
      },
      // {
      //   name: "institution",
      //   url: "/marketing/institution",
      //   icon: "icon-arrow-right",
      //   description: "institution_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 116,
      //   action: "read",
      //   resource: "Institution",
      // },
      {
        name: "Offer Types",
        url: "/marketing/offer-types",
        icon: "icon-arrow-right",
        description: "offertypes_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 117,
        action: "read",
        resource: "Offer Types",
      },
      {
        name: "Bin Numbers",
        url: "/marketing/bin-Numbers",
        icon: "icon-arrow-right",
        description: "binnumbers_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 118,
        action: "read",
        resource: "Bin Numbers",
      },
      {
        name: "customer",
        url: "/marketing/customers",
        icon: "icon-arrow-right",
        description: "customer_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 119,
        action: "read",
        resource: "customer",
      },
      {
        name: "Card Type",
        url: "/marketing/card-type",
        icon: "icon-arrow-right",
        description: "cardtype_dash_msg",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 120,
        action: "read",
        resource: "Card Type",
      },
      // {
      //   name: "referral-code",
      //   url: "/master/referral-code",
      //   icon: "icon-arrow-right",
      //   description: "referralCode_dash_msg",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 194,
      //   action: "read",
      //   resource: "Referral",
      // },
      // {
      //   name: "Merchandise Vouchers",
      //   url: "/vouchers/get-vouchers-merch",
      //   icon: "icon-arrow-right",
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   description: "voucher_dash_msg",
      //   module_id: 313,
      //   action: "read",
      //   resource: "Vouchers",
      //   only_visible_on: [
      //     {
      //       key_name: CLIENT_NAME.CINEMA_AKIL,
      //     },
      //   ],
      // },
      {
        name: "Customers Verification",
        url: "/marketing/customers_verification",
        icon: "icon-arrow-right",
        description: "customers_verification",
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 322,
        action: "read",
        resource: "customers_verification",
      },
    ],
  },
  {
    id: 14,
    name: "List of Pages",
    url: "/pages",
    icon: "icon-marketing",
    permissions: [],
    isCollapsed: false,
    only_visible_on: [
      {
        key_name: CLIENT_NAME.EMPIRE,
      },
      {
        key_name: CLIENT_NAME.IRAQ,
      },
      {
        key_name: CLIENT_NAME.BILDHAUS,
      },
      {
        key_name: CLIENT_NAME.STAR,
      },
      {
        key_name: CLIENT_NAME.WOW,
      },
      {
        key_name: CLIENT_NAME.CINEMA_AKIL,
      },
    ],
    children: [
      {
        name: "View List Of Pages",
        url: "/pages/view-list-of-pages",
        icon: "icon-arrow-right",
        description: "View List of Pages",
        keywords: ["view list of pages"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 208,
        action: "read",
        resource: "View List of Pages",
        only_available_on: [
          {
            key_name: CLIENT_NAME.EMPIRE,
            url: "/pages/view-list-of-pages",
          },
          {
            key_name: CLIENT_NAME.IRAQ,
            url: "/pages/view-list-of-pages",
          },
          {
            key_name: CLIENT_NAME.BILDHAUS,
            url: "/pages/view-list-of-pages",
          },
          {
            key_name: CLIENT_NAME.STAR,
            url: "/pages/view-list-of-pages",
          },
          {
            key_name: CLIENT_NAME.WOW,
            url: "/pages/view-list-of-pages",
          },
          {
            key_name: CLIENT_NAME.CINEMA_AKIL,
            url: "/pages/view-list-of-pages",
          },
        ],
      },
      {
        name: "List Of Pages",
        url: "/pages/list-of-pages",
        icon: "icon-arrow-right",
        description: "List of Pages",
        keywords: ["add list of pages"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 207,
        action: "read",
        resource: "List Of Pages",
        only_available_on: [
          {
            key_name: CLIENT_NAME.EMPIRE,
            url: "/pages/list-of-pages",
          },
          {
            key_name: CLIENT_NAME.IRAQ,
            url: "/pages/list-of-pages",
          },
          {
            key_name: CLIENT_NAME.BILDHAUS,
            url: "/pages/list-of-pages",
          },
          {
            key_name: CLIENT_NAME.STAR,
            url: "/pages/list-of-pages",
          },
          {
            key_name: CLIENT_NAME.WOW,
            url: "/pages/list-of-pages",
          },
          {
            key_name: CLIENT_NAME.CINEMA_AKIL,
            url: "/pages/list-of-pages",
          },
        ],
      },
    ],
  },
  {
    id: 15,
    name: "Pop Up Pages",
    url: "/pop-up-pages",
    icon: "icon-marketing",
    permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
    isCollapsed: false,

    only_visible_on: [
      {
        key_name: CLIENT_NAME.EMPIRE,
      },
      {
        key_name: CLIENT_NAME.IRAQ,
      },
      {
        key_name: CLIENT_NAME.STAR,
      },
      {
        key_name: CLIENT_NAME.WOW,
      },
      {
        key_name: CLIENT_NAME.BILDHAUS,
      },
      {
        key_name: CLIENT_NAME.CINEMA_AKIL,
      },
    ],
    only_available_on: [
      {
        key_name: CLIENT_NAME.EMPIRE,
        url: "/pop-up-pages/get-popup-pages",
      },
      {
        key_name: CLIENT_NAME.IRAQ,
        url: "/pop-up-pages/get-popup-pages",
      },
      {
        key_name: CLIENT_NAME.BILDHAUS,
        url: "/pop-up-pages/get-popup-pages",
      },
      {
        key_name: CLIENT_NAME.STAR,
        url: "/pop-up-pages/get-popup-pages",
      },
      {
        key_name: CLIENT_NAME.WOW,
        url: "/pop-up-pages/get-popup-pages",
      },
      {
        key_name: CLIENT_NAME.CINEMA_AKIL,
        url: "/pop-up-pages/get-popup-pages",
      },
    ],
    children: [
      {
        name: "Add Pop Up Pages",
        url: "/pop-up-pages/add-popup-page",
        icon: "icon-arrow-right",
        description: "Pop Up pages",
        keywords: ["add list of pop up pages"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 209,
        action: "read",
        resource: "Add Pop Up Pages",
        only_available_on: [
          {
            key_name: CLIENT_NAME.EMPIRE,
            url: "/pop-up-pages/add-popup-page",
          },
          {
            key_name: CLIENT_NAME.IRAQ,
            url: "/pop-up-pages/add-popup-page",
          },
          {
            key_name: CLIENT_NAME.BILDHAUS,
            url: "/pop-up-pages/add-popup-page",
          },
          {
            key_name: CLIENT_NAME.STAR,
            url: "/pop-up-pages/add-popup-page",
          },
          {
            key_name: CLIENT_NAME.WOW,
            url: "/pop-up-pages/add-popup-page",
          },
          {
            key_name: CLIENT_NAME.CINEMA_AKIL,
            url: "/pop-up-pages/add-popup-page",
          },
        ],
      },
      {
        name: "View Pop Up Pages",
        url: "/pop-up-pages/get-popup-pages",
        icon: "icon-arrow-right",
        description: "Pop Up pages",
        keywords: ["get list of pop up pages"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 210,
        action: "read",
        resource: "View Pop Up Pages",
        only_available_on: [
          {
            key_name: CLIENT_NAME.EMPIRE,
            url: "/pop-up-pages/get-popup-pages",
          },
          {
            key_name: CLIENT_NAME.IRAQ,
            url: "/pop-up-pages/get-popup-pages",
          },
          {
            key_name: CLIENT_NAME.BILDHAUS,
            url: "/pop-up-pages/get-popup-pages",
          },
          {
            key_name: CLIENT_NAME.STAR,
            url: "/pop-up-pages/get-popup-pages",
          },
          {
            key_name: CLIENT_NAME.WOW,
            url: "/pop-up-pages/get-popup-pages",
          },
          {
            key_name: CLIENT_NAME.CINEMA_AKIL,
            url: "/pop-up-pages/get-popup-pages",
          },
        ],
      },
    ],
  },
  {
    id: 16,
    name: "Qr Code",
    url: "/qr-code",
    icon: "icon-marketing",
    permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
    isCollapsed: false,

    only_visible_on: [
      {
        key_name: CLIENT_NAME.EMPIRE,
      },
      {
        key_name: CLIENT_NAME.IRAQ,
      },
      {
        key_name: CLIENT_NAME.BILDHAUS,
      },
      {
        key_name: CLIENT_NAME.STAR,
      },
      {
        key_name: CLIENT_NAME.WOW,
      },
      {
        key_name: CLIENT_NAME.CINEMA_AKIL,
      },
    ],

    children: [
      {
        name: "QR Code List",
        url: "/qr-code/list-qr-codes",
        icon: "icon-arrow-right",
        description: "qr code pages",
        keywords: ["qr code"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 211,
        action: "read",
        resource: "QR Code List",
        only_available_on: [
          {
            key_name: CLIENT_NAME.EMPIRE,
            url: "/qr-code/list-qr-codes",
          },
          {
            key_name: CLIENT_NAME.IRAQ,
            url: "/qr-code/list-qr-codes",
          },
          {
            key_name: CLIENT_NAME.BILDHAUS,
            url: "/qr-code/list-qr-codes",
          },
          {
            key_name: CLIENT_NAME.STAR,
            url: "/qr-code/list-qr-codes",
          },
          {
            key_name: CLIENT_NAME.WOW,
            url: "/qr-code/list-qr-codes",
          },
          {
            key_name: CLIENT_NAME.CINEMA_AKIL,
            url: "/qr-code/list-qr-codes",
          },
        ],
      },
    ],
  },
  {
    id: 18,
    name: "Data Sync",
    url: "/comscore-logs",
    icon: "icon-marketing",
    permissions: [],
    isCollapsed: false,
    only_visible_on: [
      {
        key_name: CLIENT_NAME.EMPIRE,
      },
      {
        key_name: CLIENT_NAME.IRAQ,
      },
      {
        key_name: CLIENT_NAME.BILDHAUS,
      },
      {
        key_name: CLIENT_NAME.STAR,
      },
      {
        key_name: CLIENT_NAME.WOW,
      },
      {
        key_name: CLIENT_NAME.CINEMA_AKIL,
      },
    ],

    children: [
      {
        name: CLIENT_NAME.STAR ? "Comscore Logs" : "Gcam Logs",
        url: "/reports/comscore-logs",
        icon: "icon-arrow-right",
        description: "macsettings_dash_msg",
        keywords: ["gcam logs"],
        permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
        module_id: 277,
        action: "read",
        resource: "Comscore Logs",
      },
      // {
      //   name: "Numero Report",
      //   url: "/reports/numero-report",
      //   icon: "icon-arrow-right",
      //   description: "Numero Data",
      //   keywords: ["gcam logs"],
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 314,
      //   action: "read",
      //   resource: "Numero Report",
      // },
      // {
      //   name: "Loyalty Logs",
      //   url: "/marketing/loyalty-logs",
      //   icon: "icon-arrow-right",
      //   description: "Loyalty Logs",
      //   keywords: ["gcam logs"],
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      //   module_id: 314,
      //   action: "read",
      //   resource: "Numero Report",
      // },
    ],
  },
];

export default {
  items: process.env["CINEMA_SOURCE"] ? localNavItems : cloudNavItems,
};



// WEBPACK FOOTER //
// ./src/NavHybrid.js